const customSpanImageFrames = {"70":"data:image/webp;base64,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","80":"data:image/webp;base64,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","90":"data:image/webp;base64,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","100":"data:image/webp;base64,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","110":"data:image/webp;base64,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","120":"data:image/webp;base64,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","130":"data:image/webp;base64,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","150":"data:image/webp;base64,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"};
const customSpanFrameLengths = Object.keys(customSpanImageFrames).map(Number).sort((a, b) => a - b);
const defaultFurnitureProducts = [
  {
    id: "sofa",
    name: "沙發",
    width: 200,
    height: 90,
    art: "sofa",
  },
  {
    id: "dining-table",
    name: "餐桌",
    width: 160,
    height: 80,
    art: "dining-table",
  },
  {
    id: "tv",
    name: "電視",
    width: 140,
    height: 80,
    art: "tv",
  },
  {
    id: "tv-console",
    name: "電視櫃",
    width: 180,
    height: 45,
    art: "tv-console",
  },
  {
    id: "cabinet",
    name: "櫥櫃",
    width: 90,
    height: 200,
    art: "cabinet",
  },
  {
    id: "chair",
    name: "椅子",
    width: 45,
    height: 85,
    art: "chair",
  },
  {
    id: "stool",
    name: "凳子",
    width: 35,
    height: 45,
    art: "stool",
  },
  {
    id: "frame",
    name: "畫框",
    width: 60,
    height: 80,
    art: "frame",
  },
  {
    id: "outlet",
    name: "插座面板",
    width: 12,
    height: 12,
    art: "outlet",
  },
];

const furnitureDatabaseKey = "wall-planner-furniture-database-v1";
const furnitureDatabaseVersionKey = "wall-planner-furniture-database-version";
const furnitureDatabaseVersion = "2026-05-23-simple-furniture-vector-set";
const furnitureArts = ["sofa", "dining-table", "tv", "tv-console", "cabinet", "chair", "stool", "frame", "outlet"];
let products = loadFurnitureProducts();
const productDimensionMax = 2000;
const gridCellCm = 30;
const shapeObjectId = "shape-object";
const shapeObjectCount = 5;
const shapeObjectImage = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' preserveAspectRatio='none'%3E%3Crect width='512' height='512' fill='%23969696'/%3E%3C/svg%3E";

const themeAssetBaseUrl = window.IWP_CONFIG?.assetBaseUrl || "";
function themeAssetUrl(filename) {
  const clean = String(filename || "").trim();

  if (!clean) {
    return "";
  }

  if (/^(https?:)?\/\//.test(clean) || clean.startsWith("data:")) {
    return clean;
  }

  const assetName = clean.replace(/^assets\//, "");
  const base = String(themeAssetBaseUrl || "");
  const queryIndex = base.indexOf("?");
  const basePath = queryIndex >= 0 ? base.slice(0, queryIndex) : base;
  const query = queryIndex >= 0 ? base.slice(queryIndex) : "";
  const slashIndex = basePath.lastIndexOf("/");
  const assetDirectory = slashIndex >= 0 ? basePath.slice(0, slashIndex + 1) : "/assets/";

  return assetDirectory + encodeURIComponent(assetName).replace(/%2F/g, "/") + query;
}
const defaultFixedProducts = [
  {
      id: "gamma",
      name: "Gamma",
      width: 40,
      height: 40,
      sortOrder: 1,
      price: 24500,
      category: "large",
      colors: ["light-wood", "dark-wood", "black", "white"],
      colorImages: {
        "light-wood": themeAssetUrl("Gamma N-cutout.png"),
        "dark-wood": themeAssetUrl("Gamma Walnut-cutout.png"),
        "black": themeAssetUrl("Gamma B-cutout.png"),
        "white": themeAssetUrl("Gamma W-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "40670514249893", right: "40670514380965" },
        "dark-wood": { left: "40670514282661", right: "40670514413733" },
        "black": { left: "40670514348197", right: "40670514479269" },
        "white": { left: "40670514315429", right: "40670514446501" },
      },
      colorVariantPrices: {"light-wood": 24500, "dark-wood": 24500, "black": 24500, "white": 24500},
      image: themeAssetUrl("Gamma-cutout.png"),
      flippable: true,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "busycat",
      name: "Busycat",
      width: 50,
      height: 43.3,
      sortOrder: 2,
      price: 20000,
      category: "large",
      colors: ["light-wood", "black", "white"],
      colorImages: {
        "light-wood": themeAssetUrl("Busycat N-cutout.png"),
        "black": themeAssetUrl("Busycat B-cutout.png"),
        "white": themeAssetUrl("Busycat W-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "31589861261444" },
        "black": { left: "31589859524740" },
        "white": { left: "31589862441092" },
      },
      colorVariantPrices: {"light-wood": 20000, "black": 20000, "white": 20000},
      image: themeAssetUrl("Busycat N-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "luna",
      name: "Luna",
      width: 97.7,
      height: 83.8,
      sortOrder: 3,
      price: 43980,
      category: "large",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("Luna N-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "31589856051332", right: "31589856051332" },
      },
      colorVariantPrices: {"light-wood": 43980},
      image: themeAssetUrl("Luna N-cutout.png"),
      flippable: true,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "busycat-cover",
      name: "Busycat Cover",
      width: 45,
      height: 39.3,
      sortOrder: 4,
      price: 6300,
      category: "large",
      colors: ["light-wood", "white"],
      colorImages: {
        "light-wood": themeAssetUrl("Cover N-cutout.png"),
        "white": themeAssetUrl("Cover W-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "40700855845029" },
        "white": { left: "40700855877797" },
      },
      colorVariantPrices: {"light-wood": 6300, "white": 6300},
      image: themeAssetUrl("Cover N-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "busycat-wave-cover",
      name: "Busy Cat Cover Wave",
      width: 45,
      height: 39.3,
      sortOrder: 5,
      price: 8250,
      category: "large",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("Wave N-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "42403523035301" },
      },
      colorVariantPrices: {"light-wood": 8250},
      image: themeAssetUrl("Wave N-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "busycat-rattan-cover",
      name: "Busy Cat Cover Rattan",
      width: 45,
      height: 39.3,
      sortOrder: 6,
      price: 13180,
      category: "large",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("Bamboo N-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "42410877157541" },
      },
      colorVariantPrices: {"light-wood": 13180},
      image: themeAssetUrl("Bamboo N-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "z-step",
      name: "Z Step",
      width: 74.6,
      height: 32,
      sortOrder: 9999,
      price: 16150,
      category: "large",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("ZoneLeft N-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "31589928894596", right: "31589928927364" },
      },
      colorVariantPrices: {"light-wood": 16150},
      image: themeAssetUrl("ZoneLeft N-cutout.png"),
      flippable: true,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "lack-r",
      name: "Lack R",
      width: 30,
      height: 12.4,
      sortOrder: 9999,
      price: 11750,
      category: "small",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("LackR N-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "31589867782276" },
      },
      colorVariantPrices: {"light-wood": 11750},
      image: themeAssetUrl("LackR N-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: true,
      visible: true,
      resizable: false,
    },
  {
      id: "lack-r clear",
      name: "Lack R clear",
      width: 30,
      height: 12.4,
      sortOrder: 9999,
      price: 8500,
      category: "small",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("LackC N-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "31973410373764" },
      },
      colorVariantPrices: {"light-wood": 8500},
      image: themeAssetUrl("LackC N-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "alpha",
      name: "Alpha",
      width: 66,
      height: 41,
      sortOrder: 9999,
      price: 30350,
      category: "floor",
      colors: ["light-wood"],
      colorImages: {
      },
      colorVariantIds: {
        "light-wood": { left: "31589898911876" },
      },
      colorVariantPrices: {"light-wood": 30350},
      image: themeAssetUrl("Alpha-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "aura",
      name: "Aura",
      width: 57,
      height: 12.5,
      sortOrder: 9999,
      price: 25750,
      category: "large",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("Aura N-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "45808639180965" },
      },
      colorVariantPrices: {"light-wood": 25750},
      image: themeAssetUrl("Aura N-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "avenue-60",
      name: "Avenue M",
      width: 60,
      height: 40,
      sortOrder: 9999,
      price: 11900,
      category: "large",
      colors: ["dark-wood", "black", "white"],
      colorImages: {
        "dark-wood": themeAssetUrl("Avenue 60Walnut-cutout.png"),
        "black": themeAssetUrl("Avenue 60B-cutout.png"),
        "white": themeAssetUrl("Avenue 60W-cutout.png"),
      },
      colorVariantIds: {
        "dark-wood": { left: "41260071518373" },
        "black": { left: "41273059475621" },
        "white": { left: "41273059508389" },
      },
      colorVariantPrices: {"dark-wood": 11900, "black": 11900, "white": 11900},
      image: themeAssetUrl("Avenue 60W-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "avenue-100",
      name: "Avenue L",
      width: 100,
      height: 40,
      sortOrder: 9999,
      price: 13500,
      category: "large",
      colors: ["dark-wood", "black", "white"],
      colorImages: {
        "dark-wood": themeAssetUrl("Avenue 100Walnut-.png"),
        "black": themeAssetUrl("Avenue 100BN-cutout.png"),
        "white": themeAssetUrl("Avenue 100W-cutout.png"),
      },
      colorVariantIds: {
        "dark-wood": { left: "41260071551141" },
        "black": { left: "41273059410085" },
        "white": { left: "41273059442853" },
      },
      colorVariantPrices: {"dark-wood": 13500, "black": 13500, "white": 13500},
      image: themeAssetUrl("Avenue 100W-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "avenue-100 clear",
      name: "Avenue L clear",
      width: 100,
      height: 40,
      sortOrder: 9999,
      price: 20700,
      category: "large",
      colors: ["black", "white"],
      colorImages: {
        "black": themeAssetUrl("Avenue 100BN-cutout.png"),
        "white": themeAssetUrl("Avenue 100W-cutout.png"),
      },
      colorVariantIds: {
        "black": { left: "41260340445349" },
        "white": { left: "41260340412581" },
      },
      colorVariantPrices: {"black": 20700, "white": 20700},
      image: themeAssetUrl("Avenue 100W-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "caturn-n18",
      name: "Caturn N18",
      width: 18,
      height: 18,
      sortOrder: 9999,
      price: 16500,
      category: "scratch",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("Caturn N18-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "45808680206501" },
      },
      colorVariantPrices: {"light-wood": 16500},
      image: themeAssetUrl("Caturn N18-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "caturn-n25",
      name: "Caturn N25",
      width: 25,
      height: 25,
      sortOrder: 9999,
      price: 19800,
      category: "scratch",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("Caturn N25-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "45808680239269" },
      },
      colorVariantPrices: {"light-wood": 19800},
      image: themeAssetUrl("Caturn N25-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "chillax",
      name: "Chillax",
      width: 35,
      height: 60,
      sortOrder: 9999,
      price: 24050,
      category: "scratch",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("Chillax N-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "42856013496485" },
      },
      colorVariantPrices: {"light-wood": 24050},
      image: themeAssetUrl("Chillax N-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "cloud",
      name: "Moku",
      width: 35,
      height: 22.8,
      sortOrder: 9999,
      price: 18500,
      category: "small",
      colors: ["light-wood", "white"],
      colorImages: {
        "light-wood": themeAssetUrl("Cloud N-cutout.png"),
        "white": themeAssetUrl("Cloud W-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "44187736866981" },
        "white": { left: "44187736899749" },
      },
      colorVariantPrices: {"light-wood": 18500, "white": 18500},
      image: themeAssetUrl("Cloud N-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "cork-r",
      name: "Cork R",
      width: 28,
      height: 15.3,
      sortOrder: 9999,
      price: 11600,
      category: "small",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("CorkR W-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "42770620973221" },
      },
      colorVariantPrices: {"light-wood": 11600},
      image: themeAssetUrl("CorkR W-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "cork",
      name: "Cork",
      width: 70,
      height: 9,
      sortOrder: 9999,
      price: 18380,
      category: "large",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("Cork N-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "42770559533221" },
      },
      colorVariantPrices: {"light-wood": 18380},
      image: themeAssetUrl("Cork N-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "cosmos",
      name: "Cosmos",
      width: 120,
      height: 45,
      sortOrder: 9999,
      price: 38500,
      category: "floor",
      colors: ["black", "white"],
      colorImages: {
        "black": themeAssetUrl("Cosmos B-cutout.png"),
        "white": themeAssetUrl("Cosmos W-cutout.png"),
      },
      colorVariantIds: {
      },
      colorVariantPrices: {"black": 38500, "white": 38500},
      image: themeAssetUrl("Cosmos W-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: false,
      resizable: false,
    },
  {
      id: "cylinder-50",
      name: "Cylinder",
      width: 51.9,
      height: 12,
      sortOrder: 9999,
      price: 8050,
      category: "scratch",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("Cylinder 30N-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "45946073120933" },
      },
      colorVariantPrices: {"light-wood": 8050},
      image: themeAssetUrl("Cylinder 30N-cutout.png"),
      flippable: false,
      verticalFlippable: true,
      rotateOnVerticalFlip: true,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "cylinder-100",
      name: "Cylinder 1+1",
      width: 101.9,
      height: 12,
      sortOrder: 9999,
      price: 13650,
      category: "scratch",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("Cylinder 60N-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "41586044666021" },
      },
      colorVariantPrices: {"light-wood": 13650},
      image: themeAssetUrl("Cylinder 60N-cutout.png"),
      flippable: false,
      verticalFlippable: true,
      rotateOnVerticalFlip: true,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "cylinder-150",
      name: "Cylinder 1+2",
      width: 151.8,
      height: 12,
      sortOrder: 9999,
      price: 19250,
      category: "scratch",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("Cylinder 90N-cutout.png"),
      },
      colorVariantIds: {
      },
      colorVariantPrices: {"light-wood": 19250},
      image: themeAssetUrl("Cylinder 90N-cutout.png"),
      flippable: false,
      verticalFlippable: true,
      rotateOnVerticalFlip: true,
      mustDouble: false,
      visible: false,
      resizable: false,
    },
  {
      id: "hover",
      name: "Hover",
      width: 150,
      height: 15,
      sortOrder: 9999,
      price: 24500,
      category: "large",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("Hover N-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "45732300325029" },
      },
      colorVariantPrices: {"light-wood": 24500},
      image: themeAssetUrl("Hover N-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
      customizableSpan: true,
      minLengthCm: 70,
      maxLengthCm: 150,
      defaultLengthCm: 150,
      spanVisualHeightCm: 18,
    },
  {
      id: "lack-m",
      name: "Lack M",
      width: 30,
      height: 10,
      sortOrder: 9999,
      price: 11750,
      category: "small",
      colors: ["light-wood", "black", "white"],
      colorImages: {
        "light-wood": themeAssetUrl("LackM N-cutout.png"),
        "black": themeAssetUrl("LackM B-cutout.png"),
        "white": themeAssetUrl("LackM W-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "44340299071653" },
        "black": { left: "44340302250149" },
        "white": { left: "44340302217381" },
      },
      colorVariantPrices: {"light-wood": 11750, "black": 11750, "white": 11750},
      image: themeAssetUrl("LackM N-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: true,
      visible: true,
      resizable: false,
    },
  {
      id: "lack-s",
      name: "Lack S",
      width: 20,
      height: 10,
      sortOrder: 9999,
      price: 10290,
      category: "small",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("LackS N-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "44340299038885" },
      },
      colorVariantPrices: {"light-wood": 10290},
      image: themeAssetUrl("LackS N-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: true,
      visible: true,
      resizable: false,
    },
  {
      id: "lack-tilt",
      name: "Lack Tilt",
      width: 40,
      height: 15,
      sortOrder: 9999,
      price: 9300,
      category: "small",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("Tilt left N-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "42590143086757", right: "42590143119525" },
      },
      colorVariantPrices: {"light-wood": 9300},
      image: themeAssetUrl("Tilt left N-cutout.png"),
      flippable: true,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "locus",
      name: "Locus",
      width: 29.8,
      height: 57.7,
      sortOrder: 9999,
      price: 15951,
      category: "scratch",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("Locus-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "45732301865125" },
      },
      colorVariantPrices: {"light-wood": 15951},
      image: themeAssetUrl("Locus-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "oblong-60",
      name: "Oblong M",
      width: 60,
      height: 8.8,
      sortOrder: 9999,
      price: 19050,
      category: "large",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("Oblong60 N-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "37927517094053" },
      },
      colorVariantPrices: {"light-wood": 19050},
      image: themeAssetUrl("Oblong60 N-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "oblong-90",
      name: "Oblong L",
      width: 90,
      height: 8.8,
      sortOrder: 9999,
      price: 25650,
      category: "large",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("Oblong90 N-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "37927517126821" },
      },
      colorVariantPrices: {"light-wood": 25650},
      image: themeAssetUrl("Oblong90 N-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "seaweed",
      name: "Seaweed",
      width: 26.7,
      height: 60,
      sortOrder: 9999,
      price: 8050,
      category: "scratch",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("Seaweed-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "42043628093605" },
      },
      colorVariantPrices: {"light-wood": 8050},
      image: themeAssetUrl("Seaweed-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "rover",
      name: "Ocean Rover",
      width: 50,
      height: 40.2,
      sortOrder: 9999,
      price: 31900,
      category: "large",
      colors: ["black", "white"],
      colorImages: {
        "black": themeAssetUrl("Rover B-cutout.png"),
        "white": themeAssetUrl("Rover Walnut-cutout.png"),
      },
      colorVariantIds: {
        "black": { left: "45903745155237" },
        "white": { left: "45903745188005" },
      },
      colorVariantPrices: {"black": 31900, "white": 31900},
      image: themeAssetUrl("Rover Walnut-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "solar",
      name: "Solar",
      width: 90.3,
      height: 90.3,
      sortOrder: 9999,
      price: 36500,
      category: "large",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("Solar-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "31589880103044" },
      },
      colorVariantPrices: {"light-wood": 36500},
      image: themeAssetUrl("Solar-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "star",
      name: "Star",
      width: 33.6,
      height: 32.1,
      sortOrder: 9999,
      price: 16000,
      category: "scratch",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("Star N-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "31589920866436" },
      },
      colorVariantPrices: {"light-wood": 16000},
      image: themeAssetUrl("Star N-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "stringray",
      name: "Stringray",
      width: 59.5,
      height: 15,
      sortOrder: 9999,
      price: 18500,
      category: "large",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("Stingray left N-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "41869514637477", right: "41869514670245" },
      },
      colorVariantPrices: {"light-wood": 18500},
      image: themeAssetUrl("Stingray left N-cutout.png"),
      flippable: true,
      verticalFlippable: true,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "tower-loop",
      name: "Loop Tower",
      width: 60,
      height: 127.4,
      sortOrder: 9999,
      price: 43980,
      category: "floor",
      colors: ["black", "white"],
      colorImages: {
        "black": themeAssetUrl("Loop B-cutout.png"),
        "white": themeAssetUrl("Loop W-cutout.png"),
      },
      colorVariantIds: {
        "black": { left: "42667160273061" },
        "white": { left: "42667160240293" },
      },
      colorVariantPrices: {"black": 43980, "white": 43980},
      image: themeAssetUrl("Loop W-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "trinest",
      name: "Trinest",
      width: 100,
      height: 76.6,
      sortOrder: 9999,
      price: 41800,
      category: "floor",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("Trinest N-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "44254192369829", right: "44254192369829" },
      },
      colorVariantPrices: {"light-wood": 41800},
      image: themeAssetUrl("Trinest N-cutout.png"),
      flippable: true,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "tripaws",
      name: "Tripaws",
      width: 60.4,
      height: 52.7,
      sortOrder: 9999,
      price: 25850,
      category: "floor",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("Tripaw N-cutout.png"),
      },
      colorVariantIds: {
        "light-wood": { left: "44254158618789" },
      },
      colorVariantPrices: {"light-wood": 25850},
      image: themeAssetUrl("Tripaw N-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "tunnel",
      name: "Tunnel",
      width: 63.2,
      height: 33.2,
      sortOrder: 9999,
      price: 14650,
      category: "large",
      colors: ["black", "white"],
      colorImages: {
        "black": themeAssetUrl("Tunnel B-cutout.png"),
        "white": themeAssetUrl("Tunnel W-cutout.png"),
      },
      colorVariantIds: {
        "black": { left: "41772660293797" },
        "white": { left: "41772660261029" },
      },
      colorVariantPrices: {"black": 14650, "white": 14650},
      image: themeAssetUrl("Tunnel W-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: true,
      resizable: false,
    },
  {
      id: "whale",
      name: "Whale",
      width: 75,
      height: 19,
      sortOrder: 9999,
      price: 0,
      category: "large",
      colors: ["light-wood"],
      colorImages: {
        "light-wood": themeAssetUrl("Whale N-cutout.png"),
      },
      colorVariantIds: {
      },
      colorVariantPrices: {"light-wood": 0},
      image: themeAssetUrl("Whale N-cutout.png"),
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: false,
      resizable: false,
    },
  ...Array.from({ length: shapeObjectCount }, (_, index) => ({
    id: index === 0 ? shapeObjectId : `${shapeObjectId}-${index + 1}`,
    name: index === 0 ? "家具配件" : `家具配件 ${index + 1}`,
    width: 60,
    height: 60,
    image: shapeObjectImage,
    category: "transparent",
    colors: ["transparent"],
    colorImages: {
      transparent: shapeObjectImage,
    },
    colorVariantIds: {},
    colorVariantPrices: {},
    price: 0,
    sortOrder: 9999 + index,
    flippable: false,
    verticalFlippable: false,
    rotateOnVerticalFlip: false,
    mustDouble: false,
    visible: true,
    resizable: true,
  })),
];


function isShapeObjectId(id) {
  return /^shape-object(?:-[2-5])?$/.test(String(id || ""));
}

function isShapeObjectProduct(product) {
  return isShapeObjectId(product?.id);
}

function isMobileCatalogDragDisabled(event) {
  return event?.pointerType
    ? event.pointerType !== "mouse"
    : window.matchMedia("(pointer: coarse), (max-width: 760px)").matches;
}

const productDatabaseKey = "wall-planner-product-database-v1";
const productDatabaseVersionKey = "wall-planner-product-database-version";
const productDatabaseVersion = "2026-07-10-v156-shopify-jp-products-single-db-button";
const productCategoryOrderKey = "wall-planner-product-category-order-v1";
const productColors = {
  "light-wood": { label: "橡木色", swatch: "#d7b98c" },
  "dark-wood": { label: "胡桃木色", swatch: "#6b4228" },
  black: { label: "黑色", swatch: "#3f454a" },
  white: { label: "白色", swatch: "#f8f6ef" },
  transparent: { label: "家具配件", swatch: "rgba(255, 255, 255, 0.66)" },
};
const defaultProductColor = "light-wood";
const defaultProductCategoryOrder = ["small", "large", "scratch", "floor", "transparent"];
const popularCombos = [
  {
    "id": "COMBO-001",
    "title": "Loft Living Room Set",
    "image": "https://myzoo.jp/cdn/shop/files/Loft_Living_Room_Set-1.jpg?v=1766370654&width=800",
    "price": 110000,
    "wallWidth": 273,
    "wallHeight": 240,
    "items": [
      {
        "productId": "gamma",
        "quantity": 1,
        "color": "light-wood",
        "direction": "right",
        "verticalFlipped": false,
        "leftCm": 24.5,
        "bottomCm": 176.2
      },
      {
        "productId": "stringray",
        "quantity": 1,
        "color": "light-wood",
        "direction": "left",
        "verticalFlipped": true,
        "leftCm": 70.8,
        "bottomCm": 156.2
      },
      {
        "productId": "stringray",
        "quantity": 1,
        "color": "light-wood",
        "direction": "left",
        "verticalFlipped": false,
        "leftCm": 118.5,
        "bottomCm": 200.2
      },
      {
        "productId": "z-step",
        "quantity": 1,
        "color": "light-wood",
        "direction": "right",
        "verticalFlipped": false,
        "leftCm": 145.3,
        "bottomCm": 135.4
      },
      {
        "productId": "cork",
        "quantity": 1,
        "color": "light-wood",
        "direction": "left",
        "verticalFlipped": false,
        "leftCm": 55.3,
        "bottomCm": 107.2
      },
      {
        "productId": "z-step",
        "quantity": 1,
        "color": "light-wood",
        "direction": "left",
        "verticalFlipped": false,
        "leftCm": 5.5,
        "bottomCm": 59.2
      },
      {
        "productId": "lack-m",
        "quantity": 1,
        "color": "light-wood",
        "direction": "left",
        "verticalFlipped": false,
        "leftCm": 95,
        "bottomCm": 25
      },
      {
        "productId": "lack-m",
        "quantity": 1,
        "color": "light-wood",
        "direction": "left",
        "verticalFlipped": false,
        "leftCm": 143,
        "bottomCm": 58.4
      },
      {
        "productId": "lack-m",
        "quantity": 1,
        "color": "light-wood",
        "direction": "left",
        "verticalFlipped": false,
        "leftCm": 189,
        "bottomCm": 91.4
      },
      {
        "productId": "lack-m",
        "quantity": 1,
        "color": "light-wood",
        "direction": "left",
        "verticalFlipped": false,
        "leftCm": 235,
        "bottomCm": 124.4
      }
    ]
  },
  {
    "id": "COMBO-002",
    "title": "Busycat Avenue Lack Set",
    "image": "https://myzoo.jp/cdn/shop/files/AvenueWalnutSet.jpg?v=1767771091&width=800",
    "price": 72600,
    "wallWidth": 182,
    "wallHeight": 240,
    "items": [
      {
        "productId": "busycat",
        "quantity": 1,
        "color": "black",
        "direction": "left",
        "verticalFlipped": false,
        "leftCm": 35,
        "bottomCm": 110
      },
      {
        "productId": "busycat-cover",
        "quantity": 1,
        "color": "light-wood",
        "direction": "left",
        "verticalFlipped": false,
        "leftCm": 37.3,
        "bottomCm": 112
      },
      {
        "productId": "busycat",
        "quantity": 1,
        "color": "black",
        "direction": "left",
        "verticalFlipped": false,
        "leftCm": 72.5,
        "bottomCm": 88.2
      },
      {
        "productId": "lack-m",
        "quantity": 1,
        "color": "black",
        "direction": "left",
        "verticalFlipped": false,
        "leftCm": 5,
        "bottomCm": 20
      },
      {
        "productId": "lack-m",
        "quantity": 1,
        "color": "black",
        "direction": "left",
        "verticalFlipped": false,
        "leftCm": 45,
        "bottomCm": 50
      },
      {
        "productId": "avenue-100",
        "quantity": 1,
        "color": "dark-wood",
        "direction": "left",
        "verticalFlipped": false,
        "leftCm": 29.6,
        "bottomCm": 198.4
      },
      {
        "productId": "avenue-60",
        "quantity": 1,
        "color": "dark-wood",
        "direction": "left",
        "verticalFlipped": false,
        "leftCm": 120,
        "bottomCm": 158.4
      }
    ]
  },
  {
    "id": "COMBO-003",
    "title": "Ann In Taipei Special Set",
    "image": "https://myzoo.jp/cdn/shop/files/3_0daa6a1c-5c86-47da-8378-b10dd106a6e9.png?v=1753087897&width=800",
    "price": 100000,
    "wallWidth": 250,
    "wallHeight": 250,
    "items": [
      {
        "productId": "luna",
        "quantity": 1,
        "color": "light-wood",
        "direction": "left",
        "verticalFlipped": false,
        "leftCm": 6.4,
        "bottomCm": 127.7
      },
      {
        "productId": "star",
        "quantity": 1,
        "color": "light-wood",
        "direction": "left",
        "verticalFlipped": false,
        "leftCm": 58.2,
        "bottomCm": 187
      },
      {
        "productId": "rover",
        "quantity": 1,
        "color": "white",
        "direction": "left",
        "verticalFlipped": false,
        "leftCm": 155,
        "bottomCm": 156.7
      },
      {
        "productId": "cloud",
        "quantity": 1,
        "color": "light-wood",
        "direction": "left",
        "verticalFlipped": false,
        "leftCm": 105,
        "bottomCm": 130.5
      },
      {
        "productId": "cork-r",
        "quantity": 1,
        "color": "light-wood",
        "direction": "left",
        "verticalFlipped": false,
        "leftCm": 220,
        "bottomCm": 121.8
      },
      {
        "productId": "cylinder-50",
        "quantity": 1,
        "color": "light-wood",
        "direction": "left",
        "verticalFlipped": false,
        "leftCm": 153,
        "bottomCm": 98
      }
    ]
  },
  {
    "id": "COMBO-004",
    "title": "Gamma Lack Set",
    "image": "https://myzoo.jp/cdn/shop/files/3_1_c9708a9a-9a05-4b46-a97e-f84b9c34c754.jpg?v=1738893056&width=800",
    "price": 30000,
    "wallWidth": 182,
    "wallHeight": 240,
    "items": [
      {
        "productId": "gamma",
        "quantity": 1,
        "color": "light-wood",
        "direction": "left",
        "verticalFlipped": false,
        "leftCm": 113,
        "bottomCm": 105
      },
      {
        "productId": "lack-m",
        "quantity": 1,
        "color": "light-wood",
        "direction": "left",
        "verticalFlipped": false,
        "leftCm": 35,
        "bottomCm": 50
      },
      {
        "productId": "lack-m",
        "quantity": 1,
        "color": "light-wood",
        "direction": "left",
        "verticalFlipped": false,
        "leftCm": 75,
        "bottomCm": 85
      }
    ]
  }
];
let productCategoryOrder = loadProductCategoryOrder();
const defaultProductCategory = "small";
const productCategoryLabels = {
  popular: { zh: "熱門組合", ja: "人気セット" },
  small: { zh: "小型", ja: "小型" },
  large: { zh: "大型", ja: "大型" },
  scratch: { zh: "抓布", ja: "爪とぎ" },
  floor: { zh: "落地", ja: "床置き" },
  transparent: { zh: "家具配件", ja: "家具・小物" },
};
const variantPriceCache = new Map();
const managerSessionKey = "wall-planner-manager-session-v1";
const managerAccount = {
  username: "Michael",
  password: "Sky201634",
};
let fixedProducts = loadFixedProducts();
let managerSignedIn = loadManagerSession();
const planner = document.querySelector(".planner");
document.body.classList.add("iwp-planner-page");
const wall = document.querySelector("#wall");
const wallHint = document.querySelector("#wallHint");
const wallWidthInput = document.querySelector("#wallWidth");
const wallHeightInput = document.querySelector("#wallHeight");
const roomNameInput = document.querySelector("#roomName");
const roomLabel = document.querySelector("#roomLabel");
const dimensionLabel = document.querySelector("#dimensionLabel");
const widthMeasure = document.querySelector("#widthMeasure");
const heightMeasure = document.querySelector("#heightMeasure");
const widthMeasureLine = widthMeasure?.closest(".measure-width");
const heightMeasureLine = heightMeasure?.closest(".measure-height");
const scaleLabel = document.querySelector("#scaleLabel");
const itemCount = document.querySelector("#itemCount");
const wallTotalPrice = document.querySelector("#wallTotalPrice");
const dimensionToggle = document.querySelector("#dimensionToggle");
const coordinateToggle = document.querySelector("#coordinateToggle");
const selectionModeToggle = document.querySelector("#selectionModeToggle");
const groupSelectionButton = document.querySelector("#groupSelectionToggle");
const fullscreenToggle = document.querySelector("#fullscreenToggle");
const fullscreenBottomExit = document.querySelector("#fullscreenBottomExit");
const fullscreenSidebarToggle = document.querySelector("#fullscreenSidebarToggle");
const wallWorkbar = document.querySelector("#wallWorkbar");
const wallWorkbarToggle = document.querySelector("#wallWorkbarToggle");
const arButton = document.querySelector("#arButton");
const arDialog = document.querySelector("#arDialog");
const captureArButton = document.querySelector("#captureAr");
const closeArButton = document.querySelector("#closeAr");
const arVideo = document.querySelector("#arVideo");
const arOverlay = document.querySelector("#arOverlay");
const arStatus = document.querySelector("#arStatus");
const arCalibrationHint = document.querySelector("#arCalibrationHint");
const catalogItems = document.querySelector("#catalogItems");
const productItemContainers = [...document.querySelectorAll(".category-product-items")];
const catalogTemplate = document.querySelector("#catalogTemplate");
const fixedProductTemplate = document.querySelector("#fixedProductTemplate");
const catalogTabs = [...document.querySelectorAll(".catalog-tab")];
const catalogTabList = document.querySelector(".catalog-tabs");
const catalogTabPrevButton = document.querySelector("#catalogTabPrev");
const catalogTabNextButton = document.querySelector("#catalogTabNext");
const clearWallButton = document.querySelector("#clearWall");
const addWallToCartButton = document.querySelector("#addWallToCart");
const clearConfirmDialog = document.querySelector("#clearConfirmDialog");
const clearConfirmTitle = document.querySelector("#clearConfirmTitle");
const confirmClearWallButton = document.querySelector("#confirmClearWall");
const cancelClearWallButton = document.querySelector("#cancelClearWall");
const databaseButtons = document.querySelector("#databaseButtons");
const managerLoginButton = document.querySelector("#managerLoginButton");
const managerLogoutButton = document.querySelector("#managerLogoutButton");
const managerLoginDialog = document.querySelector("#managerLoginDialog");
const managerLoginForm = document.querySelector("#managerLoginForm");
const managerUsernameInput = document.querySelector("#managerUsername");
const managerPasswordInput = document.querySelector("#managerPassword");
const managerLoginError = document.querySelector("#managerLoginError");
const closeManagerLoginButton = document.querySelector("#closeManagerLogin");
const openProductDatabaseButton = document.querySelector("#openProductDatabase");
const openFurnitureDatabaseButton = document.querySelector("#openFurnitureDatabase");
const productDatabaseDialog = document.querySelector("#productDatabaseDialog");
const furnitureDatabaseDialog = document.querySelector("#furnitureDatabaseDialog");
const productDatabaseRows = document.querySelector("#productDatabaseRows");
const productDatabaseTabs = [...document.querySelectorAll(".database-category-tab")];
const furnitureDatabaseRows = document.querySelector("#furnitureDatabaseRows");
const databaseRowTemplate = document.querySelector("#databaseRowTemplate");
const furnitureDatabaseRowTemplate = document.querySelector("#furnitureDatabaseRowTemplate");
const saveProductDatabaseButton = document.querySelector("#saveProductDatabase");
const addDatabaseProductButton = document.querySelector("#addDatabaseProduct");
const addDatabaseFurnitureButton = document.querySelector("#addDatabaseFurniture");
const resetDatabaseProductsButton = document.querySelector("#resetDatabaseProducts");
const resetDatabaseFurnitureButton = document.querySelector("#resetDatabaseFurniture");
const languageToggleButton = document.querySelector("#languageToggle");
const wallSettingsToggleButton = document.querySelector("#wallSettingsToggle");
const wallSettingsContent = document.querySelector("#wallSettingsContent");

let placedItems = [];
let activePointer = null;
let catalogPointer = null;
let resizePointer = null;
let selectionMarqueePointer = null;
let selectionModeActive = false;
let selectedItemKey = null;
let selectedItemKeys = new Set();
let itemGroupSerial = 0;
let hiddenActionWheelKey = null;
let dimensionsVisible = false;
let coordinatesVisible = false;
let plannerFullscreen = false;
let wallWorkbarCollapsed = false;
let currentLanguage = detectInitialLanguage();
let currentWallDimensions = { width: 420, height: 260 };
let wallSettingsCollapsed = false;
let wallSettingsCollapsedByUser = false;
let wallSettingsAutoHideTimer = null;
let activeProductDatabaseCategory = defaultProductCategory;
let productCategoryPointer = null;
let arStream = null;
let arCalibration = null;
let arCalibrationPointer = null;
let arProductPointer = null;
let addToastTimer = null;
let fullscreenSidebarCollapsed = false;
let customSpanPointer = null;
let arOwnsFullscreen = false;
let browserbarSpacer = null;
let browserbarAttemptTimer = null;

document.body.classList.add("iwp-planner-page-active");

const translations = {
  zh: {
    appTitle: "互動式空間設計",
    switchLanguage: "日本語",
    hideSettings: "隱藏牆面功能",
    showSettings: "顯示牆面功能",
    spaceName: "空間名稱",
    defaultRoom: "客廳展示牆",
    untitledSpace: "未命名空間",
    wallSize: "牆面尺寸",
    width: "寬",
    height: "高",
    centimeter: "公分",
    products: "產品",
    furniture: "家具",
    dragToWall: "拖曳到牆面",
    furnitureDatabase: "家具資料庫",
    productDatabase: "產品資料庫",
    clearWall: "清空牆面",
    login: "登入",
    logoutManager: "登出管理",
    showDimensions: "顯示距離",
    hideDimensions: "隱藏距離",
    showCoordinates: "顯示座標",
    hideCoordinates: "隱藏座標",
    selectArea: "範圍選取",
    selectAreaActive: "拖曳框選跳台",
    groupSelection: "組成群組",
    groupNeedSelection: "請先用範圍選取選擇至少 2 個產品。",
    ungroupSelection: "取消群組",
    fullscreenEdit: "全螢幕編輯",
    exitFullscreen: "結束全螢幕",
    showFullscreenSidebar: "顯示目錄",
    hideFullscreenSidebar: "隱藏目錄",
    showWorkbar: "顯示工作列",
    hideWorkbar: "隱藏工作列",
    arTitle: "AR",
    closeAr: "關閉 AR",
    captureAr: "拍照",
    arSaving: "正在準備照片...",
    arCaptured: "照片已準備完成，請選擇儲存到相簿。",
    arDownloaded: "照片已下載，請到下載項目查看。",
    arSavePhoto: "儲存 / 分享照片",
    arDownloadPhoto: "下載照片",
    arClosePreview: "關閉",
    arPreviewTitle: "AR 照片已完成",
    arPreviewHint: "請點選儲存 / 分享照片，並依手機提示選擇儲存圖片。",
    arShareFailed: "無法開啟分享視窗，請改用下載照片或長按圖片儲存。",
    arCaptureError: "無法拍照，請確認圖片已載入完成。",
    arStarting: "正在開啟相機...",
    arEmpty: "先把產品放到牆面，再開啟 AR 預覽。",
    arCalibrate: "拖曳框線對齊牆面，拉右下角調整大小。",
    arCameraError: "無法開啟相機。請確認已允許相機權限，並使用 HTTPS 網址開啟此頁。",
    estimatedTotal: "初估總價",
    wallHint: "按＋或直接把商品拖曳進來",
    wallHintMobile: "建議使用全螢幕編輯",
    scale: "比例 1 格 = 30 公分",
    noItems: "尚未放置產品",
    placedCount: (count) => `已放置 ${count} 件產品`,
    productManagement: "產品管理",
    furnitureManagement: "家具管理",
    image: "圖片",
    sortOrder: "排序",
    objectName: "配件名稱",
    productName: "產品名稱",
    furnitureName: "家具名稱",
    category: "分類",
    price: "價格",
    color: "顏色",
    flip: "翻轉",
    actions: "操作",
    addProduct: "新增產品",
    resetProducts: "恢復預設產品",
    resetProductsConfirm: "是否確定恢復預設產品？",
    addFurniture: "新增家具",
    resetFurniture: "恢復預設家具",
    managerAccess: "管理權限",
    account: "帳號",
    password: "密碼",
    loginError: "帳號或密碼不正確",
    register: "註冊",
    replaceImage: "換圖",
    fallbackIcon: "備用圖示",
    save: "儲存",
    delete: "刪除",
    copy: "複製",
    horizontal: "左右",
    visible: "顯示",
    addToWall: "加入牆面",
    productAdded: "已增加",
    addToCart: "加入購物車",
    cartAdded: "已加入購物車",
    cartMissingVariants: "請先增加產品到設計圖",
    cartLocalError: "請在 Shopify 網站上使用加入購物車功能。",
    cartAddError: "加入購物車失敗，請確認 Variant ID 是否正確。",
    cartSoldOutTitle: "以下商品目前無庫存，無法加入購物車：",
    cartSoldOutItem: (name) => `・${name}（無庫存）`,
    cartSystemError: (name) => `・${name}（此商品發生異常，請聯絡開發人員）`,
    colorVariantIds: "顏色 / Variant ID",
    clearConfirm: "是否確定清除",
    yes: "是",
    no: "否",
    priceLabel: (price) => `價格 ${price}`,
    spanLengthLabel: (length) => `長度 ${length} cm`,
    spanLengthRange: (min, max) => `可調長度 ${min}–${max} cm`,
    spanDragHint: "拖曳左右兩端調整長度 / 角度；角度限制 ±50°；拖中間移動產品",
    spanLeftAnchor: "調整左固定點",
    spanRightAnchor: "調整右固定點",
    sizeText: (width, height) => `寬${width}×高${height}公分`,
    widthLabel: (width) => `寬 ${width} cm`,
    heightLabel: (height) => `高 ${height} cm`,
    distanceLabel: (distance) => `${distance} cm`,
    distanceAria: (distance) => `距離牆面底部 ${distance} 公分`,
    placedLabel: (name, width, height, actions) => `${name}，寬 ${width} 高 ${height} 公分，${actions}`,
    colorChooser: (name) => `${name}顏色選擇`,
    applyColor: (color) => `套用${color}`,
    removeNamed: (name) => `刪除${name}`,
    copyNamed: (name) => `複製${name}`,
    flipNamed: (name) => `左右翻轉${name}`,
    resizeNamed: (name) => `調整${name}尺寸`,
    draggable: "可拖曳",
    resizeAction: "調整尺寸",
    flipAction: "左右翻轉",
    actionJoin: "與",
    categorySmall: "小型",
    categoryLarge: "大型",
    categoryScratch: "抓布",
    categoryFloor: "落地",
    categoryTransparent: "家具配件",
    categoryPopular: "熱門組合",
    popularComingSoonTitle: "熱門組合 敬請期待",
    popularComingSoonCopy: "組合內容準備中，之後可直接匯入牆面再自行調整。",
    comboWallSize: (width, height) => `寬${width}*高${height}cm`,
    importCombo: "匯入組合",
    comboPreservePrompt: (name) => `是否保留目前牆面規劃並加入「${name}」？\n確定＝保留目前規劃；取消＝清空後套用組合。`,
    comboMissingProduct: (name) => `找不到組合內產品：${name}`,
    previousCategory: "上一個產品分類",
    nextCategory: "下一個產品分類",
  },
  ja: {
    appTitle: "インタラクティブ空間デザイン",
    switchLanguage: "中文",
    hideSettings: "壁面機能を隠す",
    showSettings: "壁面機能を表示",
    spaceName: "空間名",
    defaultRoom: "リビング展示壁",
    untitledSpace: "名称未設定の空間",
    wallSize: "壁面サイズ",
    width: "幅",
    height: "高さ",
    centimeter: "cm",
    products: "製品",
    furniture: "家具",
    dragToWall: "壁面へドラッグ",
    furnitureDatabase: "家具データベース",
    productDatabase: "製品データベース",
    clearWall: "壁面をクリア",
    login: "ログイン",
    logoutManager: "管理者ログアウト",
    showDimensions: "距離表示",
    hideDimensions: "距離非表示",
    showCoordinates: "座標表示",
    hideCoordinates: "座標非表示",
    selectArea: "範囲選択",
    selectAreaActive: "ドラッグして選択",
    groupSelection: "グループ化",
    groupNeedSelection: "範囲選択で2個以上の商品を選択してください。",
    ungroupSelection: "グループ解除",
    fullscreenEdit: "全画面編集",
    exitFullscreen: "全画面を終了",
    showFullscreenSidebar: "目録を表示",
    hideFullscreenSidebar: "目録を隠す",
    showWorkbar: "ツールバーを表示",
    hideWorkbar: "ツールバーを隠す",
    arTitle: "AR",
    closeAr: "ARを閉じる",
    captureAr: "撮影",
    arSaving: "写真を準備しています...",
    arCaptured: "写真の準備ができました。写真へ保存してください。",
    arDownloaded: "写真をダウンロードしました。ダウンロード項目を確認してください。",
    arSavePhoto: "写真を保存 / 共有",
    arDownloadPhoto: "写真をダウンロード",
    arClosePreview: "閉じる",
    arPreviewTitle: "AR写真が完成しました",
    arPreviewHint: "保存 / 共有をタップし、スマートフォンの案内に従って画像を保存してください。",
    arShareFailed: "共有画面を開けませんでした。ダウンロード、または画像を長押しして保存してください。",
    arCaptureError: "撮影できません。画像の読み込みを確認してください。",
    arStarting: "カメラを起動しています...",
    arEmpty: "先に製品を壁面へ配置してから、ARプレビューを開いてください。",
    arCalibrate: "枠を壁面に合わせてドラッグし、右下でサイズ調整してください。",
    arCameraError: "カメラを起動できません。カメラ権限を許可し、HTTPSのURLで開いてください。",
    estimatedTotal: "概算合計",
    wallHint: "＋を押すか、商品を直接ドラッグしてください",
    wallHintMobile: "全画面編集のご利用をおすすめします",
    scale: "縮尺 1マス = 30 cm",
    noItems: "配置された製品はありません",
    placedCount: (count) => `${count}点を配置済み`,
    productManagement: "製品管理",
    furnitureManagement: "家具管理",
    image: "画像",
    sortOrder: "並び順",
    objectName: "アクセサリー名",
    productName: "製品名",
    furnitureName: "家具名",
    category: "分類",
    price: "価格",
    color: "色",
    flip: "反転",
    actions: "操作",
    addProduct: "製品を追加",
    resetProducts: "既定の製品に戻す",
    resetProductsConfirm: "既定の製品に戻しますか？",
    addFurniture: "家具を追加",
    resetFurniture: "既定の家具に戻す",
    managerAccess: "管理者権限",
    account: "アカウント",
    password: "パスワード",
    loginError: "アカウントまたはパスワードが正しくありません",
    register: "登録",
    replaceImage: "画像変更",
    fallbackIcon: "代替アイコン",
    save: "保存",
    delete: "削除",
    copy: "コピー",
    horizontal: "左右",
    visible: "表示",
    addToWall: "壁面に追加",
    productAdded: "追加しました",
    addToCart: "カートに追加",
    cartAdded: "カートに追加しました",
    cartMissingVariants: "先に製品を設計図に追加してください",
    cartLocalError: "カート追加機能は Shopify サイト上で使用してください。",
    cartAddError: "カート追加に失敗しました。Variant IDを確認してください。",
    cartSoldOutTitle: "在庫切れのため、以下の商品はカートに追加できません：",
    cartSoldOutItem: (name) => `・${name}（在庫なし）`,
    cartSystemError: (name) => `・${name}（エラーが発生しました。開発者にお問い合わせください）`,
    colorVariantIds: "色 / Variant ID",
    clearConfirm: "本当にクリアしますか",
    yes: "はい",
    no: "いいえ",
    priceLabel: (price) => `価格 ${price}`,
    spanLengthLabel: (length) => `長さ ${length} cm`,
    spanLengthRange: (min, max) => `調整可能な長さ ${min}–${max} cm`,
    spanDragHint: "左右の端で長さ / 角度を調整（角度は±50°まで）、中央で移動",
    spanLeftAnchor: "左の固定点を調整",
    spanRightAnchor: "右の固定点を調整",
    sizeText: (width, height) => `幅 ${width} x 高さ ${height} cm`,
    widthLabel: (width) => `幅 ${width} cm`,
    heightLabel: (height) => `高さ ${height} cm`,
    distanceLabel: (distance) => `${distance} cm`,
    distanceAria: (distance) => `壁面下端から ${distance} cm`,
    placedLabel: (name, width, height, actions) => `${name}、幅 ${width} 高さ ${height} cm、${actions}`,
    colorChooser: (name) => `${name} 色選択`,
    applyColor: (color) => `${color}を適用`,
    removeNamed: (name) => `${name}を削除`,
    copyNamed: (name) => `${name}をコピー`,
    flipNamed: (name) => `${name}を左右反転`,
    resizeNamed: (name) => `${name}のサイズを調整`,
    draggable: "ドラッグ可能",
    resizeAction: "サイズ調整",
    flipAction: "左右反転",
    actionJoin: "・",
    categorySmall: "小型",
    categoryLarge: "大型",
    categoryScratch: "爪とぎ",
    categoryFloor: "床置き",
    categoryTransparent: "家具・小物",
    categoryPopular: "人気セット",
    popularComingSoonTitle: "人気セット 近日公開",
    popularComingSoonCopy: "セット内容を準備中です。公開後は壁面へまとめて配置し、自由に調整できます。",
    comboWallSize: (width, height) => `幅${width}*高さ${height}cm`,
    importCombo: "セットを配置",
    comboPreservePrompt: (name) => `現在のレイアウトを残したまま「${name}」を追加しますか？\nOK＝現在のレイアウトを残す／キャンセル＝壁面をクリアしてセットを配置`,
    comboMissingProduct: (name) => `セット内の商品が見つかりません：${name}`,
    previousCategory: "前の製品カテゴリー",
    nextCategory: "次の製品カテゴリー",
  },
};

const localizedFurnitureNames = {
  zh: {
    sofa: "沙發",
    "dining-table": "餐桌",
    tv: "電視",
    "tv-console": "電視櫃",
    cabinet: "櫥櫃",
    chair: "椅子",
    stool: "凳子",
    frame: "畫框",
    outlet: "插座面板",
  },
  ja: {
    sofa: "ソファ",
    "dining-table": "ダイニングテーブル",
    tv: "テレビ",
    "tv-console": "テレビボード",
    cabinet: "キャビネット",
    chair: "椅子",
    stool: "スツール",
    frame: "額縁",
    outlet: "コンセントプレート",
  },
};

const localizedColorLabels = {
  ja: {
    "light-wood": "オーク",
    "dark-wood": "ウォールナット",
    black: "ブラック",
    white: "ホワイト",
    transparent: "家具・小物",
  },
};

function clamp(value, minimum, maximum) {
  return Math.min(Math.max(value, minimum), maximum);
}

function detectInitialLanguage() {
  const browserLanguages = Array.isArray(navigator.languages)
    ? navigator.languages.filter(Boolean)
    : [];
  const primaryLanguage = String(browserLanguages[0] || navigator.language || "").toLowerCase();

  // V164: only the browser's primary language decides the initial planner language.
  // Japanese primary language => Japanese. Chinese, English, and all other languages
  // fall back to Traditional Chinese because the planner currently supports zh / ja only.
  return primaryLanguage.startsWith("ja") ? "ja" : "zh";
}

function t(key, ...args) {
  const value = translations[currentLanguage][key] ?? translations.zh[key] ?? key;

  return typeof value === "function" ? value(...args) : value;
}

function getDisplayName(product) {
  return localizedFurnitureNames[currentLanguage]?.[product.id] || product.name;
}

function getDimensions() {
  const widthValue = Number(wallWidthInput.value);
  const heightValue = Number(wallHeightInput.value);

  return {
    width: Number.isFinite(widthValue) && widthValue > 0
      ? clamp(widthValue, 50, 1000)
      : currentWallDimensions.width,
    height: Number.isFinite(heightValue) && heightValue > 0
      ? clamp(heightValue, 50, 1000)
      : currentWallDimensions.height,
  };
}

function getProductSizeText(product) {
  return t("sizeText", formatDimension(product.width), formatDimension(product.height));
}

function formatPrice(value) {
  const formatted = new Intl.NumberFormat("ja-JP", {
    maximumFractionDigits: 0,
  }).format(value);

  return `¥${formatted}`;
}

function parseShopifyPrice(value) {
  if (value === null || value === undefined || value === "") {
    return 0;
  }

  if (typeof value === "string" && value.includes(".")) {
    return clamp(Math.round(Number(value)), 0, 999999999);
  }

  return clamp(Math.round(Number(value) / 100), 0, 999999999);
}

async function fetchVariantPrice(variantId) {
  const id = String(variantId || "").trim();

  if (!id) {
    return 0;
  }

  if (variantPriceCache.has(id)) {
    return variantPriceCache.get(id);
  }

  if (!/^https?:$/.test(window.location.protocol)) {
    return 0;
  }

  try {
    const response = await fetch(`/variants/${encodeURIComponent(id)}.js`, {
      headers: { Accept: "application/json" },
    });

    if (!response.ok) {
      return 0;
    }

    const variant = await response.json();
    const price = parseShopifyPrice(variant.price);

    if (price > 0) {
      variantPriceCache.set(id, price);
    }

    return price;
  } catch (error) {
    return 0;
  }
}

function normalizeProductColor(value) {
  return Object.prototype.hasOwnProperty.call(productColors, String(value))
    ? String(value)
    : defaultProductColor;
}

function normalizeProductColors(value) {
  const rawColors = Array.isArray(value) ? value : [value];
  const colors = rawColors
    .map(normalizeProductColor)
    .filter((color, index, entries) => entries.indexOf(color) === index);

  return colors.length > 0 ? colors : [defaultProductColor];
}

function getPrimaryProductColor(product) {
  return normalizeProductColors(product.colors || product.color)[0];
}

function getPlacedProductColor(product, item) {
  const availableColors = normalizeProductColors(product.colors || product.color);

  return availableColors.includes(item.color) ? item.color : availableColors[0];
}

function getProductColorLabel(color) {
  const normalizedColor = normalizeProductColor(color);

  return localizedColorLabels[currentLanguage]?.[normalizedColor] || productColors[normalizedColor].label;
}

function getProductColorSwatch(color) {
  return productColors[normalizeProductColor(color)].swatch;
}

function normalizeColorVariantIds(value, fallbackVariantId = "", colors = []) {
  const source = value && typeof value === "object" && !Array.isArray(value) ? value : {};
  const result = {};

  Object.keys(productColors).forEach((color) => {
    const rawValue = source[color];

    if (rawValue && typeof rawValue === "object" && !Array.isArray(rawValue)) {
      const left = String(rawValue.left || rawValue.default || rawValue.id || "").trim();
      const right = String(rawValue.right || "").trim();

      if (left || right) {
        result[color] = {
          left: left || right,
          right: right || left,
        };
      }
      return;
    }

    const variantId = String(rawValue || "").trim();

    if (variantId) {
      result[color] = variantId;
    }
  });

  const fallback = String(fallbackVariantId || "").trim();
  const primaryColor = normalizeProductColors(colors)[0];

  if (fallback && !result[primaryColor]) {
    result[primaryColor] = fallback;
  }

  return result;
}

function normalizeColorVariantPrices(value, fallbackPrice = 0, colors = []) {
  const source = value && typeof value === "object" && !Array.isArray(value) ? value : {};
  const result = {};

  Object.keys(productColors).forEach((color) => {
    const price = clamp(Number(source[color]) || 0, 0, 999999999);

    if (price > 0) {
      result[color] = price;
    }
  });

  const fallback = clamp(Number(fallbackPrice) || 0, 0, 999999999);
  const primaryColor = normalizeProductColors(colors)[0];

  if (fallback > 0 && !result[primaryColor]) {
    result[primaryColor] = fallback;
  }

  return result;
}

function normalizeColorImages(value, fallbackImage = "", colors = []) {
  const source = value && typeof value === "object" && !Array.isArray(value) ? value : {};
  const result = {};

  Object.keys(productColors).forEach((color) => {
    const image = String(source[color] || "").trim();

    if (image) {
      result[color] = image;
    }
  });

  const fallback = String(fallbackImage || "").trim();
  const primaryColor = normalizeProductColors(colors)[0];

  if (fallback && !result[primaryColor]) {
    result[primaryColor] = fallback;
  }

  return result;
}

function getProductVariantIdForColor(product, color) {
  return getProductVariantIdForColorDirection(product, color, null);
}

function isStingrayDirectionSwapProduct(product) {
  const productId = String(product?.id || "").toLowerCase();
  const productName = String(product?.name || "").toLowerCase();

  return productId === "stringray" || productId === "stingray" || /stingray|stringray/.test(productName);
}

function getEffectiveProductDirection(product, item = null) {
  const horizontallyRight = Boolean(item?.flipped);
  const verticallySwapped = isStingrayDirectionSwapProduct(product) && Boolean(item?.verticalFlipped);

  return horizontallyRight !== verticallySwapped ? "right" : "left";
}

function getProductVariantIdForColorDirection(product, color, item = null) {
  const normalizedColor = normalizeProductColor(color);
  const variantValue = product.colorVariantIds?.[normalizedColor];

  if (variantValue && typeof variantValue === "object" && !Array.isArray(variantValue)) {
    const direction = getEffectiveProductDirection(product, item);
    return String(
      variantValue[direction] ||
      variantValue.left ||
      variantValue.right ||
      product.shopifyVariantId ||
      ""
    ).trim();
  }

  return String(variantValue || product.shopifyVariantId || "").trim();
}

function hasDistinctDirectionVariant(product, item = null) {
  if (!product?.flippable) {
    return false;
  }

  const color = getPlacedProductColor(product, item);
  const normalizedColor = normalizeProductColor(color);
  const variantValue = product.colorVariantIds?.[normalizedColor];

  if (!variantValue || typeof variantValue !== "object" || Array.isArray(variantValue)) {
    return false;
  }

  const leftId = String(variantValue.left || "").trim();
  const rightId = String(variantValue.right || "").trim();

  return Boolean(leftId && rightId && leftId !== rightId);
}

function getProductDirectionLabel(product, item) {
  if (!hasDistinctDirectionVariant(product, item)) {
    return "";
  }

  return getEffectiveProductDirection(product, item) === "right" ? "右方向" : "左方向";
}

function getCartUnitQuantity(product) {
  return product?.mustDouble ? 0.5 : 1;
}

function getProductPriceForColor(product, color) {
  const normalizedColor = normalizeProductColor(color);

  return clamp(Number(product.colorVariantPrices?.[normalizedColor] || product.price) || 0, 0, 999999999);
}

function getProductPriceSummary(product) {
  const prices = normalizeProductColors(product.colors)
    .map((color) => getProductPriceForColor(product, color))
    .filter((price) => price > 0)
    .filter((price, index, entries) => entries.indexOf(price) === index)
    .sort((a, b) => a - b);

  if (prices.length === 0) {
    return t("priceLabel", formatPrice(0));
  }

  if (prices.length === 1) {
    return t("priceLabel", formatPrice(prices[0]));
  }

  return t("priceLabel", `${formatPrice(prices[0])} - ${formatPrice(prices[prices.length - 1])}`);
}

function getProductImageForColor(product, color) {
  const normalizedColor = normalizeProductColor(color);

  return String(product.colorImages?.[normalizedColor] || product.image || "").trim();
}

function hasProductColorImage(product, color) {
  const normalizedColor = normalizeProductColor(color);

  return Boolean(product.colorImages?.[normalizedColor]);
}

function normalizeProductCategoryOrder(order) {
  const seen = new Set();
  const ordered = Array.isArray(order) ? order : [];
  const validOrder = ordered
    .map((category) => String(category || "").trim())
    .filter((category) => defaultProductCategoryOrder.includes(category) && !seen.has(category) && seen.add(category));

  defaultProductCategoryOrder.forEach((category) => {
    if (!seen.has(category)) {
      validOrder.push(category);
    }
  });

  return validOrder;
}

function loadProductCategoryOrder() {
  try {
    return normalizeProductCategoryOrder(JSON.parse(localStorage.getItem(productCategoryOrderKey)));
  } catch (error) {
    return [...defaultProductCategoryOrder];
  }
}

function saveProductCategoryOrder() {
  try {
    localStorage.setItem(productCategoryOrderKey, JSON.stringify(productCategoryOrder));
  } catch (error) {
    // Category order is a convenience setting; the planner still works if storage is blocked.
  }
}

function normalizeProductCategory(category) {
  const value = String(category || "").trim();

  return productCategoryOrder.includes(value) ? value : "";
}

function getProductCategoryLabel(category) {
  const normalizedCategory = normalizeProductCategory(category) || defaultProductCategory;
  const translationKey = `category${normalizedCategory.charAt(0).toUpperCase()}${normalizedCategory.slice(1)}`;

  return t(translationKey) || productCategoryLabels[normalizedCategory]?.[currentLanguage] || productCategoryLabels[normalizedCategory]?.zh;
}

function inferProductCategory(product) {
  const name = String(product.name || "").toLowerCase();
  const width = Number(product.width) || 0;
  const height = Number(product.height) || 0;

  if (/tower|trinest|luna|locus|cosmos|solar/.test(name) || height >= 75) {
    return "floor";
  }

  if (/z step|lack|cork|oblong|cylinder|stringray|seaweed|wave|scratch/.test(name)) {
    return "scratch";
  }

  if (/transparent|clear|透明/.test(name)) {
    return "transparent";
  }

  if (width >= 70 || height >= 60) {
    return "large";
  }

  return defaultProductCategory;
}

function getProductCategory(product) {
  return normalizeProductCategory(product.category) || inferProductCategory(product);
}

function formatDimension(value) {
  return Number.isInteger(value) ? value : value.toFixed(1);
}

function getProduct(productId) {
  return [...products, ...fixedProducts].find((entry) => entry.id === productId);
}

function getFixedProduct(productId) {
  return fixedProducts.find((entry) => entry.id === productId);
}

function loadManagerSession() {
  try {
    return sessionStorage.getItem(managerSessionKey) === "signed-in";
  } catch (error) {
    return false;
  }
}

function saveManagerSession(signedIn) {
  try {
    if (signedIn) {
      sessionStorage.setItem(managerSessionKey, "signed-in");
    } else {
      sessionStorage.removeItem(managerSessionKey);
    }
  } catch (error) {
    // Session storage can be blocked; the page still keeps the current login state.
  }
}

function showManagerLogin() {
  managerLoginError.hidden = true;
  managerPasswordInput.value = "";

  if (!managerLoginDialog.open) {
    managerLoginDialog.showModal();
  }

  managerUsernameInput.focus();
}

function updateManagerAccess() {
  // V156: keep only one tiny database entry on the page.
  // The 產品資料庫 button handles login through requireManager() when not signed in.
  databaseButtons.hidden = false;
  managerLoginButton.hidden = true;
  managerLogoutButton.hidden = true;
}

function requireManager() {
  if (managerSignedIn) {
    return true;
  }

  showManagerLogin();
  return false;
}

function setText(selector, value) {
  const element = document.querySelector(selector);

  if (element) {
    element.textContent = value;
  }
}

function setAllText(selector, values) {
  document.querySelectorAll(selector).forEach((element, index) => {
    if (values[index]) {
      element.textContent = values[index];
    }
  });
}

function syncProductCategoryTabs() {
  const catalogTabList = document.querySelector(".catalog-tabs");
  const catalogSection = document.querySelector(".catalog");
  const databaseGate = document.querySelector(".database-gate");

  productCategoryOrder.forEach((category) => {
    const catalogTab = catalogTabs.find((tab) => tab.dataset.category === category);
    const databaseTab = productDatabaseTabs.find((tab) => tab.dataset.category === category);

    if (catalogTab) {
      catalogTab.textContent = getProductCategoryLabel(category);
      catalogTabList?.append(catalogTab);
      const panel = document.querySelector(`#${catalogTab.getAttribute("aria-controls")}`);

      if (panel && databaseGate) {
        catalogSection.insertBefore(panel, databaseGate);
      }
    }

    if (databaseTab) {
      databaseTab.textContent = getProductCategoryLabel(category);
      databaseTab.draggable = false;
      productDatabaseTabs[0]?.parentElement?.append(databaseTab);
    }
  });
}

function refreshDatabaseCategorySelectOrder() {
  productDatabaseRows.querySelectorAll(".database-category").forEach((select) => {
    const selectedCategory = normalizeProductCategory(select.value) || defaultProductCategory;

    select.replaceChildren(
      ...productCategoryOrder.map((value) => {
        const option = document.createElement("option");

        option.value = value;
        option.textContent = getProductCategoryLabel(value);

        return option;
      }),
    );
    select.value = selectedCategory;
  });
}


function isMobilePlannerView() {
  return window.matchMedia("(max-width: 1180px), (hover: none) and (pointer: coarse)").matches;
}

function updateWallHintText() {
  if (!wallHint) {
    return;
  }

  wallHint.textContent = isMobilePlannerView() ? t("wallHintMobile") : t("wallHint");
}

function updateStaticLanguage() {
  document.documentElement.lang = currentLanguage === "ja" ? "ja" : "zh-Hant";
  document.title = t("appTitle");
  if (languageToggleButton) {
    languageToggleButton.textContent = t("switchLanguage");
  }
  wallSettingsToggleButton.textContent = wallSettingsCollapsed ? t("showSettings") : t("hideSettings");
  wallSettingsToggleButton.setAttribute("aria-expanded", String(!wallSettingsCollapsed));
  setText(".wall-fields p", t("wallSize"));
  setAllText(".wall-fields .field span", [t("width"), t("height")]);
  syncProductCategoryTabs();
  const popularTab = document.querySelector('#popularTab');
  if (popularTab) {
    popularTab.textContent = t('categoryPopular');
  }
  if (catalogTabPrevButton) {
    catalogTabPrevButton.setAttribute('aria-label', t('previousCategory'));
    catalogTabPrevButton.title = t('previousCategory');
  }
  if (catalogTabNextButton) {
    catalogTabNextButton.setAttribute('aria-label', t('nextCategory'));
    catalogTabNextButton.title = t('nextCategory');
  }
  updateCatalogTabScrollButtons();
  updateWallHintText();
  setText("#arTitle", t("arTitle"));
  arCalibrationHint.textContent = t("arCalibrate");
  captureArButton.textContent = t("captureAr");
  closeArButton.title = t("closeAr");
  closeArButton.setAttribute("aria-label", t("closeAr"));
  setAllText("#databaseButtons .database-button", [t("productDatabase")]);
  clearWallButton.textContent = t("clearWall");
  addWallToCartButton.textContent = t("addToCart");
  updateSelectionModeToggle();
  updateWallWorkbarToggle();
  updateFullscreenSidebarToggle();
  clearConfirmTitle.textContent = t("clearConfirm");
  confirmClearWallButton.textContent = t("yes");
  cancelClearWallButton.textContent = t("no");
  managerLoginButton.textContent = "管理資料庫";
  managerLogoutButton.textContent = t("logoutManager");
  setText("#databaseTitle", t("productDatabase"));
  setText("#productDatabaseDialog .database-bar p", t("productManagement"));
  setAllText("#productDatabaseDialog th", [
    t("image"),
    t("sortOrder"),
    t("productName"),
    t("category"),
    t("width"),
    t("height"),
    t("colorVariantIds"),
    t("flip"),
    t("visible"),
    t("actions"),
  ]);
  saveProductDatabaseButton.textContent = t("save");
  addDatabaseProductButton.textContent = t("addProduct");
  resetDatabaseProductsButton.textContent = t("resetProducts");
  setText("#managerLoginTitle", t("login"));
  setText("#managerLoginDialog .database-bar p", t("managerAccess"));
  setAllText("#managerLoginDialog label span", [t("account"), t("password")]);
  managerLoginError.textContent = t("loginError");
  setText("#managerRegisterButton", t("register"));
  setText("#managerLoginForm button[type='submit']", t("login"));
  setText("#furnitureDatabaseTitle", t("furnitureDatabase"));
  setText("#furnitureDatabaseDialog .database-bar p", t("furnitureManagement"));
  setAllText("#furnitureDatabaseDialog th", [
    t("image"),
    t("furnitureName"),
    t("width"),
    t("height"),
    t("actions"),
  ]);
  if (addDatabaseFurnitureButton) {
    addDatabaseFurnitureButton.textContent = t("addFurniture");
  }

  if (resetDatabaseFurnitureButton) {
    resetDatabaseFurnitureButton.textContent = t("resetFurniture");
  }
  document.querySelectorAll(".database-art option").forEach((option) => {
    const label = localizedFurnitureNames[currentLanguage]?.[option.value];

    if (label) {
      option.textContent = label;
    }
  });

  if (
    roomNameInput &&
    (roomNameInput.value === translations.zh.defaultRoom || roomNameInput.value === translations.ja.defaultRoom)
  ) {
    roomNameInput.value = t("defaultRoom");
  }
}

function updateWallSettingsState() {
  const controls = document.querySelector(".controls");

  controls?.classList.toggle("wall-settings-collapsed", wallSettingsCollapsed);
  wallSettingsToggleButton.textContent = wallSettingsCollapsed ? t("showSettings") : t("hideSettings");
  wallSettingsToggleButton.setAttribute("aria-expanded", String(!wallSettingsCollapsed));
  clearWallSettingsAutoHide();
  requestAnimationFrame(updateWallSize);
}

function clearWallSettingsAutoHide() {
  if (!wallSettingsAutoHideTimer) {
    return;
  }

  window.clearTimeout(wallSettingsAutoHideTimer);
  wallSettingsAutoHideTimer = null;
}

function isWallSettingsFieldActive() {
  const activeElement = document.activeElement;

  return Boolean(
    activeElement &&
      wallSettingsContent?.contains(activeElement) &&
      activeElement.matches("input, select, textarea, [contenteditable='true']"),
  );
}

function autoHideWallSettings() {
  wallSettingsAutoHideTimer = null;
  if (wallSettingsCollapsed) {
    return;
  }

  if (isWallSettingsFieldActive()) {
    scheduleWallSettingsAutoHide();
    return;
  }

  wallSettingsCollapsed = true;
  updateWallSettingsState();
}

function scheduleWallSettingsAutoHide() {
  clearWallSettingsAutoHide();
}

function refreshWallSettingsAutoHide() {
  clearWallSettingsAutoHide();
}

function applyLanguage() {
  updateStaticLanguage();
  updateFullscreenToggle();
  updateDimensionToggle();
  updateCoordinateToggle();
  updateWallSize();
  renderCatalog();
  renderPopularCombos();
  renderFixedProducts();
  renderProductDatabaseRows();
  renderFurnitureDatabaseRows();
  updateRoomName();
}

function copyFurnitureProduct(product) {
  return {
    id: String(product.id),
    name: String(product.name || "未命名家具"),
    width: clamp(Number(product.width) || 20, 1, 1200),
    height: clamp(Number(product.height) || 20, 1, 600),
    art: furnitureArts.includes(product.art) ? product.art : "sofa",
    image: String(product.image || ""),
  };
}

function defaultDatabaseFurniture() {
  return defaultFurnitureProducts.map(copyFurnitureProduct);
}

function loadFurnitureProducts() {
  try {
    if (localStorage.getItem(furnitureDatabaseVersionKey) !== furnitureDatabaseVersion) {
      localStorage.removeItem(furnitureDatabaseKey);
      localStorage.setItem(furnitureDatabaseVersionKey, furnitureDatabaseVersion);
      return defaultDatabaseFurniture();
    }

    const savedFurniture = JSON.parse(localStorage.getItem(furnitureDatabaseKey));

    return Array.isArray(savedFurniture) && savedFurniture.length > 0
      ? savedFurniture.filter((product) => product?.id).map(copyFurnitureProduct)
      : defaultDatabaseFurniture();
  } catch (error) {
    return defaultDatabaseFurniture();
  }
}

function saveFurnitureProducts() {
  try {
    localStorage.setItem(furnitureDatabaseKey, JSON.stringify(products));
    localStorage.setItem(furnitureDatabaseVersionKey, furnitureDatabaseVersion);
    return true;
  } catch (error) {
    window.alert("家具資料未儲存，請改用較小的圖片後再試一次。");
    return false;
  }
}

function copyFixedProduct(product) {
  const id = String(product.id);
  const name = String(product.name || "未命名產品");
  const width = clamp(Number(product.width) || 20, 1, productDimensionMax);
  const height = clamp(Number(product.height) || 20, 1, productDimensionMax);
  const sortOrder = clamp(Number(product.sortOrder) || 0, 0, 9999);

  if (isShapeObjectId(id)) {
    return {
      id,
      name,
      width,
      height,
      sortOrder,
      price: 0,
      shopifyVariantId: "",
      colorVariantIds: {},
      colorVariantPrices: {},
      colorImages: { transparent: shapeObjectImage },
      colors: ["transparent"],
      category: "transparent",
      image: shapeObjectImage,
      flippable: false,
      verticalFlippable: false,
      rotateOnVerticalFlip: false,
      mustDouble: false,
      visible: product.visible !== false,
      resizable: true,
    };
  }

  const shopifyVariantId = String(product.shopifyVariantId || product.variantId || "").trim();
  const colors = normalizeProductColors(product.colors || product.color);
  const colorVariantIds = normalizeColorVariantIds(product.colorVariantIds, shopifyVariantId, colors);
  const colorVariantPrices = normalizeColorVariantPrices(product.colorVariantPrices, product.price, colors);
  const colorImages = normalizeColorImages(product.colorImages, product.image, colors);
  const image = String(colorImages[colors[0]] || product.image || "");
  const price = clamp(Number(colorVariantPrices[colors[0]] || product.price) || 0, 0, 999999999);

  return {
    id,
    name,
    width,
    height,
    sortOrder,
    price,
    shopifyVariantId,
    colorVariantIds,
    colorVariantPrices,
    colorImages,
    colors,
    category: normalizeProductCategory(product.category) || inferProductCategory({ name, width, height }),
    image,
    flippable: Boolean(product.flippable),
    verticalFlippable: Boolean(product.verticalFlippable || product.verticalFlipped),
    rotateOnVerticalFlip: Boolean(product.rotateOnVerticalFlip),
    mustDouble: Boolean(product.mustDouble),
    visible: product.visible !== false,
    customizableSpan: Boolean(product.customizableSpan),
    minLengthCm: clamp(Number(product.minLengthCm) || 0, 0, productDimensionMax),
    maxLengthCm: clamp(Number(product.maxLengthCm) || 0, 0, productDimensionMax),
    defaultLengthCm: clamp(Number(product.defaultLengthCm) || 0, 0, productDimensionMax),
    spanVisualHeightCm: clamp(Number(product.spanVisualHeightCm) || 0, 0, productDimensionMax),
    resizable: Boolean(product.resizable) || isShapeObjectId(id),
  };
}

function defaultDatabaseProducts() {
  return defaultFixedProducts.map((product, index) => copyFixedProduct({
    ...product,
    sortOrder: product.sortOrder || index + 1,
  }));
}

function sortFixedProductList(productList) {
  return productList
    .map((product, index) => ({ product, index }))
    .sort((a, b) => {
      const orderA = Number(a.product.sortOrder) > 0 ? Number(a.product.sortOrder) : Number.POSITIVE_INFINITY;
      const orderB = Number(b.product.sortOrder) > 0 ? Number(b.product.sortOrder) : Number.POSITIVE_INFINITY;

      return orderA - orderB || a.index - b.index;
    })
    .map(({ product }) => product);
}

function removeDuplicateFixedProducts(productList) {
  const seenProducts = new Set();

  return productList.filter((product) => {
    if (product.id === "luna-wide") {
      return false;
    }

    const duplicateKey = [
      product.name.toLowerCase(),
      formatDimension(product.width),
      formatDimension(product.height),
      String(product.image).split("/").pop().toLowerCase(),
    ].join("|");

    if (seenProducts.has(duplicateKey)) {
      return false;
    }

    seenProducts.add(duplicateKey);
    return true;
  });
}

function loadFixedProducts() {
  try {
    if (localStorage.getItem(productDatabaseVersionKey) !== productDatabaseVersion) {
      localStorage.removeItem(productDatabaseKey);
      localStorage.setItem(productDatabaseVersionKey, productDatabaseVersion);
      return sortFixedProductList(removeDuplicateFixedProducts(defaultDatabaseProducts()));
    }

    const savedProducts = JSON.parse(localStorage.getItem(productDatabaseKey));

    if (!Array.isArray(savedProducts) || savedProducts.length === 0) {
      localStorage.setItem(productDatabaseVersionKey, productDatabaseVersion);
      return sortFixedProductList(removeDuplicateFixedProducts(defaultDatabaseProducts()));
    }

    const mergedProducts = new Map(defaultDatabaseProducts().map((product) => [product.id, product]));

    savedProducts
      .filter((product) => product?.id && product?.image)
      .map((product, index) => copyFixedProduct({
        ...product,
        sortOrder: product.sortOrder || index + 1,
      }))
      .forEach((product) => {
        const defaultProduct = mergedProducts.get(product.id);

        if (
          defaultProduct?.image?.endsWith("-cutout.png") &&
          /^assets\/.+\.jpg$/i.test(product.image)
        ) {
          product.image = defaultProduct.image;
        }

        mergedProducts.set(product.id, product);
      });

    const requiredDisplayNames = {
      "avenue-60": "Avenue M",
      "avenue-100": "Avenue L",
      "avenue-100 clear": "Avenue L clear",
    };

    Object.entries(requiredDisplayNames).forEach(([productId, productName]) => {
      const product = mergedProducts.get(productId);
      if (product) {
        product.name = productName;
      }
    });

    // Keep the latest Avenue walnut assets / variant IDs authoritative even when
    // an older product database is still cached in localStorage. This is scoped
    // only to Avenue M and Avenue L so other saved product data is preserved.
    const latestDefaultProducts = new Map(defaultDatabaseProducts().map((product) => [product.id, product]));
    ["avenue-60", "avenue-100"].forEach((productId) => {
      const product = mergedProducts.get(productId);
      const latest = latestDefaultProducts.get(productId);

      if (!product || !latest) {
        return;
      }

      product.colors = [...latest.colors];
      product.colorImages = { ...latest.colorImages };
      product.colorVariantIds = Object.fromEntries(
        Object.entries(latest.colorVariantIds).map(([color, ids]) => [
          color,
          ids && typeof ids === "object" ? { ...ids } : ids,
        ]),
      );
      product.colorVariantPrices = { ...latest.colorVariantPrices };
      product.image = latest.image;
      product.price = latest.price;
      product.shopifyVariantId = latest.shopifyVariantId;
    });

    return sortFixedProductList(removeDuplicateFixedProducts([...mergedProducts.values()]));
  } catch (error) {
    return sortFixedProductList(removeDuplicateFixedProducts(defaultDatabaseProducts()));
  }
}

function saveFixedProducts() {
  try {
    localStorage.setItem(productDatabaseKey, JSON.stringify(fixedProducts));
    localStorage.setItem(productDatabaseVersionKey, productDatabaseVersion);
    return true;
  } catch (error) {
    window.alert("產品資料未儲存，請改用較小的圖片後再試一次。");
    return false;
  }
}


function getPopularComboProductColor(product, requestedColor) {
  const normalized = normalizeProductColor(requestedColor);
  return normalizeProductColors(product?.colors).includes(normalized)
    ? normalized
    : getPrimaryProductColor(product);
}

function createPopularComboPlacedItem(itemDefinition, dimensions) {
  const product = getFixedProduct(itemDefinition.productId);

  if (!product) {
    return null;
  }

  const baseWidthCm = isCustomSpanProduct(product)
    ? getCustomSpanConfig(product).defaultLength
    : Number(product.width) || 1;
  const baseHeightCm = isCustomSpanProduct(product)
    ? getCustomSpanConfig(product).visualHeight
    : Number(product.height) || 1;
  const shouldRotate = Boolean(itemDefinition.verticalFlipped && product.rotateOnVerticalFlip);
  const widthCm = shouldRotate ? baseHeightCm : baseWidthCm;
  const heightCm = shouldRotate ? baseWidthCm : baseHeightCm;
  const leftCm = Math.max(0, Number(itemDefinition.leftCm) || 0);
  const bottomCm = Math.max(0, Number(itemDefinition.bottomCm) || 0);
  const maxLeftCm = Math.max(0, dimensions.width - widthCm);
  const maxTopCm = Math.max(0, dimensions.height - heightCm);
  const topCm = dimensions.height - bottomCm - heightCm;

  return {
    key: crypto.randomUUID(),
    productId: product.id,
    widthCm,
    heightCm,
    spanLengthCm: isCustomSpanProduct(product) ? getCustomSpanConfig(product).defaultLength : undefined,
    spanAngleDeg: 0,
    color: getPopularComboProductColor(product, itemDefinition.color),
    flipped: itemDefinition.direction === "right",
    verticalFlipped: Boolean(itemDefinition.verticalFlipped && !product.rotateOnVerticalFlip),
    rotated: shouldRotate,
    xRatio: clamp(Math.min(leftCm, maxLeftCm) / dimensions.width, 0, 1),
    yRatio: clamp(Math.min(Math.max(0, topCm), maxTopCm) / dimensions.height, 0, 1),
    popularComboId: itemDefinition.comboId || "",
  };
}

function importPopularCombo(combo, anchor = null) {
  if (!combo || !Array.isArray(combo.items)) {
    return;
  }

  const preserveExisting = window.confirm(t("comboPreservePrompt", combo.title));

  if (!preserveExisting) {
    placedItems = [];
    selectedItemKey = null;
    selectedItemKeys = new Set();
    hiddenActionWheelKey = null;
    wallWidthInput.value = clamp(Number(combo.wallWidth) || 420, 50, 1000);
    wallHeightInput.value = clamp(Number(combo.wallHeight) || 260, 50, 1000);
    currentWallDimensions = {
      width: Number(wallWidthInput.value),
      height: Number(wallHeightInput.value),
    };
    updateWallSize();
  }

  const dimensions = getDimensions();
  const importedItems = [];
  const missingNames = [];

  combo.items.forEach((itemDefinition) => {
    const product = getFixedProduct(itemDefinition.productId);

    if (!product) {
      missingNames.push(itemDefinition.productId);
      return;
    }

    const quantity = Math.max(1, Math.floor(Number(itemDefinition.quantity) || 1));

    for (let index = 0; index < quantity; index += 1) {
      const item = createPopularComboPlacedItem({ ...itemDefinition, comboId: combo.id }, dimensions);
      if (item) {
        importedItems.push(item);
      }
    }
  });

  if (importedItems.length === 0) {
    if (missingNames.length > 0) {
      window.alert(missingNames.map((name) => t("comboMissingProduct", name)).join("\n"));
    }
    return;
  }

  placedItems = [...placedItems, ...importedItems];
  selectedItemKey = importedItems[importedItems.length - 1].key;
  selectedItemKeys = new Set(importedItems.map((item) => item.key));
  hiddenActionWheelKey = null;
  renderPlacedItems();
  countItems();
  showAddedToast(anchor);

  if (missingNames.length > 0) {
    window.alert(missingNames.map((name) => t("comboMissingProduct", name)).join("\n"));
  }
}

function renderPopularCombos() {
  const container = document.querySelector("#popularComboItems");

  if (!container) {
    return;
  }

  container.replaceChildren();
  container.classList.toggle("has-combos", popularCombos.length > 0);

  if (popularCombos.length === 0) {
    const emptyState = document.createElement("div");
    const title = document.createElement("strong");
    const copy = document.createElement("p");

    emptyState.className = "popular-combo-empty";
    title.textContent = t("popularComingSoonTitle");
    copy.textContent = t("popularComingSoonCopy");
    emptyState.append(title, copy);
    container.append(emptyState);
    return;
  }

  popularCombos.forEach((combo) => {
    const card = document.createElement("article");
    const image = document.createElement("img");
    const copy = document.createElement("div");
    const titleRow = document.createElement("div");
    const title = document.createElement("strong");
    const addButton = document.createElement("button");
    const meta = document.createElement("div");
    const size = document.createElement("small");
    const price = document.createElement("small");

    card.className = "catalog-item fixed-product popular-combo-card";
    card.dataset.comboId = combo.id;
    card.draggable = false;

    image.className = "catalog-image";
    image.src = combo.image;
    image.alt = combo.title;
    image.width = 120;
    image.height = 120;

    copy.className = "catalog-copy";
    titleRow.className = "catalog-title";
    title.textContent = combo.title;

    addButton.type = "button";
    addButton.className = "catalog-add";
    addButton.textContent = "+";
    addButton.title = `${t("importCombo")}：${combo.title}`;
    addButton.setAttribute("aria-label", `${t("importCombo")}：${combo.title}`);
    addButton.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      importPopularCombo(combo, event.currentTarget);
    });

    meta.className = "popular-combo-meta";
    size.className = "popular-combo-size";
    size.textContent = t("comboWallSize", formatDimension(combo.wallWidth), formatDimension(combo.wallHeight));
    price.className = "popular-combo-price";
    price.textContent = formatPrice(combo.price);

    titleRow.append(title, addButton);
    meta.append(size, price);
    copy.append(titleRow, meta);
    card.append(image, copy);
    container.append(card);
  });
}

function updateCatalogTabScrollButtons() {
  if (!catalogTabList) {
    return;
  }

  const maxScrollLeft = Math.max(0, catalogTabList.scrollWidth - catalogTabList.clientWidth);
  const currentScrollLeft = Math.max(0, catalogTabList.scrollLeft);
  const hasOverflow = maxScrollLeft > 2;

  if (catalogTabPrevButton) {
    catalogTabPrevButton.disabled = !hasOverflow || currentScrollLeft <= 2;
  }
  if (catalogTabNextButton) {
    catalogTabNextButton.disabled = !hasOverflow || currentScrollLeft >= maxScrollLeft - 2;
  }
}

function scrollCatalogTabs(direction) {
  if (!catalogTabList) {
    return;
  }

  const distance = Math.max(96, Math.round(catalogTabList.clientWidth * 0.68));
  catalogTabList.scrollBy({
    left: direction * distance,
    behavior: "smooth",
  });

  window.setTimeout(updateCatalogTabScrollButtons, 260);
}

function selectCatalogTab(selectedTab) {
  catalogTabs.forEach((tab) => {
    const selected = tab === selectedTab;
    const panel = document.querySelector(`#${tab.getAttribute("aria-controls")}`);

    tab.classList.toggle("active", selected);
    tab.setAttribute("aria-selected", selected);
    tab.tabIndex = selected ? 0 : -1;
    if (panel) {
      panel.hidden = !selected;
    }
  });

  selectedTab?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
  window.setTimeout(updateCatalogTabScrollButtons, 220);
}

function updateProductDatabaseTabRows() {
  productDatabaseRows.querySelectorAll(".database-row").forEach((row) => {
    row.hidden = row.dataset.category !== activeProductDatabaseCategory;
  });
}

function selectProductDatabaseTab(selectedTab) {
  const category = normalizeProductCategory(selectedTab.dataset.category) || defaultProductCategory;

  activeProductDatabaseCategory = category;
  productDatabaseTabs.forEach((tab) => {
    const selected = tab === selectedTab;

    tab.classList.toggle("active", selected);
    tab.setAttribute("aria-selected", selected);
    tab.tabIndex = selected ? 0 : -1;
  });
  updateProductDatabaseTabRows();
}

function moveProductCategory(movingCategory, targetCategory, placeAfter = false) {
  if (!movingCategory || !targetCategory || movingCategory === targetCategory) {
    return false;
  }

  const nextOrder = productCategoryOrder.filter((category) => category !== movingCategory);
  const targetIndex = nextOrder.indexOf(targetCategory);

  if (targetIndex === -1) {
    return false;
  }

  nextOrder.splice(targetIndex + (placeAfter ? 1 : 0), 0, movingCategory);
  productCategoryOrder = normalizeProductCategoryOrder(nextOrder);
  syncProductCategoryTabs();
  refreshDatabaseCategorySelectOrder();
  return true;
}

function startProductCategoryPointerDrag(event) {
  if (event.pointerType === "mouse" && event.button !== 0) {
    return;
  }

  const tab = event.currentTarget;
  const category = normalizeProductCategory(tab.dataset.category);

  if (!category) {
    return;
  }

  productCategoryPointer = {
    id: event.pointerId,
    startX: event.clientX,
    startY: event.clientY,
    category,
    tab,
    dragging: false,
  };
  tab.dataset.dragSuppress = "";
  tab.setPointerCapture?.(event.pointerId);
}

function getProductCategoryDropTarget(clientX, clientY, movingCategory) {
  const tabs = productCategoryOrder
    .map((category) => productDatabaseTabs.find((tab) => tab.dataset.category === category))
    .filter((tab) => tab && tab.dataset.category !== movingCategory);

  if (tabs.length === 0) {
    return null;
  }

  const closest = tabs
    .map((tab) => {
      const bounds = tab.getBoundingClientRect();
      const closestX = clamp(clientX, bounds.left, bounds.right);
      const closestY = clamp(clientY, bounds.top, bounds.bottom);

      return {
        tab,
        bounds,
        distance: Math.hypot(clientX - closestX, clientY - closestY),
      };
    })
    .sort((a, b) => a.distance - b.distance)[0];

  if (!closest) {
    return null;
  }

  const sameRow = clientY >= closest.bounds.top && clientY <= closest.bounds.bottom;
  const placeAfter = sameRow
    ? clientX > closest.bounds.left + closest.bounds.width / 2
    : clientY > closest.bounds.top + closest.bounds.height / 2;

  return {
    category: normalizeProductCategory(closest.tab.dataset.category),
    placeAfter,
  };
}

function moveProductCategoryPointerDrag(event) {
  if (!productCategoryPointer || productCategoryPointer.id !== event.pointerId) {
    return;
  }

  const movedDistance = Math.hypot(
    event.clientX - productCategoryPointer.startX,
    event.clientY - productCategoryPointer.startY,
  );

  if (!productCategoryPointer.dragging && movedDistance < 8) {
    return;
  }

  if (!productCategoryPointer.dragging) {
    productCategoryPointer.dragging = true;
    productCategoryPointer.tab.classList.add("dragging");
  }

  event.preventDefault();
  const dropTarget = getProductCategoryDropTarget(
    event.clientX,
    event.clientY,
    productCategoryPointer.category,
  );

  if (!dropTarget?.category || dropTarget.category === productCategoryPointer.category) {
    return;
  }

  if (moveProductCategory(productCategoryPointer.category, dropTarget.category, dropTarget.placeAfter)) {
    productCategoryPointer.tab.classList.add("dragging");
  }
}

function finishProductCategoryPointerDrag(event) {
  if (!productCategoryPointer || productCategoryPointer.id !== event.pointerId) {
    return;
  }

  const wasDragging = productCategoryPointer.dragging;
  const draggedTab = productCategoryPointer.tab;

  draggedTab.releasePointerCapture?.(event.pointerId);
  productDatabaseTabs.forEach((tab) => tab.classList.remove("dragging"));
  productCategoryPointer = null;

  if (wasDragging) {
    event.preventDefault();
    draggedTab.dataset.dragSuppress = "true";
    window.setTimeout(() => {
      draggedTab.dataset.dragSuppress = "";
    }, 0);
    saveProductCategoryOrder();
  }
}

function updateCatalogProduct(node, product) {
  const sizeText = getProductSizeText(product);
  const productName = getDisplayName(product);

  node.querySelector("small").textContent = sizeText;
  node.setAttribute("aria-label", `${productName}，${sizeText}，${t("dragToWall")}`);
}

function updateFixedProductCard(node, product) {
  const sizeText = getProductSizeText(product);
  const productName = getDisplayName(product);

  if (isShapeObjectProduct(product)) {
    const details = node.querySelector("small");

    if (details) {
      details.textContent = sizeText;
    }
    node.setAttribute("aria-label", `${productName}，${sizeText}，${t("addToWall")}`);
    return;
  }

  const colors = normalizeProductColors(product.colors);
  const priceText = getProductPriceSummary(product);
  const colorText = `${t("color")} ${colors.map(getProductColorLabel).join(" / ")}`;
  const details = node.querySelector("small");

  if (details) {
    details.innerHTML = `
      ${sizeText}<br>
      <span class="product-color-line">${colorText}</span><br>
      ${priceText}
    `;
  }
  node.setAttribute("aria-label", `${productName}，${sizeText}，${colorText}，${priceText}，${t("addToWall")}`);
}


function updateShapeProductDimension(event, node, product, dimension) {
  const fallback = Number(product[dimension]) || 60;
  const nextValue = clamp(Number(event.currentTarget.value) || fallback, 1, productDimensionMax);

  product[dimension] = nextValue;
  event.currentTarget.value = nextValue;
  updateFixedProductCard(node, product);
  updatePlacedDatabaseProduct(product);
  saveFixedProducts();
  renderPlacedItems();
}

function updateShapeProductName(event, node, product) {
  const nextName = event.currentTarget.value;
  const addButton = node.querySelector(".catalog-add");
  const image = node.querySelector(".catalog-image");

  product.name = nextName;
  node.querySelector("strong").textContent = getDisplayName(product);
  image.alt = getDisplayName(product);
  addButton.title = `${t("addToWall")}：${getDisplayName(product)}`;
  addButton.setAttribute("aria-label", `${t("addToWall")}：${getDisplayName(product)}`);
  updateFixedProductCard(node, product);
  saveFixedProducts();
  renderPlacedItems();
}

function commitShapeProductName(event, node, product) {
  const nextName = event.currentTarget.value.trim() || "家具配件";

  event.currentTarget.value = nextName;
  product.name = nextName;
  updateShapeProductName(event, node, product);
}

function createShapeProductFields(node, product) {
  const copy = node.querySelector(".catalog-copy");
  const small = node.querySelector("small");
  const fields = document.createElement("div");

  fields.className = "product-fields fixed-shape-fields";
  fields.innerHTML = `
    <label class="shape-name-field">
      <span>${t("objectName")}</span>
      <input class="product-name" type="text" maxlength="24" />
    </label>
    <label>
      <span>${t("width")}</span>
      <input class="product-width" type="number" min="1" max="${productDimensionMax}" step="1" />
    </label>
    <label>
      <span>${t("height")}</span>
      <input class="product-height" type="number" min="1" max="${productDimensionMax}" step="1" />
    </label>
  `;

  const nameInput = fields.querySelector(".product-name");
  const widthInput = fields.querySelector(".product-width");
  const heightInput = fields.querySelector(".product-height");

  nameInput.value = product.name;
  widthInput.value = product.width;
  heightInput.value = product.height;
  nameInput.addEventListener("input", (event) => updateShapeProductName(event, node, product));
  nameInput.addEventListener("change", (event) => commitShapeProductName(event, node, product));
  widthInput.addEventListener("change", (event) => updateShapeProductDimension(event, node, product, "width"));
  heightInput.addEventListener("change", (event) => updateShapeProductDimension(event, node, product, "height"));
  copy.insertBefore(fields, small);
  small.remove();
}

function updateProductDimension(event, node, product, dimension) {
  const limit = dimension === "width" ? 1200 : 600;
  const fallback = product[dimension];
  const nextValue = clamp(Number(event.currentTarget.value) || fallback, 20, limit);

  product[dimension] = nextValue;
  event.currentTarget.value = nextValue;
  updateCatalogProduct(node, product);
  saveFurnitureProducts();
}

function renderCatalog() {
  if (!catalogItems) {
    return;
  }

  catalogItems.replaceChildren();

  products.forEach((product) => {
    const node = catalogTemplate.content.firstElementChild.cloneNode(true);
    const art = node.querySelector(".product-art");
    const widthInput = node.querySelector(".product-width");
    const heightInput = node.querySelector(".product-height");
    const addButton = node.querySelector(".catalog-add");

    node.dataset.productId = product.id;
    if (product.image) {
      const image = document.createElement("img");

      image.className = "furniture-image";
      image.draggable = false;
      image.setAttribute("draggable", "false");
      image.src = product.image;
      image.alt = product.name;
      art.replaceWith(image);
    } else {
      art.classList.add(product.art);
    }
    const productName = getDisplayName(product);

    node.querySelector("strong").textContent = productName;
    widthInput.value = product.width;
    heightInput.value = product.height;
    addButton.title = `${t("addToWall")}：${productName}`;
    addButton.setAttribute("aria-label", `${t("addToWall")}：${productName}`);
    updateCatalogProduct(node, product);

    node.addEventListener("dragstart", (event) => {
      if (isMobileCatalogDragDisabled(event)) {
        event.preventDefault();
        return;
      }

      event.dataTransfer.setData("text/product", product.id);
      event.dataTransfer.effectAllowed = "copy";
    });

    node.addEventListener("pointerdown", (event) => startCatalogDrag(event, node, product));
    addButton.addEventListener("pointerdown", (event) => {
      event.stopPropagation();
    });
    addButton.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      addProductFromCatalog(product.id, event.currentTarget);
    });
    widthInput.addEventListener("change", (event) => {
      updateProductDimension(event, node, product, "width");
    });
    heightInput.addEventListener("change", (event) => {
      updateProductDimension(event, node, product, "height");
    });

    catalogItems.append(node);
  });
}

function renderFixedProducts() {
  const containers = productItemContainers.length > 0 ? productItemContainers : [];

  containers.forEach((container) => container.replaceChildren());

  sortFixedProductList(fixedProducts).filter((product) => product.visible !== false).forEach((product) => {
    const node = fixedProductTemplate.content.firstElementChild.cloneNode(true);
    const image = node.querySelector(".catalog-image");
    const addButton = node.querySelector(".catalog-add");
    const category = getProductCategory(product);
    const productItems = containers.find((container) => container.dataset.category === category) || containers[0];

    if (!productItems) {
      return;
    }

    node.dataset.productId = product.id;
    node.classList.toggle("shape-product", isShapeObjectProduct(product));
    if (!isShapeObjectProduct(product) && !hasProductColorImage(product, getPrimaryProductColor(product))) {
      image.classList.add(`product-tone-${getPrimaryProductColor(product)}`);
    }
    image.src = getProductImageForColor(product, getPrimaryProductColor(product));
    image.alt = product.name;
    const productName = getDisplayName(product);

    node.querySelector("strong").textContent = productName;
    addButton.title = `${t("addToWall")}：${productName}`;
    addButton.setAttribute("aria-label", `${t("addToWall")}：${productName}`);
    updateFixedProductCard(node, product);
    if (isShapeObjectProduct(product)) {
      createShapeProductFields(node, product);
    }

    node.addEventListener("dragstart", (event) => {
      if (isMobileCatalogDragDisabled(event)) {
        event.preventDefault();
        return;
      }

      event.dataTransfer.setData("text/product", product.id);
      event.dataTransfer.effectAllowed = "copy";
    });
    node.addEventListener("pointerdown", (event) => startCatalogDrag(event, node, product));
    addButton.addEventListener("pointerdown", (event) => {
      event.stopPropagation();
    });
    addButton.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      addProductFromCatalog(product.id, event.currentTarget);
    });

    productItems.append(node);
  });
}

function readImageFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.addEventListener("load", () => resolve(String(reader.result)));
    reader.addEventListener("error", reject);
    reader.readAsDataURL(file);
  });
}

function updatePlacedDatabaseProduct(product) {
  placedItems.forEach((item) => {
    if (item.productId === product.id) {
      item.widthCm = product.width;
      item.heightCm = product.height;
      if (getFixedProduct(product.id)) {
        item.color = getPlacedProductColor(product, item);
      }
    }
  });
}

function refreshProductDatabase() {
  saveFixedProducts();
  renderFixedProducts();
  renderPlacedItems();
  renderProductDatabaseRows();
}

function deleteDatabaseProduct(productId) {
  if (!requireManager()) {
    return;
  }

  fixedProducts = fixedProducts.filter((product) => product.id !== productId);
  placedItems = placedItems.filter((item) => item.productId !== productId);
  refreshProductDatabase();
}

function getDatabaseColorVariantInput(row, color) {
  return [...row.querySelectorAll(".database-color-variant")]
    .find((input) => input.dataset.color === color);
}

function getDatabaseSelectedColors(row) {
  return normalizeProductColors(
    [...row.querySelectorAll(".database-color")]
      .filter((input) => input.checked)
      .map((input) => input.value),
  );
}

function updateDatabasePreviewFromFirstColor(row) {
  const preview = row.querySelector(".database-preview");
  const firstColor = getDatabaseSelectedColors(row)[0];
  const firstColorInput = row.querySelector(`.database-color-image[data-color="${firstColor}"]`);
  const firstColorPreview = firstColorInput?.closest(".database-color-option")?.querySelector(".database-color-image-preview");
  const firstColorImage = firstColorInput?.dataset.image || (firstColorPreview && !firstColorPreview.hidden ? firstColorPreview.src : "");

  if (firstColorImage) {
    preview.src = firstColorImage;
  } else {
    preview.removeAttribute("src");
  }
}

async function syncDatabaseRowVariantPrices(row) {
  const selectedColors = getDatabaseSelectedColors(row);
  const colorVariantPrices = {};

  for (const color of Object.keys(productColors)) {
    const variantInput = getDatabaseColorVariantInput(row, color);

    if (!variantInput) {
      continue;
    }

    const variantId = variantInput.value.trim();
    let price = clamp(Number(variantInput.dataset.price) || 0, 0, 999999999);

    if (variantId && price === 0) {
      price = await fetchVariantPrice(variantId);
      variantInput.dataset.price = String(price);
    }

    const priceLabel = variantInput.closest(".database-color-option")?.querySelector(".database-color-price");

    if (priceLabel) {
      priceLabel.textContent = selectedColors.includes(color) ? `${formatPrice(price)}` : "";
    }

    if (price > 0) {
      colorVariantPrices[color] = price;
    }
  }

  return normalizeColorVariantPrices(colorVariantPrices, 0, selectedColors);
}

async function readDatabaseRowProduct(row) {
  const nameInput = row.querySelector(".database-name");
  const sortInput = row.querySelector(".database-sort");
  const widthInput = row.querySelector(".database-width");
  const heightInput = row.querySelector(".database-height");
  const categoryInput = row.querySelector(".database-category");
  const colorInputs = [...row.querySelectorAll(".database-color")];
  const flippableInput = row.querySelector(".database-flippable");
  const visibleInput = row.querySelector(".database-visible");
  const width = clamp(Number(widthInput.value) || 20, 1, productDimensionMax);
  const height = clamp(Number(heightInput.value) || 20, 1, productDimensionMax);
  const sortOrder = clamp(Number(sortInput.value) || 0, 0, 9999);
  const colors = normalizeProductColors(
    colorInputs.filter((input) => input.checked).map((input) => input.value),
  );
  const colorVariantIds = normalizeColorVariantIds(
    Object.fromEntries(
      [...row.querySelectorAll(".database-color-variant")].map((input) => [
        input.dataset.color,
        input.value,
      ]),
    ),
    "",
    colors,
  );
  const colorVariantPrices = await syncDatabaseRowVariantPrices(row);
  const price = clamp(Number(colorVariantPrices[colors[0]]) || 0, 0, 999999999);
  const colorImages = {};
  for (const input of row.querySelectorAll(".database-color-image")) {
    const color = input.dataset.color;
    const file = input.files[0];
    const savedImage = input.dataset.image || "";

    if (file) {
      colorImages[color] = await readImageFile(file);
    } else if (savedImage) {
      colorImages[color] = savedImage;
    }
  }
  const name = nameInput.value.trim();

  if (!name) {
    nameInput.focus();
    return null;
  }

  const image = colorImages[colors[0]] || "";

  if (!image) {
    row.querySelector(`.database-color-image[data-color="${colors[0]}"]`)?.focus();
    return null;
  }

  return copyFixedProduct({
    id: row.dataset.productId,
    name,
    width,
    height,
    sortOrder,
    price,
    colorVariantIds,
    colorVariantPrices,
    colorImages,
    category: normalizeProductCategory(categoryInput.value) || defaultProductCategory,
    colors,
    image,
    flippable: flippableInput.checked,
    visible: visibleInput ? visibleInput.checked : true,
  });
}

async function saveProductDatabasePage() {
  if (!requireManager()) {
    return;
  }

  const rows = [...productDatabaseRows.querySelectorAll(".database-row")];
  const nextProducts = [];

  for (const row of rows) {
    const product = await readDatabaseRowProduct(row);

    if (!product) {
      return;
    }

    nextProducts.push(product);
  }

  fixedProducts = sortFixedProductList(nextProducts);
  placedItems = placedItems.filter((item) => getProduct(item.productId));
  fixedProducts.forEach(updatePlacedDatabaseProduct);
  refreshProductDatabase();
}

function renderProductColorOptions(row, selectedColors, colorVariantIds = {}, colorImages = {}, colorVariantPrices = {}) {
  const colorOptions = row.querySelector(".database-color-options");

  if (isShapeObjectId(row.dataset.productId)) {
    const note = document.createElement("span");

    note.className = "database-shape-note";
    note.textContent = "可直接輸入寬高，不使用顏色、價格或 Variant ID。";
    colorOptions.replaceChildren(note);
    return;
  }

  const colorSet = new Set(normalizeProductColors(selectedColors));
  const variantIds = normalizeColorVariantIds(colorVariantIds, "", selectedColors);
  const images = normalizeColorImages(colorImages, "", selectedColors);
  const variantPrices = normalizeColorVariantPrices(colorVariantPrices, 0, selectedColors);

  colorOptions.replaceChildren(
    ...Object.entries(productColors).map(([value, color]) => {
      const label = document.createElement("label");
      const colorInfo = document.createElement("span");
      const variantTools = document.createElement("span");
      const imageTools = document.createElement("span");
      const input = document.createElement("input");
      const swatch = document.createElement("span");
      const text = document.createElement("span");
      const variantInput = document.createElement("input");
      const variantPrice = document.createElement("span");
      const imagePreview = document.createElement("img");
      const imageInput = document.createElement("input");

      label.className = "database-color-option";
      colorInfo.className = "database-color-main";
      variantTools.className = "database-color-variant-tools";
      imageTools.className = "database-color-image-tools";
      input.className = "database-color";
      input.type = "checkbox";
      input.value = value;
      input.checked = colorSet.has(value);
      input.addEventListener("change", () => {
        syncDatabaseRowVariantPrices(row);
        updateDatabasePreviewFromFirstColor(row);
      });
      swatch.className = "database-color-preview";
      swatch.style.background = color.swatch;
      text.textContent = getProductColorLabel(value);
      variantInput.className = "database-color-variant";
      variantInput.type = "text";
      variantInput.inputMode = "numeric";
      variantInput.placeholder = "Variant ID";
      variantInput.value = variantIds[value] || "";
      variantInput.dataset.color = value;
      variantInput.dataset.price = variantPrices[value] || "";
      variantInput.setAttribute("aria-label", `${getProductColorLabel(value)} Shopify Variant ID`);
      variantInput.addEventListener("change", () => {
        variantInput.dataset.price = "";
        syncDatabaseRowVariantPrices(row);
      });
      variantPrice.className = "database-color-price";
      variantPrice.textContent = colorSet.has(value) ? `${formatPrice(variantPrices[value] || 0)}` : "";
      imagePreview.className = "database-color-image-preview";
      imagePreview.alt = `${getProductColorLabel(value)}${t("image")}`;
      if (images[value]) {
        imagePreview.src = images[value];
      } else {
        imagePreview.hidden = true;
      }
      imageInput.className = "database-color-image";
      imageInput.type = "file";
      imageInput.accept = "image/png,image/jpeg,image/webp";
      imageInput.dataset.color = value;
      imageInput.dataset.image = images[value] || "";
      imageInput.setAttribute("aria-label", `${getProductColorLabel(value)}${t("replaceImage")}`);
      imageInput.addEventListener("change", () => {
        const file = imageInput.files[0];

        if (file) {
          const objectUrl = URL.createObjectURL(file);

          imagePreview.src = objectUrl;
          imagePreview.hidden = false;
          if (getDatabaseSelectedColors(row)[0] === value) {
            row.querySelector(".database-preview").src = objectUrl;
          }
        }
      });
      colorInfo.append(input, swatch, text);
      variantTools.append(variantInput, variantPrice);
      imageTools.append(imagePreview, imageInput);
      label.append(colorInfo, variantTools, imageTools);

      return label;
    }),
  );
}

function renderProductCategoryOptions(row, selectedCategory) {
  const categorySelect = row.querySelector(".database-category");
  const category = normalizeProductCategory(selectedCategory) || defaultProductCategory;

  categorySelect.replaceChildren(
    ...productCategoryOrder.map((value) => {
      const option = document.createElement("option");

      option.value = value;
      option.textContent = getProductCategoryLabel(value);

      return option;
    }),
  );
  categorySelect.value = category;
}

function createDatabaseRow(product) {
  const row = databaseRowTemplate.content.firstElementChild.cloneNode(true);
  const preview = row.querySelector(".database-preview");
  const deleteButton = row.querySelector(".database-delete");
  const isShapeObject = isShapeObjectProduct(product);

  row.dataset.productId = product.id;
  row.classList.toggle("shape-database-row", isShapeObject);
  const toggleLabels = row.querySelectorAll(".database-toggle span");
  if (toggleLabels[0]) {
    toggleLabels[0].textContent = t("horizontal");
  }
  if (toggleLabels[1]) {
    toggleLabels[1].textContent = t("visible");
  }
  deleteButton.textContent = t("delete");
  row.querySelector(".database-sort").value = product.sortOrder || "";
  row.querySelector(".database-name").value = product.name || "";
  renderProductCategoryOptions(row, getProductCategory(product));
  row.dataset.category = getProductCategory(product);
  row.querySelector(".database-category").addEventListener("change", (event) => {
    row.dataset.category = normalizeProductCategory(event.currentTarget.value) || defaultProductCategory;
    updateProductDatabaseTabRows();
  });
  row.querySelector(".database-width").value = product.width || "";
  row.querySelector(".database-height").value = product.height || "";
  renderProductColorOptions(
    row,
    normalizeProductColors(product.colors),
    product.colorVariantIds,
    product.colorImages,
    product.colorVariantPrices,
  );
  row.querySelector(".database-flippable").checked = !isShapeObject && Boolean(product.flippable);
  row.querySelector(".database-flippable").disabled = isShapeObject;
  const visibleInput = row.querySelector(".database-visible");
  if (visibleInput) {
    visibleInput.checked = product.visible !== false;
  }
  updateDatabasePreviewFromFirstColor(row);
  syncDatabaseRowVariantPrices(row);
  preview.alt = product.name ? `${product.name}${t("image")}` : t("image");
  deleteButton.addEventListener("click", () => {
    row.remove();
  });

  return row;
}

function renderProductDatabaseRows() {
  productDatabaseRows.replaceChildren(...sortFixedProductList(fixedProducts).map(createDatabaseRow));
  updateProductDatabaseTabRows();
}

function addDatabaseProductRow() {
  if (!requireManager()) {
    return;
  }

  const row = createDatabaseRow({
    id: `product-${crypto.randomUUID()}`,
    name: "",
    width: 20,
    height: 20,
    sortOrder: Math.max(0, ...fixedProducts.map((product) => Number(product.sortOrder) || 0)) + 1,
    price: 0,
    colorVariantIds: {},
    colorVariantPrices: {},
    colorImages: {},
    color: defaultProductColor,
    category: activeProductDatabaseCategory,
    image: "",
    flippable: false,
    visible: true,
  });

  productDatabaseRows.prepend(row);
  row.querySelector(".database-name").focus();
}

function refreshFurnitureDatabase() {
  saveFurnitureProducts();
  renderCatalog();
  renderPlacedItems();
  renderFurnitureDatabaseRows();
}

function deleteDatabaseFurniture(productId) {
  if (!requireManager()) {
    return;
  }

  products = products.filter((product) => product.id !== productId);
  placedItems = placedItems.filter((item) => item.productId !== productId);
  refreshFurnitureDatabase();
}

function updateFurnitureArtPreview(preview, art, image) {
  preview.className = `database-art-preview${image ? "" : ` product-art ${art}`}`;
  preview.style.backgroundImage = image ? `url("${image}")` : "";
  preview.style.backgroundPosition = image ? "center" : "";
  preview.style.backgroundRepeat = image ? "no-repeat" : "";
  preview.style.backgroundSize = image ? "contain" : "";
}

function previewFurnitureImage(productId, image) {
  const product = products.find((entry) => entry.id === productId);

  if (!product || !image) {
    return;
  }

  product.image = image;
  renderCatalog();
  renderPlacedItems();
}

async function saveFurnitureDatabaseRow(row, currentProduct) {
  if (!requireManager()) {
    return;
  }

  const nameInput = row.querySelector(".database-name");
  const widthInput = row.querySelector(".database-width");
  const heightInput = row.querySelector(".database-height");
  const artInput = row.querySelector(".database-art");
  const name = nameInput.value.trim();

  if (!name) {
    nameInput.focus();
    return;
  }

  const image = row.furnitureImagePromise
    ? await row.furnitureImagePromise
    : row.furnitureImage || currentProduct.image;
  const product = copyFurnitureProduct({
    ...currentProduct,
    name,
    width: widthInput.value,
    height: heightInput.value,
    art: artInput.value,
    image,
  });
  const existingIndex = products.findIndex((entry) => entry.id === product.id);

  if (existingIndex === -1) {
    products = [...products, product];
  } else {
    products[existingIndex] = product;
    updatePlacedDatabaseProduct(product);
  }

  refreshFurnitureDatabase();
}

function createFurnitureDatabaseRow(product) {
  const row = furnitureDatabaseRowTemplate.content.firstElementChild.cloneNode(true);
  const artInput = row.querySelector(".database-art");
  const imageInput = row.querySelector(".database-image");
  const preview = row.querySelector(".database-art-preview");
  const saveButton = row.querySelector(".database-save");
  const deleteButton = row.querySelector(".database-delete");

  row.dataset.productId = product.id;
  row.querySelector(".database-upload span").textContent = t("replaceImage");
  row.querySelector(".database-art-choice span").textContent = t("fallbackIcon");
  saveButton.textContent = t("save");
  deleteButton.textContent = t("delete");
  row.querySelector(".database-name").value = product.name || "";
  row.querySelector(".database-width").value = product.width || "";
  row.querySelector(".database-height").value = product.height || "";
  artInput.value = product.art || "sofa";
  row.furnitureImage = product.image || "";
  row.furnitureImagePromise = null;
  updateFurnitureArtPreview(preview, artInput.value, product.image);

  artInput.addEventListener("change", () => {
    if (!row.furnitureImagePromise && !row.furnitureImage) {
      updateFurnitureArtPreview(preview, artInput.value, "");
    }
  });
  imageInput.addEventListener("change", () => {
    const file = imageInput.files[0];

    if (file) {
      const draftImage = URL.createObjectURL(file);

      updateFurnitureArtPreview(preview, artInput.value, draftImage);
      previewFurnitureImage(product.id, draftImage);
      row.furnitureImagePromise = readImageFile(file)
        .then((image) => {
          row.furnitureImage = image;
          updateFurnitureArtPreview(preview, artInput.value, image);
          previewFurnitureImage(product.id, image);
          return image;
        })
        .catch(() => {
          row.furnitureImagePromise = null;
          window.alert("家具圖片讀取失敗，請重新選擇圖片。");
          return row.furnitureImage;
        });
    }
  });
  saveButton.addEventListener("click", () => saveFurnitureDatabaseRow(row, product));
  deleteButton.addEventListener("click", () => {
    if (products.some((entry) => entry.id === product.id)) {
      deleteDatabaseFurniture(product.id);
    } else {
      row.remove();
    }
  });

  return row;
}

function renderFurnitureDatabaseRows() {
  furnitureDatabaseRows.replaceChildren(...products.map(createFurnitureDatabaseRow));
}

function addDatabaseFurnitureRow() {
  if (!requireManager()) {
    return;
  }

  const row = createFurnitureDatabaseRow({
    id: `furniture-${crypto.randomUUID()}`,
    name: "",
    width: 100,
    height: 100,
    art: "sofa",
    image: "",
  });

  furnitureDatabaseRows.prepend(row);
  row.querySelector(".database-name").focus();
}

function pointIsOnWall(clientX, clientY) {
  const bounds = wall.getBoundingClientRect();

  return (
    clientX >= bounds.left &&
    clientX <= bounds.right &&
    clientY >= bounds.top &&
    clientY <= bounds.bottom
  );
}

function createDragPreview(product) {
  const preview = document.createElement("div");
  const art = createProductVisual(product);

  preview.className = "drag-preview";
  preview.append(art);
  document.body.append(preview);

  return preview;
}

function startCatalogDrag(event, source, product) {
  if (event.target.closest("button, input, select, textarea, label, a")) {
    return;
  }

  if (isMobileCatalogDragDisabled(event)) {
    cleanupCatalogDrag();
    return;
  }

  if (event.pointerType === "mouse" && event.button !== 0) {
    return;
  }

  catalogPointer = {
    pointerId: event.pointerId,
    productId: product.id,
    product,
    source,
    startX: event.clientX,
    startY: event.clientY,
    pointerType: event.pointerType || "mouse",
    moved: false,
    captured: false,
    preview: null,
  };
}
function moveCatalogDrag(event) {
  if (!catalogPointer || catalogPointer.pointerId !== event.pointerId) {
    return;
  }

  const deltaX = event.clientX - catalogPointer.startX;
  const deltaY = event.clientY - catalogPointer.startY;
  const absX = Math.abs(deltaX);
  const absY = Math.abs(deltaY);
  const movement = Math.hypot(deltaX, deltaY);
  const isTouchLike = catalogPointer.pointerType !== "mouse";

  if (!catalogPointer.moved && isTouchLike && absY > 12 && absY > absX * 1.15) {
    cleanupCatalogDrag();
    return;
  }

  if (!catalogPointer.moved && movement > (isTouchLike ? 18 : 7)) {
    if (isTouchLike && absX <= absY * 1.2) {
      return;
    }

    catalogPointer.moved = true;
    if (!catalogPointer.captured) {
      catalogPointer.source.setPointerCapture?.(event.pointerId);
      catalogPointer.captured = true;
    }
    catalogPointer.source.classList.add("drag-source");
    catalogPointer.preview = createDragPreview(catalogPointer.product);
  }

  if (!catalogPointer.preview) {
    return;
  }

  catalogPointer.preview.style.left = `${event.clientX}px`;
  catalogPointer.preview.style.top = `${event.clientY}px`;
  wall.classList.toggle("is-target", pointIsOnWall(event.clientX, event.clientY));
  event.preventDefault();
}

function endCatalogDrag(event) {
  if (!catalogPointer || catalogPointer.pointerId !== event.pointerId) {
    return;
  }

  const droppedOnWall = catalogPointer.moved && pointIsOnWall(event.clientX, event.clientY);
  const bounds = wall.getBoundingClientRect();

  if (droppedOnWall) {
    addProduct(
      catalogPointer.product.id,
      (event.clientX - bounds.left) / bounds.width - 0.12,
      (event.clientY - bounds.top) / bounds.height - 0.12,
    );
  }

  cleanupCatalogDrag();
}

function cleanupCatalogDrag() {
  if (!catalogPointer) {
    return;
  }

  catalogPointer.source.classList.remove("drag-source");
  catalogPointer.preview?.remove();
  wall.classList.remove("is-target");
  catalogPointer = null;
}

function updateWallSize() {
  const stage = wall.parentElement;
  const dimensions = getDimensions();
  const isCompactCanvas = window.matchMedia("(max-width: 900px)").matches;
  const isExpandedCanvas = plannerFullscreen || isCompactCanvas;
  const viewport = window.visualViewport || window;
  const fullscreenSidebarIsHidden = plannerFullscreen && (fullscreenSidebarCollapsed || planner.classList.contains("fullscreen-sidebar-collapsed"));
  const fullscreenViewportWidth = Math.floor(viewport.width || window.innerWidth || document.documentElement.clientWidth || stage.clientWidth);
  const fullscreenViewportHeight = Math.floor(viewport.height || window.innerHeight || document.documentElement.clientHeight || stage.clientHeight);
  const availableWidth = fullscreenSidebarIsHidden
    ? Math.max(fullscreenViewportWidth - 56, 190)
    : Math.max(stage.clientWidth - (plannerFullscreen ? 0 : isExpandedCanvas ? 76 : 112), 190);
  const availableHeight = fullscreenSidebarIsHidden
    ? Math.max(fullscreenViewportHeight - 18, 160)
    : Math.max(stage.clientHeight - (plannerFullscreen ? 0 : isExpandedCanvas ? 64 : 94), 160);
  const fitScale = Math.min(availableWidth / dimensions.width, availableHeight / dimensions.height);
  const scale = plannerFullscreen
    ? fitScale
    : isExpandedCanvas
      ? Math.max(fitScale, Math.min(availableWidth / dimensions.width, 2.35))
      : fitScale;
  const visualWidth = Math.round(dimensions.width * scale);
  const visualHeight = Math.round(dimensions.height * scale);

  currentWallDimensions = dimensions;
  if (document.activeElement !== wallWidthInput) {
    wallWidthInput.value = dimensions.width;
  }
  if (document.activeElement !== wallHeightInput) {
    wallHeightInput.value = dimensions.height;
  }
  wall.style.setProperty("--wall-width", `${visualWidth}px`);
  wall.style.setProperty("--wall-height", `${visualHeight}px`);
  wall.style.setProperty("--grid-size", `${Math.max(gridCellCm * scale, 22)}px`);
  widthMeasure.textContent = `${dimensions.width} cm`;
  heightMeasure.textContent = `${dimensions.height} cm`;
  syncWallMeasureLines();
  if (dimensionLabel) {
    dimensionLabel.textContent = `${dimensions.width} x ${dimensions.height} ${t("centimeter")}`;
  }
  scaleLabel.textContent = t("scale");
  renderPlacedItems();
}

function syncWallMeasureLines() {
  if (!widthMeasureLine || !heightMeasureLine) {
    return;
  }

  widthMeasureLine.style.left = `${wall.offsetLeft}px`;
  widthMeasureLine.style.right = "auto";
  widthMeasureLine.style.width = `${wall.offsetWidth}px`;
  heightMeasureLine.style.top = `${wall.offsetTop}px`;
  heightMeasureLine.style.bottom = "auto";
  heightMeasureLine.style.height = `${wall.offsetHeight}px`;
}

function updateRoomName() {
  if (!roomLabel) {
    return;
  }

  roomLabel.textContent = roomNameInput?.value.trim() || t("untitledSpace");
}


function isCustomSpanProduct(product) {
  return Boolean(product?.customizableSpan);
}

function getCustomSpanConfig(product) {
  const min = clamp(Number(product?.minLengthCm) || 75, 1, 9999);
  const max = Math.max(min, clamp(Number(product?.maxLengthCm) || 150, 1, 9999));
  const defaultLength = clamp(Number(product?.defaultLengthCm || product?.width) || max, min, max);

  return {
    min,
    max,
    defaultLength,
    visualHeight: clamp(Number(product?.spanVisualHeightCm) || Math.max(Number(product?.height) || 15, 28), 10, 120),
  };
}

function getCustomSpanLength(product, item = null) {
  const config = getCustomSpanConfig(product);

  return clamp(Number(item?.spanLengthCm) || config.defaultLength, config.min, config.max);
}

const customSpanMaxAngleDeg = 50;

function normalizeCustomSpanAngle(value) {
  const angle = Number(value) || 0;

  if (!Number.isFinite(angle)) {
    return 0;
  }

  let normalized = ((angle + 180) % 360 + 360) % 360 - 180;

  // Hover should only be installed within a practical tilt range.
  // This also prevents the left/right endpoint drag from flipping the product.
  return clamp(normalized, -customSpanMaxAngleDeg, customSpanMaxAngleDeg);
}

function getCustomSpanAngle(item = null) {
  return normalizeCustomSpanAngle(item?.spanAngleDeg);
}

function getWallCmToPx(bounds = wall.getBoundingClientRect()) {
  const dimensions = getDimensions();
  const scaleX = bounds.width / dimensions.width;
  const scaleY = bounds.height / dimensions.height;

  return (scaleX + scaleY) / 2;
}

function getCustomSpanSagRatio(product, item = null) {
  const config = getCustomSpanConfig(product);
  const length = getCustomSpanLength(product, item);

  if (config.max <= config.min) {
    return 0;
  }

  return clamp((config.max - length) / (config.max - config.min), 0, 1);
}

function getCustomSpanEndpointPoints(item, bounds = wall.getBoundingClientRect()) {
  const product = getProduct(item.productId);
  const rect = getItemRect(item, bounds);
  const angle = getCustomSpanAngle(item) * Math.PI / 180;
  const centerX = rect.left + rect.width / 2;
  const centerY = rect.top + rect.height / 2;
  const half = rect.width / 2;
  const dx = Math.cos(angle) * half;
  const dy = Math.sin(angle) * half;

  if (!isCustomSpanProduct(product)) {
    return null;
  }

  return {
    left: { x: centerX - dx, y: centerY - dy },
    right: { x: centerX + dx, y: centerY + dy },
    center: { x: centerX, y: centerY },
  };
}

const customSpanCroppedImageCache = new Map();

function cropCustomSpanImageSource(src) {
  if (!src || !src.startsWith("data:image/")) return Promise.resolve(src);
  if (customSpanCroppedImageCache.has(src)) return Promise.resolve(customSpanCroppedImageCache.get(src));
  return new Promise((resolve) => {
    const image = new Image();
    image.onload = () => {
      try {
        const width = image.naturalWidth || image.width;
        const height = image.naturalHeight || image.height;
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d", { willReadFrequently: true });
        canvas.width = width; canvas.height = height;
        context.drawImage(image, 0, 0, width, height);
        const data = context.getImageData(0, 0, width, height).data;
        let minX = width, minY = height, maxX = -1, maxY = -1;
        for (let y = 0; y < height; y += 1) {
          const row = y * width * 4;
          for (let x = 0; x < width; x += 1) {
            if (data[row + x * 4 + 3] > 8) {
              if (x < minX) minX = x; if (y < minY) minY = y;
              if (x > maxX) maxX = x; if (y > maxY) maxY = y;
            }
          }
        }
        if (maxX < minX || maxY < minY) { customSpanCroppedImageCache.set(src, src); resolve(src); return; }
        const cropWidth = maxX - minX + 1, cropHeight = maxY - minY + 1;
        if ((1 - cropWidth / width) < 0.01 && (1 - cropHeight / height) < 0.01) { customSpanCroppedImageCache.set(src, src); resolve(src); return; }
        const output = document.createElement("canvas");
        output.width = cropWidth; output.height = cropHeight;
        output.getContext("2d").drawImage(canvas, minX, minY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
        const croppedSrc = output.toDataURL("image/webp", 0.98);
        customSpanCroppedImageCache.set(src, croppedSrc); resolve(croppedSrc);
      } catch (error) { customSpanCroppedImageCache.set(src, src); resolve(src); }
    };
    image.onerror = () => resolve(src);
    image.src = src;
  });
}

function getCustomSpanImageSrc(lengthCm) {
  if (!customSpanFrameLengths.length) {
    return "";
  }

  const length = Number(lengthCm) || customSpanFrameLengths[customSpanFrameLengths.length - 1];
  const nearest = customSpanFrameLengths.reduce((best, current) => (
    Math.abs(current - length) < Math.abs(best - length) ? current : best
  ), customSpanFrameLengths[0]);

  return customSpanImageFrames[String(nearest)] || customSpanImageFrames[String(customSpanFrameLengths[customSpanFrameLengths.length - 1])] || "";
}

function refreshCustomSpanElement(element, product, item) {
  if (!element || !isCustomSpanProduct(product)) {
    return;
  }

  const length = getCustomSpanLength(product, item);
  const config = getCustomSpanConfig(product);
  const visual = element.querySelector(".custom-span-visual");
  const label = element.querySelector(".custom-span-length-label");
  const hint = element.querySelector(".custom-span-drag-hint");

  element.style.setProperty("--span-angle", `${getCustomSpanAngle(item)}deg`);
  element.style.setProperty("--span-image-height-ratio", String(config.visualHeight / Math.max(length, 1)));

  if (visual) {
    const imageSrc = getCustomSpanImageSrc(length);
    const requestKey = `${item?.key || "preview"}-${length}`;
    visual.dataset.cropRequestKey = requestKey;
    visual.innerHTML = imageSrc
      ? `<img class="custom-span-product-image" src="${imageSrc}" alt="" draggable="false">`
      : "";
    if (imageSrc) {
      cropCustomSpanImageSource(imageSrc).then((croppedSrc) => {
        if (visual.dataset.cropRequestKey !== requestKey) return;
        const image = visual.querySelector(".custom-span-product-image");
        if (image && croppedSrc && image.src !== croppedSrc) {
          image.src = croppedSrc;
          image.classList.add("custom-span-product-image-cropped");
        }
      });
    }
  }

  if (label) {
    label.textContent = `${t("spanLengthLabel", formatDimension(length))}｜${t("spanLengthRange", formatDimension(config.min), formatDimension(config.max))}`;
  }

  if (hint) {
    hint.textContent = t("spanDragHint");
  }
}

function createCustomSpanVisual(product, item) {
  const wrapper = document.createElement("div");
  const visual = document.createElement("div");
  const label = document.createElement("span");

  wrapper.className = "custom-span-wrapper";
  visual.className = "custom-span-visual";
  label.className = "custom-span-length-label";
  wrapper.append(visual, label);
  requestAnimationFrame(() => refreshCustomSpanElement(wrapper.closest(".placed-item") || wrapper, product, item));
  return wrapper;
}

function updateCustomSpanFromEndpoints(item, leftPoint, rightPoint, bounds = wall.getBoundingClientRect(), movingSide = "", fixedCenter = null) {
  const product = getProduct(item.productId);

  if (!isCustomSpanProduct(product)) {
    return;
  }

  const cmToPx = getWallCmToPx(bounds);
  const config = getCustomSpanConfig(product);
  const currentRect = getItemRect(item, bounds);
  const centerX = Number.isFinite(fixedCenter?.x) ? fixedCenter.x : currentRect.left + currentRect.width / 2;
  const centerY = Number.isFinite(fixedCenter?.y) ? fixedCenter.y : currentRect.top + currentRect.height / 2;
  const movingPoint = movingSide === "left" ? leftPoint : rightPoint;
  let vectorX = movingPoint.x - centerX;
  let vectorY = movingPoint.y - centerY;

  // Left endpoint must stay on the left side of the center, right endpoint on the right.
  // Without this guard, dragging across the center makes the product flip 180 degrees.
  if (movingSide === "left") {
    vectorX = Math.min(vectorX, -1);
  } else {
    vectorX = Math.max(vectorX, 1);
  }

  let halfLengthPx = Math.hypot(vectorX, vectorY);

  if (!Number.isFinite(halfLengthPx) || halfLengthPx < 1) {
    const currentAngle = getCustomSpanAngle(item) * Math.PI / 180;
    halfLengthPx = (getCustomSpanLength(product, item) * cmToPx) / 2;
    vectorX = Math.cos(currentAngle) * halfLengthPx * (movingSide === "left" ? -1 : 1);
    vectorY = Math.sin(currentAngle) * halfLengthPx * (movingSide === "left" ? -1 : 1);
  }

  const rawLengthCm = (halfLengthPx * 2) / cmToPx;
  const lengthCm = clamp(rawLengthCm, config.min, config.max);
  const targetPx = lengthCm * cmToPx;
  const rawAngleDeg = movingSide === "left"
    ? Math.atan2(-vectorY, -vectorX) * 180 / Math.PI
    : Math.atan2(vectorY, vectorX) * 180 / Math.PI;
  const angleDeg = normalizeCustomSpanAngle(rawAngleDeg);
  const heightPx = clamp((config.visualHeight / getDimensions().height) * bounds.height, 14, 80);
  const nextRect = {
    left: centerX - targetPx / 2,
    top: centerY - heightPx / 2,
    width: targetPx,
    height: heightPx,
  };

  item.spanLengthCm = lengthCm;
  item.widthCm = lengthCm;
  item.heightCm = config.visualHeight;
  item.spanAngleDeg = angleDeg;
  updateItemPosition(item, nextRect, bounds);
}

function startCustomSpanHandleDrag(event) {
  if (event.pointerType === "mouse" && event.button !== 0) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  const handle = event.currentTarget;
  const element = handle.closest(".placed-item");
  const item = placedItems.find((entry) => entry.key === element?.dataset.key);
  const product = item ? getProduct(item.productId) : null;

  if (!element || !item || !isCustomSpanProduct(product)) {
    return;
  }

  const bounds = wall.getBoundingClientRect();
  const endpoints = getCustomSpanEndpointPoints(item, bounds);

  if (!endpoints) {
    return;
  }

  selectItem(element);
  handle.setPointerCapture(event.pointerId);
  document.body.classList.add("custom-span-adjusting");
  customSpanPointer = {
    pointerId: event.pointerId,
    handle,
    element,
    item,
    product,
    bounds,
    draggingSide: handle.dataset.side,
    fixedPoint: handle.dataset.side === "left" ? endpoints.right : endpoints.left,
    centerPoint: endpoints.center,
  };
}


function startCustomSpanEndpointDrag(event, element, item, side) {
  const product = item ? getProduct(item.productId) : null;

  if (!element || !item || !isCustomSpanProduct(product)) {
    return false;
  }

  const bounds = wall.getBoundingClientRect();
  const endpoints = getCustomSpanEndpointPoints(item, bounds);

  if (!endpoints) {
    return false;
  }

  event.preventDefault();
  event.stopPropagation();
  selectItem(element);
  element.setPointerCapture?.(event.pointerId);
  document.body.classList.add("custom-span-adjusting");
  customSpanPointer = {
    pointerId: event.pointerId,
    handle: element,
    element,
    item,
    product,
    bounds,
    draggingSide: side,
    fixedPoint: side === "left" ? endpoints.right : endpoints.left,
    centerPoint: endpoints.center,
  };
  return true;
}

function getCustomSpanEndpointHitSide(event, item, bounds = wall.getBoundingClientRect()) {
  const endpoints = getCustomSpanEndpointPoints(item, bounds);

  if (!endpoints) {
    return "";
  }

  const point = getWallPoint(event, bounds);
  const rect = getItemRect(item, bounds);
  const leftDistance = Math.hypot(point.x - endpoints.left.x, point.y - endpoints.left.y);
  const rightDistance = Math.hypot(point.x - endpoints.right.x, point.y - endpoints.right.y);
  const hitRadius = event.pointerType === "mouse" ? 24 : 24;
  const localX = clamp(point.x - rect.left, 0, rect.width);
  const edgeZone = Math.max(18, Math.min(34, rect.width * 0.16));
  const nearLeftEdge = localX <= edgeZone;
  const nearRightEdge = localX >= rect.width - edgeZone;

  if ((nearLeftEdge && leftDistance <= hitRadius) || (nearRightEdge && rightDistance <= hitRadius)) {
    return leftDistance <= rightDistance ? "left" : "right";
  }

  return "";
}

function moveCustomSpanHandle(event) {
  if (!customSpanPointer || customSpanPointer.pointerId !== event.pointerId) {
    return;
  }

  event.preventDefault();
  const bounds = customSpanPointer.bounds;
  const pointer = getWallPoint(event, bounds);
  const fixed = customSpanPointer.fixedPoint;
  let leftPoint;
  let rightPoint;

  if (customSpanPointer.draggingSide === "left") {
    leftPoint = pointer;
    rightPoint = fixed;
  } else {
    leftPoint = fixed;
    rightPoint = pointer;
  }

  updateCustomSpanFromEndpoints(customSpanPointer.item, leftPoint, rightPoint, bounds, customSpanPointer.draggingSide, customSpanPointer.centerPoint);
  positionItem(customSpanPointer.element, customSpanPointer.item);
  refreshCustomSpanElement(customSpanPointer.element, customSpanPointer.product, customSpanPointer.item);
  renderDimensionGuides();
  renderCoordinateGuides();
}

function endCustomSpanHandle(event) {
  if (!customSpanPointer || customSpanPointer.pointerId !== event.pointerId) {
    return;
  }

  document.body.classList.remove("custom-span-adjusting");
  customSpanPointer = null;
  renderPlacedItems();
}

// V159: fixed products must use one shared cm-to-pixel scale on both axes.
// This preserves their real width/height ratio even if the rendered wall bounds differ slightly.
function getUniformDatabaseProductSize(product, item, targetWidth, targetHeight) {
  const dimensions = getDimensions();
  const widthCm = Number(item?.widthCm || product?.width) || 1;
  const heightCm = Number(item?.heightCm || product?.height) || 1;
  const cmToPx = Math.min(targetWidth / dimensions.width, targetHeight / dimensions.height);
  const rawWidth = widthCm * cmToPx;
  const rawHeight = heightCm * cmToPx;
  const fitFactor = Math.min(1, (targetWidth * 0.96) / rawWidth, (targetHeight * 0.96) / rawHeight);

  return {
    width: Math.max(1, rawWidth * fitFactor),
    height: Math.max(1, rawHeight * fitFactor),
  };
}

function productPixelSize(product, item) {
  const dimensions = getDimensions();
  const bounds = wall.getBoundingClientRect();
  const customSpan = isCustomSpanProduct(product);
  const databaseProduct = !customSpan && Boolean(getFixedProduct(product?.id));

  if (databaseProduct) {
    return getUniformDatabaseProductSize(product, item, bounds.width, bounds.height);
  }

  const config = customSpan ? getCustomSpanConfig(product) : null;
  const widthCm = customSpan ? getCustomSpanLength(product, item) : (item?.widthCm || product.width);
  const heightCm = customSpan ? config.visualHeight : (item?.heightCm || product.height);
  const minimumSize = customSpan ? 14 : (product.resizable === false ? 18 : 54);

  return {
    width: clamp((widthCm / dimensions.width) * bounds.width, minimumSize, bounds.width * 0.96),
    height: clamp((heightCm / dimensions.height) * bounds.height, customSpan ? 14 : minimumSize, bounds.height * 0.96),
  };
}

function getItemRect(item, bounds = wall.getBoundingClientRect()) {
  const product = getProduct(item.productId);
  const size = productPixelSize(product, item);

  return {
    left: clamp(item.xRatio * bounds.width, 0, bounds.width - size.width),
    top: clamp(item.yRatio * bounds.height, 0, bounds.height - size.height),
    width: size.width,
    height: size.height,
  };
}

function updateItemPosition(item, rect, bounds = wall.getBoundingClientRect()) {
  item.xRatio = rect.left / bounds.width;
  item.yRatio = rect.top / bounds.height;
}

function countItems() {
  const totalPrice = placedItems.reduce((total, item) => {
    const product = getFixedProduct(item.productId);
    const color = product ? getPlacedProductColor(product, item) : "";

    return product ? total + getProductPriceForColor(product, color) : total;
  }, 0);

  wallHint.classList.toggle("hidden", placedItems.length > 0);
  itemCount.textContent =
    placedItems.length > 0 ? t("placedCount", placedItems.length) : t("noItems");
  wallTotalPrice.textContent = `${t("estimatedTotal")} ${formatPrice(totalPrice)}`;
}

function getCartItemsFromWall() {
  const cartItems = new Map();

  placedItems.forEach((item) => {
    const product = getFixedProduct(item.productId);
    const color = product ? getPlacedProductColor(product, item) : "";
    const variantId = product ? getProductVariantIdForColorDirection(product, color, item) : "";

    if (!variantId) {
      return;
    }

    const id = String(variantId).trim();
    const unitQuantity = getCartUnitQuantity(product);

    if (!cartItems.has(id)) {
      const colorLabel = color ? getProductColorLabel(color) : "";
      const directionLabel = getProductDirectionLabel(product, item);
      const labelParts = [product.name, colorLabel, directionLabel].filter(Boolean);
      cartItems.set(id, { quantity: 0, label: labelParts.join(" - ") });
    }

    cartItems.get(id).quantity += unitQuantity;
  });

  return [...cartItems].map(([id, { quantity, label }]) => ({
    id,
    quantity: Math.max(1, Math.ceil(quantity)),
    label,
  }));
}

async function fetchVariantStockStatus(variantId, requestedQuantity = 1) {
  const id = String(variantId || "").trim();
  const quantity = Number(requestedQuantity) || 1;

  if (!id) {
    return {
      ok: false,
      purchasable: false,
      reason: "invalid-id",
      inventoryKnown: false,
    };
  }

  try {
    const response = await fetch(`/variants/${encodeURIComponent(id)}.js`, {
      headers: { Accept: "application/json" },
      cache: "no-store",
    });

    if (!response.ok) {
      return {
        ok: false,
        purchasable: false,
        reason: "variant-not-found",
        inventoryKnown: false,
      };
    }

    const variant = await response.json();
    const inventoryQuantity = Number(variant.inventory_quantity);
    const inventoryKnown = Number.isFinite(inventoryQuantity);

    // Shopify may still allow the add-to-cart request when inventory_policy is "continue".
    // This planner should block every no-stock variant before sending the form request.
    if (inventoryKnown && inventoryQuantity < quantity) {
      return {
        ok: true,
        purchasable: false,
        reason: "not-enough-stock",
        inventoryKnown,
        inventoryQuantity,
        variant,
      };
    }

    if (variant.available === false) {
      return {
        ok: true,
        purchasable: false,
        reason: "unavailable",
        inventoryKnown,
        inventoryQuantity: inventoryKnown ? inventoryQuantity : null,
        variant,
      };
    }

    return {
      ok: true,
      purchasable: true,
      reason: "available",
      inventoryKnown,
      inventoryQuantity: inventoryKnown ? inventoryQuantity : null,
      variant,
    };
  } catch (error) {
    console.warn("Variant stock check failed:", { id, error });
    return {
      ok: false,
      purchasable: false,
      reason: "stock-check-failed",
      inventoryKnown: false,
    };
  }
}

async function addVariantToCartWithProductForm(id, quantity) {
  const formData = new URLSearchParams();

  formData.append("form_type", "product");
  formData.append("id", String(id));
  formData.append("quantity", String(quantity));

  return fetch("/cart/add.js", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: formData.toString(),
  });
}

async function addWallProductsToCart() {
  const items = getCartItemsFromWall();

  if (items.length === 0) {
    window.alert(t("cartMissingVariants"));
    return;
  }

  if (window.location.protocol === "file:") {
    window.alert(t("cartLocalError"));
    return;
  }

  const soldOutLines = [];
  const errorLines = [];
  const successItems = [];

  for (const { id, quantity, label } of items) {
    const stockStatus = await fetchVariantStockStatus(id, quantity);

    if (!stockStatus.purchasable) {
      if (stockStatus.reason === "stock-check-failed") {
        errorLines.push(t("cartSystemError", label));
      } else {
        soldOutLines.push(t("cartSoldOutItem", label));
      }
      continue;
    }

    try {
      const response = await addVariantToCartWithProductForm(id, quantity);

      if (response.ok) {
        successItems.push(label);
        continue;
      }

      const errBody = await response.json().catch(() => ({}));
      const errMsg = String(errBody?.description || errBody?.message || "").toLowerCase();
      const isSoldOut =
        response.status === 422 &&
        (errMsg.includes("sold out") ||
          errMsg.includes("売り切れ") ||
          errMsg.includes("在庫") ||
          errMsg.includes("out of stock") ||
          errMsg.includes("unavailable"));

      if (isSoldOut) {
        soldOutLines.push(t("cartSoldOutItem", label));
      } else {
        console.warn("Cart add failed:", { id, quantity, label, errBody });
        errorLines.push(t("cartSystemError", label));
      }
    } catch (error) {
      console.warn("Cart add network error:", { id, quantity, label, error });
      errorLines.push(t("cartSystemError", label));
    }
  }

  const problemLines = [...soldOutLines, ...errorLines];

  if (problemLines.length === 0) {
    window.alert(t("cartAdded"));
    return;
  }

  const parts = [];

  if (problemLines.length > 0) {
    parts.push(t("cartSoldOutTitle"));
    parts.push(...problemLines);
  }

  if (successItems.length > 0) {
    parts.push("");
    parts.push(t("cartAdded"));
  }

  window.alert(parts.join("\n"));
}

function addProduct(productId, xRatio, yRatio) {
  const product = getProduct(productId);

  if (!product) {
    return;
  }

  const createItem = (offsetIndex = 0) => ({
    key: crypto.randomUUID(),
    productId,
    widthCm: isCustomSpanProduct(product) ? getCustomSpanConfig(product).defaultLength : product.width,
    heightCm: isCustomSpanProduct(product) ? getCustomSpanConfig(product).visualHeight : product.height,
    spanLengthCm: isCustomSpanProduct(product) ? getCustomSpanConfig(product).defaultLength : undefined,
    spanAngleDeg: 0,
    color: getFixedProduct(product.id) ? getPrimaryProductColor(product) : "",
    flipped: false,
    verticalFlipped: false,
    rotated: false,
    xRatio: clamp(xRatio + offsetIndex * 0.035, 0, 0.84),
    yRatio: clamp(yRatio + offsetIndex * 0.035, 0, 0.78),
  });

  const newItems = [createItem(0)];

  if (product.mustDouble) {
    newItems.push(createItem(1));
  }

  const bounds = wall.getBoundingClientRect();
  const positionedItems = newItems.map((item) => {
    const rect = getItemRect(item, bounds);
    updateItemPosition(item, rect, bounds);
    return item;
  });

  placedItems = [
    ...placedItems,
    ...positionedItems,
  ];
  selectedItemKey = positionedItems[positionedItems.length - 1]?.key || null;
  selectedItemKeys = new Set(positionedItems.map((item) => item.key));
  renderPlacedItems();
}

function showAddedToast(anchor) {
  const toast = document.createElement("span");
  const bounds = anchor?.getBoundingClientRect();

  document.querySelector(".add-toast")?.remove();
  clearTimeout(addToastTimer);
  toast.className = "add-toast";
  toast.textContent = t("productAdded");
  toast.setAttribute("role", "status");
  toast.setAttribute("aria-live", "polite");

  if (bounds) {
    toast.style.left = `${Math.min(bounds.left + bounds.width / 2, window.innerWidth - 44)}px`;
    toast.style.top = `${Math.max(bounds.top - 8, 12)}px`;
  }

  document.body.append(toast);
  requestAnimationFrame(() => toast.classList.add("visible"));
  addToastTimer = window.setTimeout(() => {
    toast.classList.remove("visible");
    toast.addEventListener("transitionend", () => toast.remove(), { once: true });
  }, 1200);
}

function addProductFromCatalog(productId, anchor) {
  addProduct(productId, 0.08 + placedItems.length * 0.05, 0.14 + placedItems.length * 0.04);
  showAddedToast(anchor);
}

function removeProduct(key) {
  placedItems = placedItems.filter((item) => item.key !== key);
  selectedItemKeys.delete(key);
  if (selectedItemKey === key) {
    selectedItemKey = [...selectedItemKeys][0] || null;
    hiddenActionWheelKey = null;
  }
  renderPlacedItems();
}

function duplicatePlacedItem(item) {
  const product = getProduct(item.productId);

  if (!product) {
    return;
  }

  const clone = {
    ...item,
    key: crypto.randomUUID(),
    xRatio: item.xRatio + 0.04,
    yRatio: item.yRatio + 0.04,
  };
  const bounds = wall.getBoundingClientRect();
  const rect = getItemRect(clone, bounds);

  updateItemPosition(clone, rect, bounds);
  delete clone.groupId;
  placedItems = [...placedItems, clone];
  selectedItemKey = clone.key;
  selectedItemKeys = new Set([clone.key]);
  hiddenActionWheelKey = null;
  renderPlacedItems();
}

function positionItem(element, item) {
  const rect = getItemRect(item);

  element.style.width = `${rect.width}px`;
  element.style.height = `${rect.height}px`;
  element.style.left = `${rect.left}px`;
  element.style.top = `${rect.top}px`;

  const product = getProduct(item.productId);
  if (isCustomSpanProduct(product)) {
    element.style.setProperty("--span-angle", `${getCustomSpanAngle(item)}deg`);
  } else {
    element.style.removeProperty("--span-angle");
  }

  if (item.rotated) {
    element.style.setProperty("--rotated-visual-width", `${rect.height}px`);
    element.style.setProperty("--rotated-visual-height", `${rect.width}px`);
  } else {
    element.style.removeProperty("--rotated-visual-width");
    element.style.removeProperty("--rotated-visual-height");
  }
}

function getControlSide(item, bounds = wall.getBoundingClientRect()) {
  const rect = getItemRect(item, bounds);
  const box = {
    left: rect.left,
    right: rect.left + rect.width,
    centerX: rect.left + rect.width / 2,
  };
  const controlWidth = 196;
  const rightSpace = bounds.width - box.right;
  const leftSpace = box.left;
  const nearest = placedItems
    .filter((placedItem) => placedItem.key !== item.key)
    .map((placedItem) => {
      const targetRect = getItemRect(placedItem, bounds);
      const targetBox = {
        left: targetRect.left,
        right: targetRect.left + targetRect.width,
        centerX: targetRect.left + targetRect.width / 2,
        centerY: targetRect.top + targetRect.height / 2,
      };
      const gapX = Math.max(0, Math.max(box.left - targetBox.right, targetBox.left - box.right));
      const gapY = Math.abs((rect.top + rect.height / 2) - targetBox.centerY);

      return {
        side: targetBox.centerX < box.centerX ? "right" : "left",
        score: Math.hypot(gapX, gapY),
      };
    })
    .sort((a, b) => a.score - b.score)[0];
  const preferredSide = nearest?.side || (rightSpace >= leftSpace ? "right" : "left");

  if (preferredSide === "right" && rightSpace >= controlWidth) {
    return "right";
  }
  if (preferredSide === "left" && leftSpace >= controlWidth) {
    return "left";
  }
  if (rightSpace >= controlWidth || rightSpace >= leftSpace) {
    return "right";
  }

  return "left";
}

function getActionWheelPlacement(item, bounds = wall.getBoundingClientRect()) {
  const rect = getItemRect(item, bounds);
  const wheelSize = 171;
  const wheelGap = 18;
  const spaces = {
    right: bounds.width - rect.left - rect.width,
    left: rect.left,
    bottom: bounds.height - rect.top - rect.height,
    top: rect.top,
  };
  const needed = wheelSize + wheelGap;

  for (const side of ["right", "left", "bottom", "top"]) {
    if (spaces[side] >= needed) {
      return side;
    }
  }

  return Object.entries(spaces).sort((a, b) => b[1] - a[1])[0][0];
}

function getBottomDistance(item, rect = getItemRect(item), bounds = wall.getBoundingClientRect()) {
  const dimensions = getDimensions();
  const itemBottomRatio = (rect.top + rect.height) / bounds.height;

  return Math.max(0, dimensions.height - itemBottomRatio * dimensions.height);
}

const coordinateColorPalette = [
  { line: "#6F8FAF", bg: "rgba(111, 143, 175, 0.18)" },
  { line: "#A77979", bg: "rgba(167, 121, 121, 0.18)" },
  { line: "#6F9A8D", bg: "rgba(111, 154, 141, 0.18)" },
  { line: "#9985A5", bg: "rgba(153, 133, 165, 0.18)" },
  { line: "#B28A55", bg: "rgba(178, 138, 85, 0.18)" },
  { line: "#6D8E73", bg: "rgba(109, 142, 115, 0.18)" },
  { line: "#8D7B68", bg: "rgba(141, 123, 104, 0.18)" },
  { line: "#7E8AA2", bg: "rgba(126, 138, 162, 0.18)" },
  { line: "#A06F83", bg: "rgba(160, 111, 131, 0.18)" },
  { line: "#718F94", bg: "rgba(113, 143, 148, 0.18)" },
  { line: "#9B835E", bg: "rgba(155, 131, 94, 0.18)" },
  { line: "#7F7866", bg: "rgba(127, 120, 102, 0.18)" },
  { line: "#7289A1", bg: "rgba(114, 137, 161, 0.18)" },
  { line: "#9A7D90", bg: "rgba(154, 125, 144, 0.18)" },
  { line: "#7B956F", bg: "rgba(123, 149, 111, 0.18)" },
  { line: "#A1846A", bg: "rgba(161, 132, 106, 0.18)" },
  { line: "#73858D", bg: "rgba(115, 133, 141, 0.18)" },
  { line: "#927C6B", bg: "rgba(146, 124, 107, 0.18)" },
  { line: "#788EA4", bg: "rgba(120, 142, 164, 0.18)" },
  { line: "#8C7AA0", bg: "rgba(140, 122, 160, 0.18)" },
  { line: "#71947F", bg: "rgba(113, 148, 127, 0.18)" },
  { line: "#A27A68", bg: "rgba(162, 122, 104, 0.18)" },
  { line: "#7A8797", bg: "rgba(122, 135, 151, 0.18)" },
  { line: "#8B856D", bg: "rgba(139, 133, 109, 0.18)" },
  { line: "#6D9297", bg: "rgba(109, 146, 151, 0.18)" },
  { line: "#9C7880", bg: "rgba(156, 120, 128, 0.18)" },
  { line: "#7F9271", bg: "rgba(127, 146, 113, 0.18)" },
  { line: "#9A8067", bg: "rgba(154, 128, 103, 0.18)" },
  { line: "#74859D", bg: "rgba(116, 133, 157, 0.18)" },
  { line: "#8E7892", bg: "rgba(142, 120, 146, 0.18)" },
];

function renderCoordinateGuides() {
  const wallStage = wall.closest(".wall-stage");

  wall.querySelectorAll(".coordinate-guide, .coordinate-legend").forEach((element) => element.remove());
  wallStage?.querySelectorAll(":scope > .coordinate-guide, :scope > .coordinate-legend").forEach((element) => element.remove());
  wallStage?.classList.remove("coordinates-outside-active", "coordinates-mobile-clean");
  wallStage?.style.removeProperty("--coordinate-top-space");
  wallStage?.style.removeProperty("--coordinate-right-space");

  if (!coordinatesVisible || placedItems.length === 0 || !wallStage) {
    return;
  }

  const isMobileLayout = window.matchMedia("(max-width: 900px), (hover: none) and (pointer: coarse)").matches;
  const isFullscreenCoordinateLayout = isMobileLayout && (
    plannerFullscreen ||
    document.body.classList.contains("planner-fullscreen-active") ||
    planner.classList.contains("is-fullscreen") ||
    document.fullscreenElement === planner
  );
  const bounds = wall.getBoundingClientRect();
  const dimensions = getDimensions();
  const legend = document.createElement("div");

  legend.className = `coordinate-legend${isMobileLayout ? " coordinate-legend-mobile" : " coordinate-legend-desktop"}${isFullscreenCoordinateLayout ? " coordinate-legend-mobile-fullscreen" : ""}`;
  legend.setAttribute("aria-label", "產品座標對照");

  if (isMobileLayout) {
    wallStage.classList.add("coordinates-mobile-clean");
  }

  placedItems.forEach((item, index) => {
    const product = getProduct(item.productId);
    const productName = product?.name || item.productId || "產品";
    const palette = coordinateColorPalette[index % coordinateColorPalette.length];
    const rect = getItemRect(item, bounds);
    const productBottom = rect.top + rect.height;
    const verticalHeight = Math.max(0, bounds.height - productBottom);
    const leftDistance = Math.max(0, (rect.left / bounds.width) * dimensions.width);
    const bottomDistance = getBottomDistance(item, rect, bounds);
    const displayName = `${index + 1}. ${productName}`;

    if (rect.left >= 1) {
      const horizontalGuide = document.createElement("div");

      horizontalGuide.className = "coordinate-guide coordinate-guide-horizontal coordinate-guide-colored coordinate-guide-clean";
      horizontalGuide.style.setProperty("--coordinate-color", palette.line);
      horizontalGuide.style.left = "0px";
      horizontalGuide.style.top = `${rect.top + rect.height / 2}px`;
      horizontalGuide.style.width = `${Math.max(0, rect.left)}px`;
      horizontalGuide.setAttribute("aria-label", `${displayName}，距離左牆 ${formatDimension(leftDistance)} 公分`);
      wall.append(horizontalGuide);
    }

    if (verticalHeight >= 1) {
      const verticalGuide = document.createElement("div");

      verticalGuide.className = "coordinate-guide coordinate-guide-vertical coordinate-guide-colored coordinate-guide-clean";
      verticalGuide.style.setProperty("--coordinate-color", palette.line);
      verticalGuide.style.left = `${rect.left + rect.width / 2}px`;
      verticalGuide.style.top = `${productBottom}px`;
      verticalGuide.style.height = `${verticalHeight}px`;
      verticalGuide.setAttribute("aria-label", `${displayName}，離地 ${formatDimension(bottomDistance)} 公分`);
      wall.append(verticalGuide);
    }

    const legendItem = document.createElement("div");
    const swatch = document.createElement("span");
    const copy = document.createElement("span");
    const name = document.createElement("strong");
    const values = document.createElement("span");

    legendItem.className = "coordinate-legend-item";
    legendItem.style.setProperty("--coordinate-color", palette.line);
    swatch.className = "coordinate-legend-swatch";
    copy.className = "coordinate-legend-copy";
    name.textContent = displayName;
    values.className = "coordinate-legend-values";
    values.textContent = `左 ${formatDimension(leftDistance)} cm｜離地 ${formatDimension(bottomDistance)} cm`;
    copy.append(name, values);
    legendItem.append(swatch, copy);
    legend.append(legendItem);
  });

  if (isFullscreenCoordinateLayout) {
    wallStage.append(legend);
  } else {
    wall.append(legend);
  }
}

function renderDimensionGuides() {
  wall.querySelectorAll(".dimension-guide").forEach((element) => element.remove());

  if (!dimensionsVisible || selectedItemKeys.size !== 1 || !selectedItemKey || placedItems.length < 2) {
    return;
  }

  const bounds = wall.getBoundingClientRect();
  const dimensions = getDimensions();
  const selectedItem = placedItems.find((item) => item.key === selectedItemKey);

  if (!selectedItem) {
    return;
  }

  const selectedRect = getItemRect(selectedItem, bounds);
  const selectedBox = {
    ...selectedRect,
    right: selectedRect.left + selectedRect.width,
    bottom: selectedRect.top + selectedRect.height,
    centerX: selectedRect.left + selectedRect.width / 2,
    centerY: selectedRect.top + selectedRect.height / 2,
  };
  const nearest = placedItems
    .filter((item) => item.key !== selectedItemKey)
    .map((item) => {
      const rect = getItemRect(item, bounds);
      const box = {
        ...rect,
        right: rect.left + rect.width,
        bottom: rect.top + rect.height,
        centerX: rect.left + rect.width / 2,
        centerY: rect.top + rect.height / 2,
      };
      const gapX = Math.max(0, Math.max(selectedBox.left - box.right, box.left - selectedBox.right));
      const gapY = Math.max(0, Math.max(selectedBox.top - box.bottom, box.top - selectedBox.bottom));
      const centerGap = Math.hypot(selectedBox.centerX - box.centerX, selectedBox.centerY - box.centerY);

      return {
        box,
        centerGap,
        score: Math.hypot(gapX, gapY),
      };
    })
    .sort((a, b) => a.score - b.score || a.centerGap - b.centerGap)[0];

  if (!nearest) {
    return;
  }

  const targetBox = nearest.box;
  const targetIsRight = targetBox.centerX >= selectedBox.centerX;
  const targetIsBelow = targetBox.centerY >= selectedBox.centerY;
  const horizontalStart = targetIsRight ? selectedBox.right : targetBox.right;
  const horizontalEnd = targetIsRight ? targetBox.left : selectedBox.left;
  const verticalStart = targetIsBelow ? selectedBox.bottom : targetBox.bottom;
  const verticalEnd = targetIsBelow ? targetBox.top : selectedBox.top;
  const horizontalGapPx = Math.max(0, horizontalEnd - horizontalStart);
  const verticalGapPx = Math.max(0, verticalEnd - verticalStart);
  const horizontalGapCm = (horizontalGapPx / bounds.width) * dimensions.width;
  const verticalGapCm = (verticalGapPx / bounds.height) * dimensions.height;
  const widthGuide = document.createElement("div");
  const heightGuide = document.createElement("div");
  const widthLabel = document.createElement("span");
  const heightLabel = document.createElement("span");
  const horizontalLineLeft = Math.max(0, Math.min(horizontalStart, horizontalEnd));
  const horizontalLineTop = Math.max(8, selectedBox.top - 18);
  const verticalLineTop = Math.max(0, Math.min(verticalStart, verticalEnd));
  const verticalSide = targetBox.centerX < selectedBox.centerX ? selectedBox.left - 16 : selectedBox.right + 16;

  widthGuide.className = "dimension-guide dimension-guide-line dimension-guide-width";
  widthLabel.textContent = t("widthLabel", formatDimension(horizontalGapCm));
  widthGuide.style.left = `${horizontalLineLeft}px`;
  widthGuide.style.top = `${horizontalLineTop}px`;
  widthGuide.style.width = `${Math.max(horizontalGapPx, 1)}px`;
  widthGuide.setAttribute("aria-label", t("widthLabel", formatDimension(horizontalGapCm)));
  widthGuide.append(widthLabel);

  heightGuide.className = "dimension-guide dimension-guide-line dimension-guide-height";
  heightLabel.textContent = t("heightLabel", formatDimension(verticalGapCm));
  heightGuide.style.left = `${verticalSide}px`;
  heightGuide.style.top = `${verticalLineTop}px`;
  heightGuide.style.height = `${Math.max(verticalGapPx, 1)}px`;
  heightGuide.setAttribute("aria-label", t("heightLabel", formatDimension(verticalGapCm)));
  heightGuide.append(heightLabel);

  wall.append(widthGuide, heightGuide);
}

function updateCoordinateToggle() {
  coordinateToggle.classList.toggle("active", coordinatesVisible);
  coordinateToggle.setAttribute("aria-pressed", String(coordinatesVisible));
  coordinateToggle.textContent = coordinatesVisible ? t("hideCoordinates") : t("showCoordinates");
  renderCoordinateGuides();
}

function updateFullscreenToggle() {
  fullscreenToggle.classList.toggle("active", plannerFullscreen);
  fullscreenToggle.setAttribute("aria-pressed", String(plannerFullscreen));
  fullscreenToggle.textContent = plannerFullscreen ? t("exitFullscreen") : t("fullscreenEdit");
  if (fullscreenBottomExit) {
    fullscreenBottomExit.hidden = !plannerFullscreen;
    fullscreenBottomExit.textContent = t("exitFullscreen");
  }
}

function updateFullscreenSidebarToggle() {
  if (!fullscreenSidebarToggle) {
    return;
  }

  const expanded = plannerFullscreen && !fullscreenSidebarCollapsed;
  const label = fullscreenSidebarCollapsed ? t("showFullscreenSidebar") : t("hideFullscreenSidebar");

  fullscreenSidebarToggle.hidden = !plannerFullscreen;
  fullscreenSidebarToggle.classList.toggle("is-collapsed", fullscreenSidebarCollapsed);
  fullscreenSidebarToggle.setAttribute("aria-expanded", String(expanded));
  fullscreenSidebarToggle.setAttribute("aria-label", label);
  fullscreenSidebarToggle.querySelector("span").textContent = label;
  fullscreenSidebarToggle.title = label;
  planner.classList.toggle("fullscreen-sidebar-collapsed", plannerFullscreen && fullscreenSidebarCollapsed);
}


let fullscreenChromeButtonLastTap = 0;
function handleFullscreenChromeButtonTap(event) {
  const sidebarButton = event.target?.closest?.("#fullscreenSidebarToggle");
  const exitButton = event.target?.closest?.("#fullscreenBottomExit");

  if (!sidebarButton && !exitButton) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation?.();

  const now = Date.now();
  if (now - fullscreenChromeButtonLastTap < 420) {
    return;
  }
  fullscreenChromeButtonLastTap = now;

  if (sidebarButton) {
    toggleFullscreenSidebar();
  } else {
    togglePlannerFullscreen();
  }
}

function toggleFullscreenSidebar() {
  fullscreenSidebarCollapsed = !fullscreenSidebarCollapsed;
  updateFullscreenSidebarToggle();
  requestAnimationFrame(updateWallSize);
  window.setTimeout(updateWallSize, 260);
}

function isMobileLikeViewport() {
  return window.matchMedia("(hover: none), (pointer: coarse), (max-width: 1180px)").matches;
}

function ensureBrowserbarSpacer() {
  if (browserbarSpacer) {
    return browserbarSpacer;
  }

  browserbarSpacer = document.createElement("div");
  browserbarSpacer.className = "iwp-browserbar-spacer";
  browserbarSpacer.setAttribute("aria-hidden", "true");
  document.body.append(browserbarSpacer);
  return browserbarSpacer;
}

function clearBrowserbarCollapseAttempt() {
  window.clearTimeout(browserbarAttemptTimer);
  browserbarAttemptTimer = null;
  document.body.classList.remove("iwp-browserbar-collapse-enabled");
  if (browserbarSpacer) {
    browserbarSpacer.remove();
    browserbarSpacer = null;
  }
}

function attemptMobileBrowserbarCollapse() {
  window.clearTimeout(browserbarAttemptTimer);

  if (!plannerFullscreen || !isMobileLikeViewport()) {
    clearBrowserbarCollapseAttempt();
    return;
  }

  document.body.classList.add("iwp-browserbar-collapse-enabled");
  ensureBrowserbarSpacer();

  // iOS/Android only shrink browser chrome when the page itself can scroll.
  // The planner stays fixed while the document scrolls a little behind it.
  const scrollTargets = [1, 64, 128, 180, 96];
  scrollTargets.forEach((target, index) => {
    window.setTimeout(() => {
      if (plannerFullscreen) {
        window.scrollTo(0, target);
      }
    }, 80 + index * 120);
  });

  browserbarAttemptTimer = window.setTimeout(() => {
    if (plannerFullscreen && isMobileLikeViewport()) {
      document.body.classList.add("iwp-browserbar-collapse-enabled");
      window.scrollTo(0, 180);
      window.setTimeout(() => {
        if (plannerFullscreen) {
          window.scrollTo(0, 96);
        }
      }, 180);
    }
  }, 800);
}

function updateWallWorkbarToggle() {
  if (!wallWorkbar || !wallWorkbarToggle) {
    return;
  }

  wallWorkbar.classList.toggle("is-collapsed", wallWorkbarCollapsed);
  wallWorkbarToggle.setAttribute("aria-expanded", String(!wallWorkbarCollapsed));
  wallWorkbarToggle.setAttribute("aria-label", wallWorkbarCollapsed ? t("showWorkbar") : t("hideWorkbar"));
  wallWorkbarToggle.title = wallWorkbarCollapsed ? t("showWorkbar") : t("hideWorkbar");
}

function toggleWallWorkbar() {
  wallWorkbarCollapsed = !wallWorkbarCollapsed;
  updateWallWorkbarToggle();
}


function isPlannerExternalFloatingWidget(element) {
  if (
    !element ||
    element === document.body ||
    element === document.documentElement ||
    element.closest?.(".iwp-shopify-section") ||
    planner?.contains(element)
  ) {
    return false;
  }

  const style = window.getComputedStyle(element);
  if (style.position !== "fixed" && style.position !== "sticky") {
    return false;
  }

  const rect = element.getBoundingClientRect();
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

  if (rect.width < 24 || rect.height < 24 || rect.width > 140 || rect.height > 140) {
    return false;
  }

  if (rect.right < viewportWidth - 180 || rect.bottom < viewportHeight - 220) {
    return false;
  }

  const text = [
    element.id,
    element.className,
    element.getAttribute?.("aria-label"),
    element.getAttribute?.("title"),
    element.getAttribute?.("data-testid"),
    element.getAttribute?.("data-app"),
  ].join(" ").toLowerCase();

  const html = String(element.outerHTML || "").slice(0, 1600).toLowerCase();
  const signature = `${text} ${html}`;

  return (
    signature.includes("joy") ||
    signature.includes("joy-loyalty") ||
    signature.includes("joy loyalty") ||
    signature.includes("joy: loyalty") ||
    signature.includes("avada") ||
    signature.includes("avada-joy") ||
    signature.includes("member") ||
    signature.includes("membership") ||
    signature.includes("reward") ||
    signature.includes("rewards") ||
    signature.includes("loyalty") ||
    signature.includes("vip") ||
    signature.includes("point") ||
    signature.includes("account") ||
    signature.includes("launcher")
  );
}

function hidePlannerExternalFloatingWidgets() {
  if (!document.body.classList.contains("iwp-planner-page-active")) {
    return;
  }

  document.querySelectorAll("body > *").forEach((element) => {
    if (!isPlannerExternalFloatingWidget(element)) {
      return;
    }

    element.setAttribute("data-iwp-hidden-floating-widget", "true");
    element.style.setProperty("display", "none", "important");
    element.style.setProperty("visibility", "hidden", "important");
    element.style.setProperty("opacity", "0", "important");
    element.style.setProperty("pointer-events", "none", "important");
  });
}

let externalFloatingWidgetObserver = null;
function startExternalFloatingWidgetObserver() {
  if (externalFloatingWidgetObserver) {
    return;
  }

  externalFloatingWidgetObserver = new MutationObserver(() => {
    hidePlannerExternalFloatingWidgets();
  });
  externalFloatingWidgetObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["style", "class", "id"],
  });
}

startExternalFloatingWidgetObserver();

window.setTimeout(hidePlannerExternalFloatingWidgets, 80);
window.setTimeout(hidePlannerExternalFloatingWidgets, 500);
window.setTimeout(hidePlannerExternalFloatingWidgets, 1500);


function setPlannerFullscreen(enabled) {
  plannerFullscreen = enabled;
  fullscreenSidebarCollapsed = false;
  if (plannerFullscreen && !wallSettingsCollapsedByUser) {
    wallSettingsCollapsed = false;
  }
  planner.classList.toggle("is-fullscreen", plannerFullscreen);
  planner.classList.remove("fullscreen-sidebar-collapsed");
  document.body.classList.toggle("planner-fullscreen-active", plannerFullscreen);
  if (plannerFullscreen) {
    attemptMobileBrowserbarCollapse();
    hidePlannerExternalFloatingWidgets();
    window.setTimeout(hidePlannerExternalFloatingWidgets, 80);
    window.setTimeout(hidePlannerExternalFloatingWidgets, 300);
    window.setTimeout(hidePlannerExternalFloatingWidgets, 900);
  } else {
    clearBrowserbarCollapseAttempt();
  }
  updateFullscreenToggle();
  updateFullscreenSidebarToggle();
  updateWallSettingsState();
  requestAnimationFrame(() => {
    refreshMobileFullscreenLayout();
    updateWallSize();
    window.setTimeout(renderCoordinateGuides, 80);
  });
}

async function togglePlannerFullscreen() {
  const nextState = !plannerFullscreen;
  setPlannerFullscreen(nextState);

  const useCssOnlyFullscreen = isMobileLikeViewport();

  try {
    if (!useCssOnlyFullscreen && nextState && planner.requestFullscreen && !document.fullscreenElement) {
      await planner.requestFullscreen();
    } else if (!nextState && document.fullscreenElement === planner && document.exitFullscreen) {
      await document.exitFullscreen();
    }
  } catch (error) {
    // CSS fullscreen still works when browser fullscreen is unavailable.
  }
}

function updateDimensionToggle() {
  if (!dimensionToggle) {
    return;
  }

  dimensionToggle.classList.toggle("active", dimensionsVisible);
  dimensionToggle.setAttribute("aria-pressed", String(dimensionsVisible));
  dimensionToggle.textContent = dimensionsVisible ? t("hideDimensions") : t("showDimensions");
  renderDimensionGuides();
}

function getDefaultArCalibration(bounds) {
  const dimensions = getDimensions();
  const scale = Math.min(
    bounds.width / dimensions.width,
    bounds.height / dimensions.height,
  ) * 0.82;
  const width = dimensions.width * scale;
  const height = dimensions.height * scale;

  return {
    left: (bounds.width - width) / 2,
    top: (bounds.height - height) / 2,
    width,
    height,
  };
}

function getArCalibration(bounds) {
  if (!arCalibration) {
    arCalibration = getDefaultArCalibration(bounds);
  }

  const dimensions = getDimensions();
  const minWidth = Math.min(bounds.width * 0.24, 180);
  const minHeight = minWidth * (dimensions.height / dimensions.width);
  const width = clamp(arCalibration.width, minWidth, bounds.width);
  const height = clamp(arCalibration.height, minHeight, bounds.height);

  arCalibration = {
    left: clamp(arCalibration.left, 0, bounds.width - width),
    top: clamp(arCalibration.top, 0, bounds.height - height),
    width,
    height,
  };

  return arCalibration;
}

function updateArCalibration(nextCalibration) {
  const bounds = arOverlay.getBoundingClientRect();
  const dimensions = getDimensions();
  const minWidth = Math.min(bounds.width * 0.24, 180);
  const minHeight = minWidth * (dimensions.height / dimensions.width);
  const width = clamp(nextCalibration.width, minWidth, bounds.width);
  const height = clamp(nextCalibration.height, minHeight, bounds.height);

  arCalibration = {
    left: clamp(nextCalibration.left, 0, bounds.width - width),
    top: clamp(nextCalibration.top, 0, bounds.height - height),
    width,
    height,
  };
  renderArOverlay();
}

function startArCalibration(event) {
  if (event.pointerType === "mouse" && event.button !== 0) {
    return;
  }

  const productElement = event.target.closest(".ar-product");

  if (productElement) {
    const item = placedItems.find((entry) => entry.key === productElement.dataset.key);

    if (!item) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const overlayBounds = arOverlay.getBoundingClientRect();
    const calibration = getArCalibration(overlayBounds);
    const left = Number.parseFloat(productElement.style.left) || calibration.left;
    const top = Number.parseFloat(productElement.style.top) || calibration.top;
    const width = Number.parseFloat(productElement.style.width) || productElement.offsetWidth;
    const height = Number.parseFloat(productElement.style.height) || productElement.offsetHeight;

    arOverlay.setPointerCapture(event.pointerId);
    productElement.classList.add("dragging");
    arProductPointer = {
      pointerId: event.pointerId,
      element: productElement,
      item,
      startX: event.clientX,
      startY: event.clientY,
      startLeft: left,
      startTop: top,
      width,
      height,
      wallLeft: calibration.left,
      wallTop: calibration.top,
      wallWidth: calibration.width,
      wallHeight: calibration.height,
    };
    return;
  }

  const frame = event.target.closest(".ar-wall-frame");

  if (!frame) {
    return;
  }

  event.preventDefault();
  const bounds = arOverlay.getBoundingClientRect();
  const calibration = getArCalibration(bounds);
  const resizing = Boolean(event.target.closest(".ar-resize-handle"));

  frame.setPointerCapture(event.pointerId);
  arCalibrationPointer = {
    pointerId: event.pointerId,
    resizing,
    startX: event.clientX,
    startY: event.clientY,
    start: { ...calibration },
  };
}

function moveArCalibration(event) {
  if (arProductPointer && arProductPointer.pointerId === event.pointerId) {
    const dx = event.clientX - arProductPointer.startX;
    const dy = event.clientY - arProductPointer.startY;
    const minLeft = arProductPointer.wallLeft;
    const minTop = arProductPointer.wallTop;
    const maxLeft = arProductPointer.wallLeft + arProductPointer.wallWidth - arProductPointer.width;
    const maxTop = arProductPointer.wallTop + arProductPointer.wallHeight - arProductPointer.height;
    const left = clamp(arProductPointer.startLeft + dx, minLeft, maxLeft);
    const top = clamp(arProductPointer.startTop + dy, minTop, maxTop);

    arProductPointer.item.xRatio = (left - arProductPointer.wallLeft) / arProductPointer.wallWidth;
    arProductPointer.item.yRatio = (top - arProductPointer.wallTop) / arProductPointer.wallHeight;
    arProductPointer.element.style.left = `${left}px`;
    arProductPointer.element.style.top = `${top}px`;
    return;
  }

  if (!arCalibrationPointer || arCalibrationPointer.pointerId !== event.pointerId) {
    return;
  }

  const dx = event.clientX - arCalibrationPointer.startX;
  const dy = event.clientY - arCalibrationPointer.startY;
  const start = arCalibrationPointer.start;

  if (arCalibrationPointer.resizing) {
    const dimensions = getDimensions();
    const aspectRatio = dimensions.height / dimensions.width;
    const width = start.width + dx;

    updateArCalibration({
      ...start,
      width,
      height: width * aspectRatio,
    });
    return;
  }

  updateArCalibration({
    ...start,
    left: start.left + dx,
    top: start.top + dy,
  });
}

function endArCalibration(event) {
  if (arProductPointer && arProductPointer.pointerId === event.pointerId) {
    arProductPointer.element.classList.remove("dragging");
    if (arOverlay.hasPointerCapture?.(event.pointerId)) {
      arOverlay.releasePointerCapture(event.pointerId);
    }
    arProductPointer = null;
    renderPlacedItems();
    renderArOverlay();
    return;
  }

  if (!arCalibrationPointer || arCalibrationPointer.pointerId !== event.pointerId) {
    return;
  }

  arCalibrationPointer = null;
}

function renderArOverlay() {
  if (!arDialog.open) {
    return;
  }

  arOverlay.replaceChildren();
  arStatus.textContent = placedItems.length === 0 ? t("arEmpty") : "";

  if (placedItems.length === 0) {
    return;
  }

  const dimensions = getDimensions();
  const overlayBounds = arOverlay.getBoundingClientRect();

  if (overlayBounds.width === 0 || overlayBounds.height === 0) {
    requestAnimationFrame(renderArOverlay);
    return;
  }

  const calibration = getArCalibration(overlayBounds);
  const wallWidth = calibration.width;
  const wallHeight = calibration.height;
  const wallLeft = calibration.left;
  const wallTop = calibration.top;
  const wallFrame = document.createElement("div");
  const resizeHandle = document.createElement("span");

  wallFrame.className = "ar-wall-frame";
  wallFrame.style.left = `${wallLeft}px`;
  wallFrame.style.top = `${wallTop}px`;
  wallFrame.style.width = `${wallWidth}px`;
  wallFrame.style.height = `${wallHeight}px`;
  resizeHandle.className = "ar-resize-handle";
  wallFrame.append(resizeHandle);
  arOverlay.append(wallFrame);

  placedItems.forEach((item) => {
    const product = getProduct(item.productId);

    if (!product) {
      return;
    }

    const productElement = document.createElement("div");
    const visual = createProductVisual(product, item);
    const databaseProduct = !isCustomSpanProduct(product) && Boolean(getFixedProduct(product.id));
    const databaseSize = databaseProduct
      ? getUniformDatabaseProductSize(product, item, wallWidth, wallHeight)
      : null;
    const width = databaseSize
      ? databaseSize.width
      : clamp(((isCustomSpanProduct(product) ? getCustomSpanLength(product, item) : item.widthCm) / dimensions.width) * wallWidth, 14, wallWidth * 0.96);
    const height = databaseSize
      ? databaseSize.height
      : clamp(((isCustomSpanProduct(product) ? getCustomSpanConfig(product).visualHeight : item.heightCm) / dimensions.height) * wallHeight, 14, wallHeight * 0.96);
    const left = clamp(wallLeft + item.xRatio * wallWidth, wallLeft, wallLeft + wallWidth - width);
    const top = clamp(wallTop + item.yRatio * wallHeight, wallTop, wallTop + wallHeight - height);

    productElement.className = "ar-product";
    productElement.dataset.key = item.key;
    productElement.classList.toggle("custom-span-item", isCustomSpanProduct(product));
    if (isCustomSpanProduct(product)) {
      productElement.style.setProperty("--span-angle", `${getCustomSpanAngle(item)}deg`);
    }
    productElement.classList.toggle("flipped", item.flipped);
    productElement.classList.toggle("vertical-flipped", item.verticalFlipped);
    productElement.classList.toggle("rotated", item.rotated);
    productElement.classList.toggle("rotated-thickness-boost", item.rotated && product.rotateOnVerticalFlip);
    productElement.style.left = `${left}px`;
    productElement.style.top = `${top}px`;
    productElement.style.width = `${width}px`;
    productElement.style.height = `${height}px`;
    if (item.rotated) {
      productElement.style.setProperty("--rotated-visual-width", `${height}px`);
      productElement.style.setProperty("--rotated-visual-height", `${width}px`);
    }
    productElement.append(visual);
    arOverlay.append(productElement);
  });
}

function loadCaptureImage(src) {
  return new Promise((resolve, reject) => {
    const image = new Image();

    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = src;
  });
}

function drawVideoCover(context, width, height) {
  const videoWidth = arVideo.videoWidth;
  const videoHeight = arVideo.videoHeight;

  if (!videoWidth || !videoHeight) {
    return false;
  }

  const videoRatio = videoWidth / videoHeight;
  const canvasRatio = width / height;
  let sourceWidth = videoWidth;
  let sourceHeight = videoHeight;
  let sourceX = 0;
  let sourceY = 0;

  if (videoRatio > canvasRatio) {
    sourceWidth = videoHeight * canvasRatio;
    sourceX = (videoWidth - sourceWidth) / 2;
  } else {
    sourceHeight = videoWidth / canvasRatio;
    sourceY = (videoHeight - sourceHeight) / 2;
  }

  context.drawImage(arVideo, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, width, height);
  return true;
}

function createArPhotoFilename() {
  const timestamp = new Date()
    .toISOString()
    .replace(/\.\d+Z$/, "")
    .replace(/[-:T]/g, "");

  return `myzoo-ar-${timestamp}.png`;
}

function canvasToBlob(canvas) {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) {
        resolve(blob);
      } else {
        reject(new Error("Canvas export failed"));
      }
    }, "image/png");
  });
}

function downloadArPhotoBlob(blob, filename = createArPhotoFilename()) {
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.href = url;
  link.download = filename;
  link.rel = "noopener";
  document.body.append(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1600);
  arStatus.textContent = t("arDownloaded");
}

async function shareArPhotoBlob(blob, filename = createArPhotoFilename()) {
  if (!(window.File && navigator.share)) {
    return false;
  }

  const file = new File([blob], filename, { type: "image/png" });

  if (navigator.canShare && !navigator.canShare({ files: [file] })) {
    return false;
  }

  try {
    await navigator.share({
      files: [file],
      title: "MYZOO AR",
    });
    arStatus.textContent = t("arCaptured");
    return true;
  } catch (error) {
    if (error?.name === "AbortError") {
      return true;
    }

    console.warn("AR photo share failed:", error);
    return false;
  }
}

function closeArPhotoPreview(preview, imageUrl) {
  preview?.remove();
  if (imageUrl) {
    window.setTimeout(() => URL.revokeObjectURL(imageUrl), 400);
  }
}

function presentArPhotoSaveOptions(blob, filename = createArPhotoFilename()) {
  const imageUrl = URL.createObjectURL(blob);
  const preview = document.createElement("div");
  const panel = document.createElement("div");
  const title = document.createElement("strong");
  const hint = document.createElement("p");
  const image = document.createElement("img");
  const actions = document.createElement("div");
  const saveButton = document.createElement("button");
  const downloadButton = document.createElement("button");
  const closeButton = document.createElement("button");

  document.querySelector(".ar-photo-save-preview")?.remove();
  preview.className = "ar-photo-save-preview";
  panel.className = "ar-photo-save-panel";
  title.textContent = t("arPreviewTitle");
  hint.textContent = t("arPreviewHint");
  image.src = imageUrl;
  image.alt = "MYZOO AR";
  actions.className = "ar-photo-save-actions";
  saveButton.type = "button";
  downloadButton.type = "button";
  closeButton.type = "button";
  saveButton.className = "ar-photo-save-primary";
  saveButton.textContent = t("arSavePhoto");
  downloadButton.textContent = t("arDownloadPhoto");
  closeButton.textContent = t("arClosePreview");

  saveButton.addEventListener("click", async () => {
    const shared = await shareArPhotoBlob(blob, filename);

    if (shared) {
      closeArPhotoPreview(preview, imageUrl);
      return;
    }

    arStatus.textContent = t("arShareFailed");
  });

  downloadButton.addEventListener("click", () => {
    downloadArPhotoBlob(blob, filename);
    closeArPhotoPreview(preview, imageUrl);
  });

  closeButton.addEventListener("click", () => closeArPhotoPreview(preview, imageUrl));
  preview.addEventListener("click", (event) => {
    if (event.target === preview) {
      closeArPhotoPreview(preview, imageUrl);
    }
  });

  actions.append(saveButton, downloadButton, closeButton);
  panel.append(title, hint, image, actions);
  preview.append(panel);
  (arDialog.querySelector(".ar-shell") || arDialog || document.body).append(preview);
  arStatus.textContent = t("arCaptured");
}

function isAndroidDevice() {
  const ua = navigator.userAgent || navigator.vendor || "";
  return /Android/i.test(ua);
}

async function saveArPhotoBlob(blob) {
  const filename = createArPhotoFilename();

  // Android should not download immediately. Show a clear confirmation panel first,
  // then download only after the user taps the download button.
  if (isAndroidDevice()) {
    presentArPhotoSaveOptions(blob, filename);
    return;
  }

  const shared = await shareArPhotoBlob(blob, filename);

  if (shared) {
    return;
  }

  presentArPhotoSaveOptions(blob, filename);
}

async function captureArPhoto() {
  const overlayBounds = arOverlay.getBoundingClientRect();
  const ratio = Math.min(window.devicePixelRatio || 1, 2);
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  if (!context || overlayBounds.width === 0 || overlayBounds.height === 0) {
    arStatus.textContent = t("arCaptureError");
    return;
  }

  try {
    arStatus.textContent = t("arSaving");
    canvas.width = Math.round(overlayBounds.width * ratio);
    canvas.height = Math.round(overlayBounds.height * ratio);
    context.scale(ratio, ratio);

    if (!drawVideoCover(context, overlayBounds.width, overlayBounds.height)) {
      arStatus.textContent = t("arCaptureError");
      return;
    }

    const dimensions = getDimensions();
    const calibration = getArCalibration(overlayBounds);

    context.save();
    context.strokeStyle = "rgba(255, 255, 255, 0.72)";
    context.setLineDash([8, 6]);
    context.lineWidth = 2;
    context.strokeRect(calibration.left, calibration.top, calibration.width, calibration.height);
    context.restore();

    for (const item of placedItems) {
      const product = getProduct(item.productId);
      const color = product ? getPlacedProductColor(product, item) : "";
      const productImage = product ? getProductImageForColor(product, color) : "";

      if (!productImage) {
        continue;
      }

      const image = await loadCaptureImage(productImage);
      const databaseProduct = Boolean(getFixedProduct(product?.id));
      const databaseSize = databaseProduct
        ? getUniformDatabaseProductSize(product, item, calibration.width, calibration.height)
        : null;
      const width = databaseSize
        ? databaseSize.width
        : clamp((item.widthCm / dimensions.width) * calibration.width, 14, calibration.width * 0.96);
      const height = databaseSize
        ? databaseSize.height
        : clamp((item.heightCm / dimensions.height) * calibration.height, 14, calibration.height * 0.96);
      const left = clamp(
        calibration.left + item.xRatio * calibration.width,
        calibration.left,
        calibration.left + calibration.width - width,
      );
      const top = clamp(
        calibration.top + item.yRatio * calibration.height,
        calibration.top,
        calibration.top + calibration.height - height,
      );

      context.save();
      context.globalAlpha = 0.92;
      context.shadowColor = "rgba(0, 0, 0, 0.36)";
      context.shadowBlur = 16;
      context.shadowOffsetY = 8;
      if (item.flipped) {
        context.translate(left + width, top);
        context.scale(-1, 1);
        context.drawImage(image, 0, 0, width, height);
      } else {
        context.drawImage(image, left, top, width, height);
      }
      context.restore();
    }

    await saveArPhotoBlob(await canvasToBlob(canvas));
  } catch (error) {
    arStatus.textContent = t("arCaptureError");
  }
}


function requestArFullscreenMode() {
  document.body.classList.add("ar-fullscreen-active");

  if (document.fullscreenElement) {
    arOwnsFullscreen = false;
    return;
  }

  const target = arDialog || document.documentElement;
  const requestFullscreen = target?.requestFullscreen || document.documentElement?.requestFullscreen;

  if (!requestFullscreen) {
    arOwnsFullscreen = false;
    return;
  }

  Promise.resolve()
    .then(() => requestFullscreen.call(target, { navigationUI: "hide" }))
    .catch(() => requestFullscreen.call(target))
    .then(() => {
      arOwnsFullscreen = true;
    })
    .catch(() => {
      arOwnsFullscreen = false;
    });
}

async function openArExperience() {
  if (!navigator.mediaDevices?.getUserMedia) {
    if (!arDialog.open) {
      arDialog.showModal();
    }
    arStatus.textContent = t("arCameraError");
    renderArOverlay();
    return;
  }

  arStatus.textContent = t("arStarting");
  arDialog.classList.add("clean-fullscreen");
  document.body.classList.add("ar-fullscreen-active");

  if (!arDialog.open) {
    arDialog.showModal();
  }
  requestArFullscreenMode();
  requestAnimationFrame(renderArOverlay);

  try {
    arStream = await navigator.mediaDevices.getUserMedia({
      audio: false,
      video: {
        facingMode: { ideal: "environment" },
      },
    });

    if (!arDialog.open) {
      arStream.getTracks().forEach((track) => track.stop());
      arStream = null;
      return;
    }

    arVideo.srcObject = arStream;
    await arVideo.play();
    renderArOverlay();
  } catch (error) {
    arStatus.textContent = t("arCameraError");
  }
}

function closeArExperience() {
  if (arStream) {
    arStream.getTracks().forEach((track) => track.stop());
    arStream = null;
  }

  arVideo.srcObject = null;
  arOverlay.replaceChildren();
  arStatus.textContent = "";
  arDialog.classList.remove("clean-fullscreen");
  document.body.classList.remove("ar-fullscreen-active");
  arCalibrationPointer = null;
  arProductPointer = null;

  if (arDialog.open) {
    arDialog.close();
  }
  if (arOwnsFullscreen && document.fullscreenElement && document.exitFullscreen) {
    document.exitFullscreen().catch(() => {});
  }
  arOwnsFullscreen = false;
}

function renderPlacedItems() {
  wall.querySelectorAll(".placed-item, .coordinate-guide, .coordinate-legend, .dimension-guide").forEach((element) => element.remove());
  wall.closest(".wall-stage")?.querySelectorAll(":scope > .coordinate-legend").forEach((element) => element.remove());
  const bounds = wall.getBoundingClientRect();
  const existingKeys = new Set(placedItems.map((item) => item.key));

  selectedItemKeys = new Set([...selectedItemKeys].filter((key) => existingKeys.has(key)));
  if (selectedItemKey && !existingKeys.has(selectedItemKey)) {
    selectedItemKey = [...selectedItemKeys][0] || null;
  }
  if (selectedItemKey && selectedItemKeys.size === 0) {
    selectedItemKeys.add(selectedItemKey);
  }

  placedItems.forEach((item) => {
    const product = getProduct(item.productId);
    const productName = getDisplayName(product);
    const element = document.createElement("article");
    const art = createProductVisual(product, item);

    element.className = "placed-item";
    element.classList.toggle("selected", selectedItemKeys.has(item.key));
    element.classList.toggle("multi-selected", selectedItemKeys.size > 1 && selectedItemKeys.has(item.key));
    element.classList.toggle("grouped", Boolean(item.groupId));
    element.classList.toggle("wheel-hidden", item.key === hiddenActionWheelKey);
    element.classList.toggle("flipped", item.flipped);
    element.classList.toggle("vertical-flipped", item.verticalFlipped);
    element.classList.toggle("rotated", item.rotated);
    element.classList.toggle("rotated-thickness-boost", item.rotated && product?.rotateOnVerticalFlip);
    element.classList.toggle("shape-object", isShapeObjectProduct(product));
    element.classList.toggle("custom-span-item", isCustomSpanProduct(product));
    element.classList.toggle("loop-tower-item", product?.id === "tower-loop");
    element.classList.add(`controls-${getControlSide(item, bounds)}`);
    element.dataset.key = item.key;
    element.tabIndex = 0;
    element.setAttribute(
      "aria-label",
      getPlacedLabel(product, item),
    );

    element.append(art);
    if (isCustomSpanProduct(product)) {
      const leftHandle = document.createElement("button");
      const rightHandle = document.createElement("button");

      leftHandle.type = "button";
      rightHandle.type = "button";
      leftHandle.className = "custom-span-handle custom-span-handle-left";
      rightHandle.className = "custom-span-handle custom-span-handle-right";
      leftHandle.dataset.side = "left";
      rightHandle.dataset.side = "right";
      leftHandle.title = t("spanLeftAnchor");
      rightHandle.title = t("spanRightAnchor");
      leftHandle.setAttribute("aria-label", t("spanLeftAnchor"));
      rightHandle.setAttribute("aria-label", t("spanRightAnchor"));
      leftHandle.addEventListener("pointerdown", startCustomSpanHandleDrag);
      rightHandle.addEventListener("pointerdown", startCustomSpanHandleDrag);
      element.append(leftHandle, rightHandle);
      refreshCustomSpanElement(element, product, item);
    }
    if (isShapeObjectProduct(product)) {
      element.append(createAccessoryActionWheel(product, item, bounds));
    } else {
      element.append(createPlacedActionWheel(product, item, element, bounds));
    }
    if (product.resizable !== false && !isCustomSpanProduct(product)) {
      const resizeHandle = document.createElement("button");

      resizeHandle.type = "button";
      resizeHandle.className = "resize-handle";
      resizeHandle.title = t("resizeNamed", productName);
      resizeHandle.setAttribute("aria-label", t("resizeNamed", productName));
      resizeHandle.addEventListener("pointerdown", startResize);
      element.append(resizeHandle);
    }
    element.addEventListener("pointerdown", startMove);
    element.addEventListener("focus", () => selectItem(element));
    element.addEventListener("keydown", (event) => {
      if (event.key === "Delete" || event.key === "Backspace") {
        removeProduct(item.key);
      }
    });
    positionItem(element, item);
    wall.append(element);
  });

  countItems();
  renderDimensionGuides();
  renderCoordinateGuides();
  renderArOverlay();
}


function createShapeRemoveButton(product, item) {
  const button = document.createElement("button");
  const productName = getDisplayName(product);

  button.type = "button";
  button.className = "shape-remove-button";
  button.textContent = "×";
  button.title = t("removeNamed", productName);
  button.setAttribute("aria-label", t("removeNamed", productName));
  button.addEventListener("pointerdown", (event) => {
    event.stopPropagation();
  });
  button.addEventListener("click", (event) => {
    event.stopPropagation();
    removeProduct(item.key);
  });
  return button;
}

function createAccessoryActionWheel(product, item, bounds = wall.getBoundingClientRect()) {
  const wheel = document.createElement("div");
  const productName = getDisplayName(product);
  const current = document.createElement("div");
  const copyButton = document.createElement("button");
  const deleteButton = document.createElement("button");

  wheel.className = `placed-action-wheel accessory-action-wheel wheel-${getActionWheelPlacement(item, bounds)}`;
  wheel.setAttribute("aria-label", productName);
  wheel.addEventListener("pointerdown", (event) => event.stopPropagation());

  current.className = "action-wheel-current accessory-action-wheel-current light";
  current.setAttribute("aria-hidden", "true");
  wheel.append(current);

  copyButton.type = "button";
  copyButton.className = "action-wheel-button action-wheel-copy";
  copyButton.title = t("copyNamed", productName);
  copyButton.setAttribute("aria-label", t("copyNamed", productName));
  copyButton.addEventListener("click", (event) => {
    event.stopPropagation();
    duplicatePlacedItem(item);
  });

  deleteButton.type = "button";
  deleteButton.className = "action-wheel-button action-wheel-delete";
  deleteButton.title = t("removeNamed", productName);
  deleteButton.setAttribute("aria-label", t("removeNamed", productName));
  deleteButton.addEventListener("click", (event) => {
    event.stopPropagation();
    removeProduct(item.key);
  });

  wheel.append(copyButton, deleteButton);
  return wheel;
}

function createPlacedActionWheel(product, item, element, bounds = wall.getBoundingClientRect()) {
  const wheel = document.createElement("div");
  const availableColors = normalizeProductColors(product.colors || product.color);
  const selectedColor = getPlacedProductColor(product, item);
  const previousColor = item.wheelColorFrom;
  const productName = getDisplayName(product);
  const colorLabel = getProductColorLabel(selectedColor);

  wheel.className = `placed-action-wheel wheel-${getActionWheelPlacement(item, bounds)}`;
  wheel.setAttribute("aria-label", t("colorChooser", productName));
  wheel.addEventListener("pointerdown", (event) => {
    event.stopPropagation();
  });

  const current = document.createElement("div");

  current.className = "action-wheel-current";
  current.classList.toggle("light", ["light-wood", "white", "transparent"].includes(selectedColor));
  current.style.background = getProductColorSwatch(selectedColor);
  if (previousColor && previousColor !== selectedColor) {
    const fromTone = document.createElement("span");
    const toTone = document.createElement("span");

    fromTone.className = "action-wheel-current-tone from";
    toTone.className = "action-wheel-current-tone to";
    fromTone.style.background = getProductColorSwatch(previousColor);
    toTone.style.background = getProductColorSwatch(selectedColor);
    current.append(fromTone, toTone);
  }
  const currentLabel = document.createElement("span");

  currentLabel.className = "action-wheel-current-label";
  currentLabel.textContent = colorLabel.toUpperCase();
  current.append(currentLabel);
  delete item.wheelColorFrom;
  wheel.append(current);

  const closeButton = document.createElement("button");

  closeButton.type = "button";
  closeButton.className = "action-wheel-close";
  closeButton.textContent = "×";
  closeButton.title = t("closeAr");
  closeButton.setAttribute("aria-label", t("closeAr"));
  closeButton.addEventListener("click", (event) => {
    event.stopPropagation();
    hiddenActionWheelKey = item.key;
    selectedItemKey = item.key;
    renderPlacedItems();
  });
  wheel.append(closeButton);

  availableColors.forEach((color) => {
    const button = document.createElement("button");
    const index = availableColors.indexOf(color);
    const swatchGapPx = 10;
    const swatchRadius = 65;
    const swatchStep = ((31 + swatchGapPx) / swatchRadius) * (180 / Math.PI);
    const arcCenter = -90;
    const arcStart = arcCenter - (swatchStep * (availableColors.length - 1)) / 2;
    const angle = availableColors.length === 1
      ? arcCenter
      : arcStart + swatchStep * index;

    button.type = "button";
    button.className = "action-wheel-swatch";
    button.classList.toggle("active", color === selectedColor);
    button.style.background = getProductColorSwatch(color);
    button.style.setProperty("--angle", `${angle}deg`);
    button.title = getProductColorLabel(color);
    button.setAttribute("aria-label", t("applyColor", getProductColorLabel(color)));
    button.addEventListener("click", (event) => {
      event.stopPropagation();
      if (color === selectedColor) {
        return;
      }
      item.wheelColorFrom = selectedColor;
      item.color = color;
      selectedItemKey = item.key;
      hiddenActionWheelKey = null;
      renderPlacedItems();
    });
    wheel.append(button);
  });

  const copyButton = document.createElement("button");

  copyButton.type = "button";
  copyButton.className = "action-wheel-button action-wheel-copy";
  copyButton.title = t("copyNamed", productName);
  copyButton.setAttribute("aria-label", t("copyNamed", productName));
  copyButton.addEventListener("click", (event) => {
    event.stopPropagation();
    duplicatePlacedItem(item);
  });
  wheel.append(copyButton);

  if (product.flippable) {
    const flipButton = document.createElement("button");

    flipButton.type = "button";
    flipButton.className = "action-wheel-button action-wheel-flip";
    flipButton.title = t("flipNamed", productName);
    flipButton.setAttribute("aria-label", t("flipNamed", productName));
    flipButton.addEventListener("click", (event) => {
      event.stopPropagation();
      flipPlacedItem(element, item);
    });
    wheel.append(flipButton);
  }

  if (product.verticalFlippable) {
    const verticalFlipButton = document.createElement("button");
    const verticalTitle = product.rotateOnVerticalFlip ? "向右旋轉90度" : "上下翻轉";

    verticalFlipButton.type = "button";
    verticalFlipButton.className = "action-wheel-button action-wheel-vertical-flip";
    verticalFlipButton.title = verticalTitle;
    verticalFlipButton.setAttribute("aria-label", verticalTitle);
    verticalFlipButton.addEventListener("click", (event) => {
      event.stopPropagation();
      toggleVerticalPlacedItem(element, item, product);
    });
    wheel.append(verticalFlipButton);
  }

  if (item.groupId) {
    const ungroupButton = document.createElement("button");

    ungroupButton.type = "button";
    ungroupButton.className = "action-wheel-button action-wheel-ungroup";
    ungroupButton.title = t("ungroupSelection");
    ungroupButton.setAttribute("aria-label", t("ungroupSelection"));
    ungroupButton.addEventListener("click", (event) => {
      event.stopPropagation();
      ungroupPlacedItem(item);
    });
    wheel.append(ungroupButton);
  }

  const deleteButton = document.createElement("button");

  deleteButton.type = "button";
  deleteButton.className = "action-wheel-button action-wheel-delete";
  deleteButton.title = t("removeNamed", productName);
  deleteButton.setAttribute("aria-label", t("removeNamed", productName));
  deleteButton.addEventListener("click", (event) => {
    event.stopPropagation();
    removeProduct(item.key);
  });
  wheel.append(deleteButton);

  return wheel;
}

const productImagePaddingTrimCache = new Map();
const paddingTrimExcludedProductIds = new Set(["hover"]);

function scheduleProductImagePaddingTrim(image) {
  if (!image || image.dataset.paddingTrimScheduled === "true") {
    return;
  }

  if (paddingTrimExcludedProductIds.has(image.dataset.productId)) {
    return;
  }

  image.dataset.paddingTrimScheduled = "true";

  const run = () => trimProductImagePadding(image);

  if (image.complete && image.naturalWidth > 0 && image.naturalHeight > 0) {
    requestAnimationFrame(run);
    return;
  }

  image.addEventListener("load", run, { once: true });
}

function applyProductImagePaddingTrim(image, trim) {
  if (!trim || paddingTrimExcludedProductIds.has(image.dataset.productId)) {
    image.classList.remove("padding-trimmed");
    image.style.removeProperty("--image-trim-scale");
    image.style.removeProperty("--image-trim-origin-x");
    image.style.removeProperty("--image-trim-origin-y");
    return;
  }

  image.classList.add("padding-trimmed");
  image.style.setProperty("--image-trim-scale", String(trim.scale));
  image.style.setProperty("--image-trim-origin-x", `${trim.originX}%`);
  image.style.setProperty("--image-trim-origin-y", `${trim.originY}%`);
}

function trimProductImagePadding(image) {
  if (paddingTrimExcludedProductIds.has(image.dataset.productId)) {
    applyProductImagePaddingTrim(image, null);
    return;
  }

  const src = image.currentSrc || image.src || "";

  if (!src || !image.naturalWidth || !image.naturalHeight) {
    return;
  }

  if (productImagePaddingTrimCache.has(src)) {
    applyProductImagePaddingTrim(image, productImagePaddingTrimCache.get(src));
    return;
  }

  try {
    const naturalWidth = image.naturalWidth;
    const naturalHeight = image.naturalHeight;
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d", { willReadFrequently: true });

    canvas.width = naturalWidth;
    canvas.height = naturalHeight;
    context.drawImage(image, 0, 0, naturalWidth, naturalHeight);

    const data = context.getImageData(0, 0, naturalWidth, naturalHeight).data;
    let minX = naturalWidth;
    let minY = naturalHeight;
    let maxX = -1;
    let maxY = -1;

    for (let y = 0; y < naturalHeight; y += 1) {
      const rowOffset = y * naturalWidth * 4;

      for (let x = 0; x < naturalWidth; x += 1) {
        const alpha = data[rowOffset + x * 4 + 3];

        if (alpha > 8) {
          if (x < minX) minX = x;
          if (y < minY) minY = y;
          if (x > maxX) maxX = x;
          if (y > maxY) maxY = y;
        }
      }
    }

    if (maxX < minX || maxY < minY) {
      productImagePaddingTrimCache.set(src, null);
      applyProductImagePaddingTrim(image, null);
      return;
    }

    const contentWidth = maxX - minX + 1;
    const contentHeight = maxY - minY + 1;
    const horizontalPadding = 1 - contentWidth / naturalWidth;
    const verticalPadding = 1 - contentHeight / naturalHeight;

    if (horizontalPadding < 0.025 && verticalPadding < 0.025) {
      productImagePaddingTrimCache.set(src, null);
      applyProductImagePaddingTrim(image, null);
      return;
    }

    const rawScale = Math.min(naturalWidth / contentWidth, naturalHeight / contentHeight);
    const trim = {
      scale: Math.min(Math.max(rawScale, 1), 2.4),
      originX: ((minX + contentWidth / 2) / naturalWidth) * 100,
      originY: ((minY + contentHeight / 2) / naturalHeight) * 100,
    };

    productImagePaddingTrimCache.set(src, trim);
    applyProductImagePaddingTrim(image, trim);
  } catch (error) {
    productImagePaddingTrimCache.set(src, null);
    applyProductImagePaddingTrim(image, null);
  }
}


function createProductVisual(product, item = null) {
  if (isShapeObjectProduct(product)) {
    const shape = document.createElement("span");

    shape.className = "placed-shape-object";
    shape.textContent = getDisplayName(product);
    return shape;
  }

  if (isCustomSpanProduct(product)) {
    return createCustomSpanVisual(product, item);
  }

  const color = item ? getPlacedProductColor(product, item) : getPrimaryProductColor(product);
  const productImage = getProductImageForColor(product, color);

  if (productImage) {
    const image = document.createElement("img");

    image.className = "placed-image";
    image.crossOrigin = "anonymous";
    image.dataset.productId = product.id;
    image.draggable = false;
    image.setAttribute("draggable", "false");
    if (getFixedProduct(product.id) && !hasProductColorImage(product, color)) {
      image.classList.add(`product-tone-${color}`);
    }
    image.src = productImage;
    image.alt = "";
    image.draggable = false;
    image.addEventListener("load", () => scheduleProductImagePaddingTrim(image), { once: true });
    image.addEventListener("error", () => {
      const fallbackImage = product?.image || "";
      if (fallbackImage && image.src !== fallbackImage) {
        image.src = fallbackImage;
      }
    }, { once: true });
    scheduleProductImagePaddingTrim(image);
    return image;
  }

  const art = document.createElement("span");

  art.className = `product-art ${product.art}`;
  return art;
}

function getPlacedLabel(product, item) {
  const actions = [t("draggable")];
  const productName = getDisplayName(product);

  if (product.resizable !== false) {
    actions.push(t("resizeAction"));
  }

  if (product.flippable) {
    actions.push(t("flipAction"));
  }

  return t(
    "placedLabel",
    productName,
    isCustomSpanProduct(product) ? formatDimension(getCustomSpanLength(product, item)) : formatDimension(item.widthCm),
    formatDimension(item.heightCm),
    actions.join(t("actionJoin")),
  );
}

function flipPlacedItem(element, item) {
  item.flipped = !item.flipped;
  element.classList.toggle("flipped", item.flipped);
}

function toggleVerticalPlacedItem(element, item, product) {
  if (product?.rotateOnVerticalFlip) {
    item.rotated = !item.rotated;
    const nextWidth = item.heightCm;
    const nextHeight = item.widthCm;
    item.widthCm = nextWidth;
    item.heightCm = nextHeight;
    const bounds = wall.getBoundingClientRect();
    updateItemPosition(item, getItemRect(item, bounds), bounds);
  } else {
    item.verticalFlipped = !item.verticalFlipped;
  }

  element.classList.toggle("vertical-flipped", item.verticalFlipped);
  element.classList.toggle("rotated", item.rotated);
  renderPlacedItems();
}


function updateSelectionModeToggle() {
  if (groupSelectionButton) {
    groupSelectionButton.textContent = t("groupSelection");
  }
  if (!selectionModeToggle) {
    return;
  }

  selectionModeToggle.textContent = selectionModeActive ? t("selectAreaActive") : t("selectArea");
  selectionModeToggle.classList.toggle("active", selectionModeActive);
  selectionModeToggle.setAttribute("aria-pressed", String(selectionModeActive));
  wall.classList.toggle("selection-mode", selectionModeActive);
}

function toggleSelectionMode() {
  selectionModeActive = !selectionModeActive;
  updateSelectionModeToggle();
}

function getWallPoint(event, bounds = wall.getBoundingClientRect()) {
  return {
    x: clamp(event.clientX - bounds.left, 0, bounds.width),
    y: clamp(event.clientY - bounds.top, 0, bounds.height),
  };
}

function getSelectionBox(startX, startY, currentX, currentY) {
  const left = Math.min(startX, currentX);
  const top = Math.min(startY, currentY);
  const width = Math.abs(currentX - startX);
  const height = Math.abs(currentY - startY);

  return {
    left,
    top,
    width,
    height,
    right: left + width,
    bottom: top + height,
  };
}

function intersectsBox(a, b) {
  return a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
}

function startWallSelection(event) {
  if (event.pointerType === "mouse" && event.button !== 0) {
    return;
  }

  if (event.target.closest(".placed-item, button, input, select, textarea, label, .placed-action-wheel, .placed-color-panel")) {
    return;
  }

  const shouldStart = event.pointerType === "mouse" || selectionModeActive;

  if (!shouldStart) {
    return;
  }

  event.preventDefault();
  const bounds = wall.getBoundingClientRect();
  const start = getWallPoint(event, bounds);
  const marquee = document.createElement("div");

  marquee.className = "selection-marquee";
  marquee.style.left = `${start.x}px`;
  marquee.style.top = `${start.y}px`;
  marquee.style.width = "0px";
  marquee.style.height = "0px";
  wall.append(marquee);
  wall.setPointerCapture(event.pointerId);
  selectionMarqueePointer = {
    pointerId: event.pointerId,
    bounds,
    startX: start.x,
    startY: start.y,
    marquee,
    moved: false,
  };
}

function updateWallSelection(event) {
  if (!selectionMarqueePointer || selectionMarqueePointer.pointerId !== event.pointerId) {
    return;
  }

  event.preventDefault();
  const point = getWallPoint(event, selectionMarqueePointer.bounds);
  const box = getSelectionBox(
    selectionMarqueePointer.startX,
    selectionMarqueePointer.startY,
    point.x,
    point.y,
  );

  selectionMarqueePointer.moved = selectionMarqueePointer.moved || box.width > 6 || box.height > 6;
  selectionMarqueePointer.marquee.style.left = `${box.left}px`;
  selectionMarqueePointer.marquee.style.top = `${box.top}px`;
  selectionMarqueePointer.marquee.style.width = `${box.width}px`;
  selectionMarqueePointer.marquee.style.height = `${box.height}px`;
}

function finishWallSelection(event) {
  if (!selectionMarqueePointer || selectionMarqueePointer.pointerId !== event.pointerId) {
    return;
  }

  const pointer = selectionMarqueePointer;
  const point = getWallPoint(event, pointer.bounds);
  const box = getSelectionBox(pointer.startX, pointer.startY, point.x, point.y);

  pointer.marquee.remove();
  selectionMarqueePointer = null;

  if (!pointer.moved) {
    clearSelectedItem();
  } else {
    const selectedKeys = placedItems
      .filter((item) => {
        const rect = getItemRect(item, pointer.bounds);
        const itemBox = {
          left: rect.left,
          top: rect.top,
          right: rect.left + rect.width,
          bottom: rect.top + rect.height,
        };

        return intersectsBox(box, itemBox);
      })
      .map((item) => item.key);

    selectedItemKeys = new Set(selectedKeys);
    selectedItemKey = selectedKeys[selectedKeys.length - 1] || null;
    hiddenActionWheelKey = null;
    updateSelectedElements();
  }

  if (selectionModeActive && event.pointerType !== "mouse") {
    selectionModeActive = false;
    updateSelectionModeToggle();
  }
}


function getGroupKeysForItemKey(key) {
  const item = placedItems.find((entry) => entry.key === key);

  if (!item?.groupId) {
    return [key];
  }

  return placedItems
    .filter((entry) => entry.groupId === item.groupId)
    .map((entry) => entry.key);
}


function flashGroupSelectionButton() {
  if (!groupSelectionButton) {
    return;
  }

  groupSelectionButton.classList.remove("is-confirmed");
  groupSelectionButton.classList.remove("is-flashing");
  void groupSelectionButton.offsetWidth;
  groupSelectionButton.classList.add("is-flashing");
  window.setTimeout(() => {
    groupSelectionButton.classList.remove("is-flashing");
    groupSelectionButton.classList.remove("is-confirmed");
    groupSelectionButton.blur();
  }, 500);
}

function showGroupSelectionNotice() {
  document.querySelectorAll(".wall-group-notice").forEach((node) => node.remove());

  const notice = document.createElement("div");

  notice.className = "wall-group-notice is-visible";
  notice.textContent = t("groupNeedSelection");
  notice.setAttribute("role", "status");
  notice.setAttribute("aria-live", "polite");

  const noticeRoot = planner || document.body;
  noticeRoot.append(notice);

  window.setTimeout(() => {
    notice.classList.remove("is-visible");
    window.setTimeout(() => notice.remove(), 180);
  }, 1900);
}

function groupSelectedItems() {
  const selectedKeys = [...selectedItemKeys].filter((key) => placedItems.some((item) => item.key === key));

  if (selectedKeys.length < 2) {
    showGroupSelectionNotice();
    flashGroupSelectionButton();
    return;
  }

  itemGroupSerial += 1;
  const groupId = `group-${Date.now()}-${itemGroupSerial}`;

  placedItems = placedItems.map((item) => (
    selectedKeys.includes(item.key)
      ? { ...item, groupId }
      : item
  ));
  selectedItemKeys = new Set(selectedKeys);
  selectedItemKey = selectedKeys[selectedKeys.length - 1] || null;
  hiddenActionWheelKey = null;
  flashGroupSelectionButton();
  renderPlacedItems();
}

function ungroupPlacedItem(item) {
  if (!item?.groupId) {
    return;
  }

  const groupId = item.groupId;
  const groupKeys = placedItems
    .filter((entry) => entry.groupId === groupId)
    .map((entry) => entry.key);

  placedItems = placedItems.map((entry) => {
    if (entry.groupId !== groupId) {
      return entry;
    }

    const nextEntry = { ...entry };
    delete nextEntry.groupId;
    return nextEntry;
  });

  selectedItemKeys = new Set(groupKeys);
  selectedItemKey = item.key;
  hiddenActionWheelKey = null;
  renderPlacedItems();
}

function updateSelectedElements() {
  wall.querySelectorAll(".placed-item").forEach((element) => {
    const isSelected = selectedItemKeys.has(element.dataset.key);

    element.classList.toggle("selected", isSelected);
    element.classList.toggle("multi-selected", selectedItemKeys.size > 1 && isSelected);
    element.classList.toggle("grouped", Boolean(placedItems.find((item) => item.key === element.dataset.key)?.groupId));
    element.classList.toggle("wheel-hidden", element.dataset.key === hiddenActionWheelKey);
  });
  renderDimensionGuides();
}

function selectItem(selectedElement, options = {}) {
  const nextKey = selectedElement.dataset.key;
  const additive = Boolean(options.additive);

  if (selectedItemKey !== nextKey || hiddenActionWheelKey === nextKey) {
    hiddenActionWheelKey = null;
  }

  if (additive) {
    if (selectedItemKeys.has(nextKey) && selectedItemKeys.size > 1) {
      selectedItemKeys.delete(nextKey);
      selectedItemKey = [...selectedItemKeys][selectedItemKeys.size - 1] || null;
    } else {
      selectedItemKeys.add(nextKey);
      selectedItemKey = nextKey;
    }
  } else {
    selectedItemKeys = new Set([nextKey]);
    selectedItemKey = nextKey;
  }

  if (selectedItemKeys.size !== 1) {
    hiddenActionWheelKey = null;
  }

  updateSelectedElements();
}

function clearSelectedItem() {
  selectedItemKey = null;
  selectedItemKeys.clear();
  hiddenActionWheelKey = null;
  wall.querySelectorAll(".placed-item").forEach((element) => {
    element.classList.remove("selected");
    element.classList.remove("multi-selected");
  });
  renderDimensionGuides();
}

function startMove(event) {
  if (event.pointerType === "mouse" && event.button !== 0) {
    return;
  }

  const element = event.currentTarget;
  const key = element.dataset.key;
  const wallBounds = wall.getBoundingClientRect();
  const moveItem = placedItems.find((entry) => entry.key === key);
  const moveProduct = moveItem ? getProduct(moveItem.productId) : null;

  if (isCustomSpanProduct(moveProduct)) {
    const hitSide = getCustomSpanEndpointHitSide(event, moveItem, wallBounds);

    if (hitSide && startCustomSpanEndpointDrag(event, element, moveItem, hitSide)) {
      return;
    }
  }

  if (event.target.closest("button, .placed-color-panel, .placed-action-wheel")) {
    return;
  }

  const additive = event.shiftKey || event.metaKey || event.ctrlKey;

  if (additive) {
    selectItem(element, { additive: true });
    if (!selectedItemKeys.has(key)) {
      return;
    }
  } else if (moveItem?.groupId) {
    selectedItemKeys = new Set(getGroupKeysForItemKey(key));
    selectedItemKey = key;
    hiddenActionWheelKey = null;
    updateSelectedElements();
  } else if (!selectedItemKeys.has(key)) {
    selectItem(element);
  } else {
    updateSelectedElements();
  }

  const selectedKeys = [...selectedItemKeys];
  const startRects = selectedKeys
    .map((selectedKey) => {
      const selectedElement = wall.querySelector(`.placed-item[data-key="${selectedKey}"]`);
      const item = placedItems.find((entry) => entry.key === selectedKey);

      if (!selectedElement || !item) {
        return null;
      }

      const bounds = selectedElement.getBoundingClientRect();

      return {
        key: selectedKey,
        element: selectedElement,
        item,
        left: bounds.left - wallBounds.left,
        top: bounds.top - wallBounds.top,
        width: bounds.width,
        height: bounds.height,
      };
    })
    .filter(Boolean);

  if (startRects.length === 0) {
    return;
  }

  const groupBounds = startRects.reduce((box, rect) => ({
    left: Math.min(box.left, rect.left),
    top: Math.min(box.top, rect.top),
    right: Math.max(box.right, rect.left + rect.width),
    bottom: Math.max(box.bottom, rect.top + rect.height),
  }), {
    left: Infinity,
    top: Infinity,
    right: -Infinity,
    bottom: -Infinity,
  });

  startRects.forEach((rect) => rect.element.classList.add("dragging"));
  element.setPointerCapture(event.pointerId);
  activePointer = {
    pointerId: event.pointerId,
    element,
    selectedKeys,
    startX: event.clientX,
    startY: event.clientY,
    startRects,
    groupBounds,
    wallBounds,
  };
}

function startResize(event) {
  if (event.pointerType === "mouse" && event.button !== 0) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  const element = event.currentTarget.closest(".placed-item");
  const item = placedItems.find((entry) => entry.key === element.dataset.key);
  const wallBounds = wall.getBoundingClientRect();
  const itemBounds = element.getBoundingClientRect();

  selectItem(element);
  element.classList.add("resizing");
  event.currentTarget.setPointerCapture(event.pointerId);
  resizePointer = {
    pointerId: event.pointerId,
    element,
    item,
    wallBounds,
    left: itemBounds.left - wallBounds.left,
    top: itemBounds.top - wallBounds.top,
  };
}

function resizeSelected(event) {
  if (!resizePointer || resizePointer.pointerId !== event.pointerId) {
    return;
  }

  const dimensions = getDimensions();
  const bounds = resizePointer.wallBounds;
  const maxWidth = bounds.width - resizePointer.left;
  const maxHeight = bounds.height - resizePointer.top;
  const nextWidth = clamp(event.clientX - bounds.left - resizePointer.left, 54, maxWidth);
  const nextHeight = clamp(event.clientY - bounds.top - resizePointer.top, 54, maxHeight);
  resizePointer.item.widthCm = clamp((nextWidth / bounds.width) * dimensions.width, 20, dimensions.width);
  resizePointer.item.heightCm = clamp(
    (nextHeight / bounds.height) * dimensions.height,
    20,
    dimensions.height,
  );
  resizePointer.element.style.width = `${nextWidth}px`;
  resizePointer.element.style.height = `${nextHeight}px`;
  updatePlacedSize(resizePointer.element, resizePointer.item);
  renderDimensionGuides();
  renderCoordinateGuides();
}

function endResize(event) {
  if (!resizePointer || resizePointer.pointerId !== event.pointerId) {
    return;
  }

  resizePointer.element.classList.remove("resizing");
  resizePointer = null;
}

function updatePlacedSize(element, item) {
  const product = getProduct(item.productId);

  element.setAttribute("aria-label", getPlacedLabel(product, item));
}

function moveSelected(event) {
  if (!activePointer || activePointer.pointerId !== event.pointerId) {
    return;
  }

  const bounds = activePointer.wallBounds;
  const maxDeltaX = bounds.width - activePointer.groupBounds.right;
  const minDeltaX = -activePointer.groupBounds.left;
  const maxDeltaY = bounds.height - activePointer.groupBounds.bottom;
  const minDeltaY = -activePointer.groupBounds.top;
  const deltaX = clamp(event.clientX - activePointer.startX, minDeltaX, maxDeltaX);
  const deltaY = clamp(event.clientY - activePointer.startY, minDeltaY, maxDeltaY);

  activePointer.startRects.forEach((startRect) => {
    const left = startRect.left + deltaX;
    const top = startRect.top + deltaY;
    const nextRect = {
      left,
      top,
      width: startRect.width,
      height: startRect.height,
    };

    updateItemPosition(startRect.item, nextRect, bounds);
    startRect.element.style.left = `${left}px`;
    startRect.element.style.top = `${top}px`;
  });
  renderDimensionGuides();
  renderCoordinateGuides();
}

function endMove(event) {
  if (!activePointer || activePointer.pointerId !== event.pointerId) {
    return;
  }

  activePointer.startRects.forEach((startRect) => startRect.element.classList.remove("dragging"));
  activePointer = null;
}

function addDroppedProduct(event) {
  event.preventDefault();
  wall.classList.remove("is-target");

  const productId = event.dataTransfer.getData("text/product");
  const bounds = wall.getBoundingClientRect();
  const xRatio = (event.clientX - bounds.left) / bounds.width - 0.12;
  const yRatio = (event.clientY - bounds.top) / bounds.height - 0.12;

  addProduct(productId, xRatio, yRatio);
}


function preventPlannerImageSave(event) {
  if (
    event.target.closest(".catalog-item, .placed-item, .wall, .catalog, .canvas-panel") ||
    event.target.matches("img, .product-art, .placed-image, .catalog-image, .furniture-image")
  ) {
    event.preventDefault();
  }
}

document.addEventListener("contextmenu", preventPlannerImageSave);
document.addEventListener("dragstart", (event) => {
  if (event.target.matches("img, .placed-image, .catalog-image, .furniture-image")) {
    event.preventDefault();
  }
});

wall.addEventListener("dragover", (event) => {
  event.preventDefault();
  wall.classList.add("is-target");
});
wall.addEventListener("dragleave", () => wall.classList.remove("is-target"));
wall.addEventListener("drop", addDroppedProduct);
wall.addEventListener("pointerdown", (event) => {
  if (!event.target.closest(".placed-item")) {
    clearSelectedItem();
  }
});
wall.addEventListener("pointermove", moveSelected);
wall.addEventListener("pointermove", moveCustomSpanHandle);
wall.addEventListener("pointerup", endMove);
wall.addEventListener("pointerup", endCustomSpanHandle);
wall.addEventListener("pointercancel", endMove);
wall.addEventListener("pointercancel", endCustomSpanHandle);
wall.addEventListener("pointermove", resizeSelected);
wall.addEventListener("pointerup", endResize);
wall.addEventListener("pointercancel", endResize);
window.addEventListener("pointermove", moveCatalogDrag);
window.addEventListener("pointerup", endCatalogDrag);
window.addEventListener("pointercancel", endCatalogDrag);
window.addEventListener("pointermove", moveCustomSpanHandle, { passive: false });
window.addEventListener("pointerup", endCustomSpanHandle);
window.addEventListener("pointercancel", endCustomSpanHandle);

[wallWidthInput, wallHeightInput].forEach((input) => {
  input.addEventListener("input", updateWallSize);
  input.addEventListener("change", () => {
    const dimensions = getDimensions();

    wallWidthInput.value = dimensions.width;
    wallHeightInput.value = dimensions.height;
    updateWallSize();
  });
});
if (roomNameInput) {
  roomNameInput.addEventListener("input", updateRoomName);
}
clearWallButton.addEventListener("click", () => {
  clearConfirmDialog.showModal();
});
confirmClearWallButton.addEventListener("click", () => {
  placedItems = [];
  selectedItemKeys.clear();
  selectedItemKey = null;
  hiddenActionWheelKey = null;
  clearConfirmDialog.close();
  renderPlacedItems();
});
cancelClearWallButton.addEventListener("click", () => clearConfirmDialog.close());
addWallToCartButton.addEventListener("click", addWallProductsToCart);
if (languageToggleButton) {
  languageToggleButton.addEventListener("click", () => {
    currentLanguage = currentLanguage === "zh" ? "ja" : "zh";
    applyLanguage();
  });
}
wallSettingsToggleButton.addEventListener("click", () => {
  wallSettingsCollapsed = !wallSettingsCollapsed;
  wallSettingsCollapsedByUser = wallSettingsCollapsed;
  updateWallSettingsState();
});
if (wallSettingsContent) {
  ["pointerdown", "pointermove", "focusin", "input", "keydown", "wheel"].forEach((eventName) => {
    wallSettingsContent.addEventListener(eventName, refreshWallSettingsAutoHide, { passive: true });
  });
}
if (dimensionToggle) {
  dimensionToggle.addEventListener("click", () => {
    dimensionsVisible = !dimensionsVisible;
    updateDimensionToggle();
  });
}
coordinateToggle.addEventListener("click", () => {
  coordinatesVisible = !coordinatesVisible;
  updateCoordinateToggle();
});
selectionModeToggle?.addEventListener("click", toggleSelectionMode);
groupSelectionButton?.addEventListener("click", groupSelectedItems);
wall.addEventListener("pointerdown", startWallSelection);
wall.addEventListener("pointermove", updateWallSelection);
wall.addEventListener("pointerup", finishWallSelection);
wall.addEventListener("pointercancel", finishWallSelection);
wallWorkbarToggle?.addEventListener("click", toggleWallWorkbar);
document.addEventListener("touchend", handleFullscreenChromeButtonTap, { capture: true, passive: false });
document.addEventListener("click", handleFullscreenChromeButtonTap, { capture: true });
fullscreenSidebarToggle?.addEventListener("click", toggleFullscreenSidebar);
fullscreenToggle.addEventListener("click", togglePlannerFullscreen);
fullscreenBottomExit?.addEventListener("click", togglePlannerFullscreen);
document.addEventListener("fullscreenchange", () => {
  window.setTimeout(renderCoordinateGuides, 80);
  if (!document.fullscreenElement && plannerFullscreen) {
    setPlannerFullscreen(false);
  }
  if (!document.fullscreenElement && arOwnsFullscreen) {
    arOwnsFullscreen = false;
    document.body.classList.remove("ar-fullscreen-active");
  }
});
arButton.addEventListener("click", openArExperience);

function isLandscapeSidebarScrollMode() {
  return window.matchMedia("(max-width: 1180px) and (orientation: landscape)").matches;
}

function installLandscapeSidebarTouchScroll() {
  if (!planner) {
    return;
  }

  const controls = planner.querySelector(".controls");

  if (!controls || controls.dataset.touchScrollInstalled === "true") {
    return;
  }

  controls.dataset.touchScrollInstalled = "true";

  let touchState = null;

  controls.addEventListener("touchstart", (event) => {
    if (!isLandscapeSidebarScrollMode() || event.touches.length !== 1) {
      touchState = null;
      return;
    }

    touchState = {
      y: event.touches[0].clientY,
      moved: false,
      target: event.target,
    };
  }, { passive: true });

  controls.addEventListener("touchmove", (event) => {
    if (!touchState || !isLandscapeSidebarScrollMode() || event.touches.length !== 1) {
      return;
    }

    const currentY = event.touches[0].clientY;
    const deltaY = touchState.y - currentY;

    if (Math.abs(deltaY) < 2) {
      return;
    }

    const maxScroll = controls.scrollHeight - controls.clientHeight;

    if (maxScroll <= 0) {
      return;
    }

    const previousTop = controls.scrollTop;
    const nextTop = clamp(previousTop + deltaY, 0, maxScroll);

    if (nextTop !== previousTop) {
      controls.scrollTop = nextTop;
      touchState.moved = true;
      touchState.y = currentY;
      event.preventDefault();
    }
  }, { passive: false });

  controls.addEventListener("touchend", (event) => {
    if (touchState?.moved) {
      const interactive = touchState.target?.closest?.("button, a, input, select, textarea, label");

      if (interactive) {
        interactive.dataset.iwpScrollSuppressClick = "true";
        window.setTimeout(() => {
          delete interactive.dataset.iwpScrollSuppressClick;
        }, 80);
      }
    }

    touchState = null;
  }, { passive: true });

  controls.addEventListener("click", (event) => {
    const interactive = event.target.closest?.("button, a, input, select, textarea, label");

    if (interactive?.dataset.iwpScrollSuppressClick === "true") {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);
}

captureArButton.addEventListener("click", captureArPhoto);
closeArButton.addEventListener("click", closeArExperience);
arDialog.addEventListener("close", closeArExperience);
arVideo.addEventListener("loadedmetadata", renderArOverlay);
arOverlay.addEventListener("pointerdown", startArCalibration);
arOverlay.addEventListener("pointermove", moveArCalibration);
arOverlay.addEventListener("pointerup", endArCalibration);
arOverlay.addEventListener("pointercancel", endArCalibration);
catalogTabs.forEach((tab) => {
  tab.addEventListener("click", () => selectCatalogTab(tab));
});
if (catalogTabPrevButton) {
  catalogTabPrevButton.addEventListener("click", () => scrollCatalogTabs(-1));
}
if (catalogTabNextButton) {
  catalogTabNextButton.addEventListener("click", () => scrollCatalogTabs(1));
}
if (catalogTabList) {
  catalogTabList.addEventListener("scroll", updateCatalogTabScrollButtons, { passive: true });
}
window.addEventListener("resize", updateCatalogTabScrollButtons, { passive: true });
productDatabaseTabs.forEach((tab) => {
  tab.addEventListener("click", (event) => {
    if (tab.dataset.dragSuppress === "true") {
      event.preventDefault();
      return;
    }

    selectProductDatabaseTab(tab);
  });
  tab.addEventListener("pointerdown", startProductCategoryPointerDrag);
  tab.addEventListener("pointermove", moveProductCategoryPointerDrag);
  tab.addEventListener("pointerup", finishProductCategoryPointerDrag);
  tab.addEventListener("pointercancel", finishProductCategoryPointerDrag);
});
managerLoginButton.addEventListener("click", showManagerLogin);
closeManagerLoginButton.addEventListener("click", () => managerLoginDialog.close());
managerLoginForm.addEventListener("submit", (event) => {
  event.preventDefault();

  const correctAccount =
    managerUsernameInput.value.trim() === managerAccount.username &&
    managerPasswordInput.value === managerAccount.password;

  if (!correctAccount) {
    managerLoginError.hidden = false;
    managerPasswordInput.focus();
    managerPasswordInput.select();
    return;
  }

  managerSignedIn = true;
  saveManagerSession(true);
  updateManagerAccess();
  managerLoginDialog.close();
});
managerLogoutButton.addEventListener("click", () => {
  managerSignedIn = false;
  saveManagerSession(false);
  updateManagerAccess();

  if (productDatabaseDialog.open) {
    productDatabaseDialog.close();
  }

  if (furnitureDatabaseDialog.open) {
    furnitureDatabaseDialog.close();
  }
});
openProductDatabaseButton.addEventListener("click", () => {
  if (!requireManager()) {
    return;
  }

  renderProductDatabaseRows();
  selectProductDatabaseTab(
    productDatabaseTabs.find((tab) => tab.dataset.category === activeProductDatabaseCategory) || productDatabaseTabs[0],
  );
  productDatabaseDialog.showModal();
});
if (openFurnitureDatabaseButton) {
  openFurnitureDatabaseButton.addEventListener("click", () => {
    if (!requireManager()) {
      return;
    }

    renderFurnitureDatabaseRows();
    furnitureDatabaseDialog.showModal();
  });
}
saveProductDatabaseButton.addEventListener("click", saveProductDatabasePage);
addDatabaseProductButton.addEventListener("click", addDatabaseProductRow);
if (addDatabaseFurnitureButton) {
  addDatabaseFurnitureButton.addEventListener("click", addDatabaseFurnitureRow);
}
resetDatabaseProductsButton.addEventListener("click", () => {
  if (!requireManager()) {
    return;
  }

  if (!window.confirm(t("resetProductsConfirm"))) {
    return;
  }

  fixedProducts = defaultDatabaseProducts();
  placedItems = placedItems.filter((item) => getProduct(item.productId));
  refreshProductDatabase();
});
if (resetDatabaseFurnitureButton) {
  resetDatabaseFurnitureButton.addEventListener("click", () => {
    if (!requireManager()) {
      return;
    }

    products = defaultDatabaseFurniture();
    placedItems = placedItems.filter((item) => getProduct(item.productId));
    refreshFurnitureDatabase();
  });
}

function updateMobileViewportHeight() {
  const viewportHeight = window.visualViewport?.height || window.innerHeight;

  if (Number.isFinite(viewportHeight) && viewportHeight > 0) {
    document.documentElement.style.setProperty("--iwp-vh", `${viewportHeight}px`);
  }
}

function refreshMobileFullscreenLayout() {
  updateMobileViewportHeight();
  if (plannerFullscreen) {
    // iOS/Android may change visualViewport after rotation and fullscreen UI changes.
    window.requestAnimationFrame(() => {
      updateWallSize();
      renderPlacedItems();
    });
  }
}

window.addEventListener("resize", () => {
  refreshMobileFullscreenLayout();
  updateWallHintText();
  updateWallSize();
  renderArOverlay();
});

window.visualViewport?.addEventListener("resize", refreshMobileFullscreenLayout);
window.visualViewport?.addEventListener("scroll", refreshMobileFullscreenLayout);
window.addEventListener("orientationchange", () => window.setTimeout(refreshMobileFullscreenLayout, 180));
updateMobileViewportHeight();

installLandscapeSidebarTouchScroll();
updateManagerAccess();
applyLanguage();
window.requestAnimationFrame(updateCatalogTabScrollButtons);
requestAnimationFrame(updateWallSize);

function resetFullscreenSidebarScrollForOrientation() {
  const controls = document.querySelector(".planner.is-fullscreen .controls");
  const catalog = document.querySelector(".planner.is-fullscreen .catalog");
  const activePanel = document.querySelector(".planner.is-fullscreen .catalog-panel:not([hidden])");

  [controls, catalog, activePanel].forEach((node) => {
    if (node) {
      node.scrollTop = 0;
    }
  });
}

window.addEventListener("orientationchange", () => {
  window.setTimeout(resetFullscreenSidebarScrollForOrientation, 260);
});

window.addEventListener("resize", () => {
  window.setTimeout(resetFullscreenSidebarScrollForOrientation, 120);
});


function cleanupMobileLandscapeCatalogFooter() {
  const planner = document.querySelector(".planner");
  if (!planner) {
    return;
  }

  const isLandscape = window.matchMedia("(max-width: 1180px) and (orientation: landscape)").matches;
  const catalog = planner.querySelector(".catalog");

  if (!catalog) {
    return;
  }

  catalog.querySelectorAll("*").forEach((node) => {
    if (node.childNodes && [...node.childNodes].some((child) => child.nodeType === Node.TEXT_NODE && child.textContent.includes("管理資料庫"))) {
      node.classList.add("admin-library-note");
      if (isLandscape) {
        node.style.display = "none";
      } else {
        node.style.display = "";
      }
    }
  });

  if (isLandscape) {
    planner.classList.add("is-mobile-landscape");
  } else {
    planner.classList.remove("is-mobile-landscape");
  }
}

window.addEventListener("orientationchange", () => {
  window.setTimeout(cleanupMobileLandscapeCatalogFooter, 120);
  window.setTimeout(cleanupMobileLandscapeCatalogFooter, 420);
});

window.addEventListener("resize", () => {
  window.setTimeout(cleanupMobileLandscapeCatalogFooter, 80);
});

document.addEventListener("DOMContentLoaded", cleanupMobileLandscapeCatalogFooter);
cleanupMobileLandscapeCatalogFooter();









function applyLandscapeNoBottomBlankMode() {
  const shouldApply = window.innerWidth > window.innerHeight && (
    window.matchMedia("(pointer: coarse)").matches ||
    navigator.maxTouchPoints > 0 ||
    window.innerHeight <= 560
  );

  document.documentElement.classList.toggle("iwp-landscape-no-bottom-blank", shouldApply);

  document.querySelectorAll(".planner").forEach((planner) => {
    planner.classList.toggle("iwp-landscape-no-bottom-blank", shouldApply);

    const nodesToHide = planner.querySelectorAll(".database-gate, .left-manager, .database-buttons, .product-database-only, .admin-library-note");
    nodesToHide.forEach((node) => {
      if (shouldApply) {
        node.hidden = true;
        node.style.setProperty("display", "none", "important");
        node.style.setProperty("height", "0px", "important");
        node.style.setProperty("min-height", "0px", "important");
        node.style.setProperty("max-height", "0px", "important");
        node.style.setProperty("padding", "0px", "important");
        node.style.setProperty("margin", "0px", "important");
        node.style.setProperty("overflow", "hidden", "important");
      } else {
        node.hidden = false;
        node.style.removeProperty("display");
        node.style.removeProperty("height");
        node.style.removeProperty("min-height");
        node.style.removeProperty("max-height");
        node.style.removeProperty("padding");
        node.style.removeProperty("margin");
        node.style.removeProperty("overflow");
      }
    });

    const resetNodes = planner.querySelectorAll(".controls, .catalog, .catalog-panel, .catalog-items, .category-product-items, .product-items");
    resetNodes.forEach((node) => {
      if (shouldApply) {
        node.style.setProperty("min-height", "0px", "important");
        node.style.setProperty("padding-bottom", "0px", "important");
        node.style.setProperty("margin-bottom", "0px", "important");
      } else {
        node.style.removeProperty("min-height");
        node.style.removeProperty("padding-bottom");
        node.style.removeProperty("margin-bottom");
      }
    });
  });
}

["DOMContentLoaded", "orientationchange", "resize"].forEach((eventName) => {
  window.addEventListener(eventName, () => {
    window.setTimeout(applyLandscapeNoBottomBlankMode, 40);
    window.setTimeout(applyLandscapeNoBottomBlankMode, 250);
  });
});

applyLandscapeNoBottomBlankMode();



function equalizeWallWorkbarButtons() {
  const workbar = document.querySelector("#wallWorkbar .wall-workbar-actions, .wall-workbar-actions");

  if (!workbar) {
    return;
  }

  const ids = ["fullscreenToggle", "selectionModeToggle", "groupSelectionToggle", "coordinateToggle", "arButton", "clearWall", "addWallToCart"];
  const buttons = ids.map((id) => document.getElementById(id)).filter(Boolean);

  if (buttons.length < 6) {
    return;
  }

  const isLandscape = window.innerWidth > window.innerHeight;
  const isTouch = window.matchMedia("(pointer: coarse)").matches || navigator.maxTouchPoints > 0;
  const isMobileLike = isTouch || window.innerWidth <= 900 || window.innerHeight <= 560;
  const targetHeight = isMobileLike && isLandscape ? 48 : (window.innerWidth <= 900 ? 58 : 46);

  workbar.style.setProperty("display", "grid", "important");
  workbar.style.setProperty("grid-template-columns", "repeat(2, minmax(0, 1fr))", "important");
  workbar.style.setProperty("grid-template-rows", `repeat(4, ${targetHeight}px)`, "important");
  workbar.style.setProperty("grid-auto-rows", `${targetHeight}px`, "important");
  workbar.style.setProperty("gap", isLandscape ? "8px" : "10px", "important");
  workbar.style.setProperty("align-items", "stretch", "important");
  workbar.style.setProperty("justify-items", "stretch", "important");

  buttons.forEach((button, index) => {
    button.style.setProperty("width", "100%", "important");
    button.style.setProperty("min-width", "0", "important");
    button.style.setProperty("max-width", "100%", "important");
    button.style.setProperty("height", `${targetHeight}px`, "important");
    button.style.setProperty("min-height", `${targetHeight}px`, "important");
    button.style.setProperty("max-height", `${targetHeight}px`, "important");
    button.style.setProperty("padding", "0 8px", "important");
    button.style.setProperty("margin", "0", "important");
    button.style.setProperty("box-sizing", "border-box", "important");
    button.style.setProperty("display", "flex", "important");
    button.style.setProperty("align-items", "center", "important");
    button.style.setProperty("justify-content", "center", "important");
    button.style.setProperty("align-self", "stretch", "important");
    button.style.setProperty("justify-self", "stretch", "important");
    button.style.setProperty("line-height", "1.15", "important");
    button.style.setProperty("font-size", isLandscape ? "0.92rem" : "", "important");
    button.style.setProperty("overflow", "hidden", "important");

    const row = Math.floor(index / 2) + 1;
    const col = (index % 2) + 1;
    const gridRow = button.id === "addWallToCart" ? 4 : row;
    const gridColumn = button.id === "addWallToCart" ? 2 : col;
    button.style.setProperty("grid-row", String(gridRow), "important");
    button.style.setProperty("grid-column", String(gridColumn), "important");
  });

  const total = document.getElementById("wallTotalPrice");
  if (total) {
    total.style.setProperty("grid-column", "1", "important");
    total.style.setProperty("grid-row", "4", "important");
    total.style.setProperty("height", `${targetHeight}px`, "important");
    total.style.setProperty("min-height", `${targetHeight}px`, "important");
    total.style.setProperty("display", "flex", "important");
    total.style.setProperty("align-items", "center", "important");
    total.style.setProperty("justify-content", "center", "important");
    total.style.setProperty("justify-self", "stretch", "important");
    total.style.setProperty("text-align", "center", "important");
    total.style.setProperty("font-size", "0.86rem", "important");
    total.style.setProperty("overflow", "hidden", "important");
    total.style.setProperty("text-overflow", "ellipsis", "important");
    total.style.setProperty("white-space", "nowrap", "important");
  }
}

["DOMContentLoaded", "resize", "orientationchange"].forEach((eventName) => {
  window.addEventListener(eventName, () => {
    window.setTimeout(equalizeWallWorkbarButtons, 30);
    window.setTimeout(equalizeWallWorkbarButtons, 180);
    window.setTimeout(equalizeWallWorkbarButtons, 420);
  });
});

document.addEventListener("click", () => {
  window.setTimeout(equalizeWallWorkbarButtons, 30);
});

equalizeWallWorkbarButtons();



function applyMobileDatabaseHideOnly() {
  const isMobileLike = window.matchMedia("(max-width: 900px)").matches || window.matchMedia("(pointer: coarse)").matches || navigator.maxTouchPoints > 0;

  document.querySelectorAll(".planner").forEach((planner) => {
    planner.classList.toggle("iwp-mobile-no-database", isMobileLike);

    planner.querySelectorAll(".database-gate, .left-manager, .database-buttons, .product-database-only, .admin-library-note, #managerLoginButton, #managerLogoutButton").forEach((node) => {
      if (isMobileLike) {
        node.hidden = true;
        node.style.setProperty("display", "none", "important");
        node.style.setProperty("visibility", "hidden", "important");
        node.style.setProperty("height", "0px", "important");
        node.style.setProperty("min-height", "0px", "important");
        node.style.setProperty("max-height", "0px", "important");
        node.style.setProperty("padding", "0px", "important");
        node.style.setProperty("margin", "0px", "important");
        node.style.setProperty("overflow", "hidden", "important");
      } else {
        node.hidden = false;
        node.style.removeProperty("display");
        node.style.removeProperty("visibility");
        node.style.removeProperty("height");
        node.style.removeProperty("min-height");
        node.style.removeProperty("max-height");
        node.style.removeProperty("padding");
        node.style.removeProperty("margin");
        node.style.removeProperty("overflow");
      }
    });
  });
}

["DOMContentLoaded", "resize", "orientationchange"].forEach((eventName) => {
  window.addEventListener(eventName, () => {
    window.setTimeout(applyMobileDatabaseHideOnly, 30);
    window.setTimeout(applyMobileDatabaseHideOnly, 220);
  });
});

applyMobileDatabaseHideOnly();



function normalizePortraitProductCardText() {
  const isPortraitMobile = window.matchMedia("(max-width: 900px) and (orientation: portrait)").matches;

  if (!isPortraitMobile) {
    return;
  }

  document.querySelectorAll(".catalog-item small").forEach((small) => {
    small.childNodes.forEach((node) => {
      if (node.nodeType !== Node.TEXT_NODE) {
        return;
      }

      node.textContent = node.textContent.replace(/寬\s*([0-9.]+)\s*x\s*高\s*([0-9.]+)\s*公\s*分/g, "寬$1×高$2公分");
    });
  });
}

["DOMContentLoaded", "resize", "orientationchange"].forEach((eventName) => {
  window.addEventListener(eventName, () => {
    window.setTimeout(normalizePortraitProductCardText, 40);
    window.setTimeout(normalizePortraitProductCardText, 240);
  });
});

document.addEventListener("click", () => {
  window.setTimeout(normalizePortraitProductCardText, 60);
});

normalizePortraitProductCardText();

